/**
 * Product catalog for HGW Industry.
 * Tree:
 *   architettonici
 *     alluminio → porte-finestre | scorrevole | facciate
 *     pvc       → porte-finestre | scorrevole
 *   pergole
 *     bioclimatiche
 *     tende-schermature
 *     coperture-vetrate
 *
 * Each product has a unique slug used for /prodotti/p/:slug
 * Images are placeholders — replace with real product photography.
 */

const IMG = {
  arch: "https://images.unsplash.com/photo-1758998256408-ab2c9fbec19b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxhbHVtaW5pdW0lMjB3aW5kb3clMjBmcmFtZSUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg0MTM1NjQ2fDA&ixlib=rb-4.1.0&q=85",
  pergolas: "https://images.unsplash.com/photo-1762715576863-a10e7c38b5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBwZXJnb2xhJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDEzNTY1MXww&ixlib=rb-4.1.0&q=85",
  workshop: "https://images.unsplash.com/photo-1608126841830-53832c4b326f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxhbHVtaW5pdW0lMjB3aW5kb3clMjBmcmFtZSUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg0MTM1NjQ2fDA&ixlib=rb-4.1.0&q=85",
  frame: "https://images.unsplash.com/photo-1758998256408-ab2c9fbec19b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxhbHVtaW5pdW0lMjB3aW5kb3clMjBmcmFtZSUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg0MTM1NjQ2fDA&ixlib=rb-4.1.0&q=85",
  pergolaDetail: "https://images.unsplash.com/photo-1633354747567-e0682586f082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwZXJnb2xhJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDEzNTY1MXww&ixlib=rb-4.1.0&q=85",
  slidingSystem: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1600&q=85&auto=format",
  facade: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=85&auto=format",
  door: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85&auto=format",
  awning: "https://images.unsplash.com/photo-1762715576863-a10e7c38b5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBwZXJnb2xhJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDEzNTY1MXww&ixlib=rb-4.1.0&q=85",
  glassRoof: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=1600&q=85&auto=format",
  bioclimatic: "https://images.unsplash.com/photo-1633354747567-e0682586f082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwZXJnb2xhJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDEzNTY1MXww&ixlib=rb-4.1.0&q=85",
  livingRoom: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85&auto=format",
};

/** MACRO categories */
export const MACROS = {
  architettonici: {
    slug: "architettonici",
    it: { title: "Sistemi Architettonici", sub: "Infissi in alluminio e PVC con profili ASAŞ — distribuzione ufficiale per l'Italia." },
    en: { title: "Architectural Systems", sub: "Aluminium and PVC systems with ASAŞ profiles — official Italian distribution." },
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/kwj0cd92_sistemi%20architettonici%20sfondo%20sito%20web.jpeg",
    children: ["alluminio", "pvc"],
  },
  pergole: {
    slug: "pergole",
    it: { title: "Pergole & Coperture", sub: "Bioclimatiche, vetrate e schermature automatiche firmate Winperax." },
    en: { title: "Pergolas & Covers", sub: "Bioclimatic, glass and automatic shading signed by Winperax." },
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/a279ysbq_pergola%20sfondo%20sito%20web.jpeg",
    children: ["pergole-bioclimatiche", "pergole-tende-schermature", "pergole-glass-roof", "pergole-chiusure-vetrate"],
  },
};

/** SUB categories (leaf categories that list products). */
export const CATEGORIES = {
  // ARCHITECTURAL — Aluminium
  "alluminio": {
    slug: "alluminio",
    parent: "architettonici",
    it: { title: "Alluminio", sub: "Serramenti e sistemi in alluminio con profili ASAŞ, distribuiti ufficialmente da HGW Industry." },
    en: { title: "Aluminium", sub: "Aluminium joinery and systems with ASAŞ profiles, officially distributed by HGW Industry." },
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/kwj0cd92_sistemi%20architettonici%20sfondo%20sito%20web.jpeg",
    isBranch: true,
    children: [
      "alluminio-porte-finestre",
      "alluminio-scorrevole",
      "alluminio-facciate",
      "alluminio-complementari",
    ],
  },
  "alluminio-porte-finestre": {
    slug: "alluminio-porte-finestre",
    parent: "alluminio",
    macroSlug: "architettonici",
    it: { title: "Finestre & Portefinestre", sub: "Serramenti a battente, anta-ribalta e a scomparsa — dal minimal look al Passive House." },
    en: { title: "Windows & French Doors", sub: "Casement, tilt-turn and concealed-vent systems — from slim look to Passive House." },
    image: "/catalog2026/asw34.webp",
  },
  "alluminio-scorrevole": {
    slug: "alluminio-scorrevole",
    parent: "alluminio",
    macroSlug: "architettonici",
    it: { title: "Scorrevoli e Grandi Aperture", sub: "Alzanti scorrevoli, scorrevoli minimal e ad alte prestazioni, porte a libro: per aprire le pareti sul paesaggio." },
    en: { title: "Sliding & Wide Openings", sub: "Lift-and-slide, minimal and high-performance sliders, folding doors: open your walls to the view." },
    image: "/catalog2026/alu-resf32.webp",
  },

  "alluminio-facciate": {
    slug: "alluminio-facciate",
    parent: "alluminio",
    macroSlug: "architettonici",
    it: { title: "Facciate & Vetrate", sub: "Facciate continue, unitizzate e window wall per involucri architettonici." },
    en: { title: "Facades & Curtain Walls", sub: "Curtain walls, unitised and window-wall systems for architectural envelopes." },
    image: "/catalog2026/ref60.webp",
  },

  "alluminio-complementari": {
    slug: "alluminio-complementari",
    parent: "alluminio",
    macroSlug: "architettonici",
    it: { title: "Sistemi Complementari", sub: "Rivestimenti di facciata, parapetti e vetrate per balconi, pareti divisorie per uffici." },
    en: { title: "Complementary Systems", sub: "Facade cladding, balustrades and balcony glazing, office partitions." },
    image: "/catalog2026/alu-rdm50.webp",
    isBranch: true,
  },
  "alluminio-rivestimenti": {
    slug: "alluminio-rivestimenti",
    parent: "alluminio-complementari",
    macroSlug: "architettonici",
    it: { title: "Rivestimenti di Facciata", sub: "Terracotta, pannelli compositi, doghe, lamelle e lastre in alluminio per facciate ventilate." },
    en: { title: "Facade Cladding", sub: "Terracotta, composite panels, planks, fins and aluminium sheets for ventilated facades." },
    image: "/catalog2026/alu-rdp.webp",
  },
  "alluminio-parapetti": {
    slug: "alluminio-parapetti",
    parent: "alluminio-complementari",
    macroSlug: "architettonici",
    it: { title: "Parapetti e Vetrate per Balconi", sub: "Parapetti in vetro, balconi alla francese e vetrate a pacchetto o scorrevoli per chiudere balconi e verande." },
    en: { title: "Balustrades & Balcony Glazing", sub: "Glass balustrades, Juliet balconies and folding or sliding glazing to enclose balconies and verandas." },
    image: "/catalog2026/alu-rb90.webp",
  },
  "alluminio-pareti-ufficio": {
    slug: "alluminio-pareti-ufficio",
    parent: "alluminio-complementari",
    macroSlug: "architettonici",
    it: { title: "Pareti Divisorie per Uffici", sub: "Pareti in vetro singolo e doppio e porte per interni, per uffici luminosi e silenziosi." },
    en: { title: "Office Partitions", sub: "Single and double-glazed partitions and interior doors for bright, quiet offices." },
    image: "/catalog2026/alu-ro108.webp",
  },

  // ARCHITECTURAL — PVC
  "pvc": {
    slug: "pvc",
    parent: "architettonici",
    it: { title: "PVC", sub: "Sistemi in PVC con profili ASAŞ per porte, finestre e scorrevoli — comfort e isolamento." },
    en: { title: "PVC", sub: "PVC systems with ASAŞ profiles for doors, windows and sliders — comfort and insulation." },
    image: "/catalog2026/pvc-tile.jpeg",
    isBranch: true,
    children: ["pvc-porte-finestre", "pvc-scorrevole", "pvc-oscuranti"],
  },
  "pvc-porte-finestre": {
    slug: "pvc-porte-finestre",
    parent: "pvc",
    macroSlug: "architettonici",
    it: { title: "Porte e Finestre", sub: "Sistemi a battente in PVC — dalla soluzione essenziale al Passive House." },
    en: { title: "Doors & Windows", sub: "Hinged PVC systems — from essential solutions to Passive House." },
    image: "/catalog2026/inova-76-md.webp",
  },
  "pvc-scorrevole": {
    slug: "pvc-scorrevole",
    parent: "pvc",
    macroSlug: "architettonici",
    it: { title: "Scorrevoli e Alzanti", sub: "Scorrevoli e alzanti scorrevoli in PVC per grandi luci." },
    en: { title: "Sliding & Lift-Slide", sub: "PVC sliding and lift-and-slide systems for large openings." },
    image: "/catalog2026/hebe-schiebe.webp",
  },
  "pvc-oscuranti": {
    slug: "pvc-oscuranti",
    parent: "pvc",
    macroSlug: "architettonici",
    it: { title: "Complementi e Finiture", sub: "Cassonetti monoblocco, oscuranti a incasso e profili davanzale che completano il serramento." },
    en: { title: "Complements & Finishes", sub: "Monobloc shutter boxes, recessed shading and sill profiles that complete the window." },
    image: "/catalog2026/inovabox.webp",
  },

  // PERGOLE
  "pergole-bioclimatiche": {
    slug: "pergole-bioclimatiche",
    parent: "pergole",
    macroSlug: "pergole",
    it: { title: "Sistemi Bioclimatici", sub: "Pergole a lame orientabili — luce, ombra e ventilazione automatizzate." },
    en: { title: "Bioclimatic Systems", sub: "Louvered pergolas — light, shade and ventilation, automated." },
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/y3kohwd3_1.webp",
  },
  "pergole-tende-schermature": {
    slug: "pergole-tende-schermature",
    parent: "pergole",
    macroSlug: "pergole",
    it: { title: "Tende da Sole & Schermature", sub: "Tende a cassonetto, cabrio e schermature laterali motorizzate." },
    en: { title: "Awning & Shading", sub: "Cassette awnings, cabrio covers and motorised side screens." },
    image: "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/4.jpg",
  },
  "pergole-chiusure-vetrate": {
    slug: "pergole-chiusure-vetrate",
    parent: "pergole",
    macroSlug: "pergole",
    it: { title: "Chiusure Vetrate", sub: "Ghigliottine motorizzate, scorrevoli, a libro e paraventi in vetro per terrazze, verande e dehors." },
    en: { title: "Glass Enclosures", sub: "Motorised guillotines, sliding, folding and glass windbreaks for terraces, verandas and outdoor seating." },
    image: "/winperax/wp-chiusure-cover.webp",
  },
  "pergole-glass-roof": {
    slug: "pergole-glass-roof",
    parent: "pergole",
    macroSlug: "pergole",
    it: { title: "Coperture in Vetro", sub: "Tetti in vetro fissi e motorizzati per verande, terrazze e giardini d'inverno." },
    en: { title: "Glass Roof Systems", sub: "Fixed and motorised glass roofs for verandas, terraces and winter gardens." },
    image: "https://winperax.com/images/urunler/otomatik/1.jpg",
  },
};

/** PRODUCTS — flat map by slug. */
export const PRODUCTS = {
  // ALLUMINIO — Porte e Finestre (Catalogo ASAŞ 2026)
  "asas-asw34": {
    slug: "asas-asw34",
    category: "alluminio-porte-finestre",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/ASW34_Teknik_ozellikler-559-559.pdf",
    quickSpecs: { frame: 82, glass: 42, thermal: 34 },
    it: {
      name: "ASW34",
      tagline: "Sistema slim look. Minimalismo estetico ed elevato isolamento termico.",
      description: "ASW34 è il serramento a taglio termico dall'aspetto minimale: le parti in alluminio a vista sono ridotte al minimo, così il vetro diventa protagonista e gli ambienti guadagnano luce. L'estetica sottile richiama le finestre in acciaio tanto amate dagli architetti, mentre le prestazioni di isolamento assicurano il comfort di un sistema moderno. Disponibile con apertura verso l'interno o verso l'esterno, è perfetto anche nelle ristrutturazioni dove si vuole mantenere un fascino industriale.",
      features: [
        "Uw 1,74 W/m²K",
        "Profondità telaio 82/105 mm — anta 92 mm",
        "Spessore parete profilo 2 mm",
        "Vetro fino a 42 mm",
        "Barra di taglio termico 34 mm",
        "Apertura verso interno, esterno, vasistas, anta-ribalta",
        "Aspetto \"steel look\" — sezioni in vista minimali",
        "Verniciatura elettrostatica o anodizzazione — qualsiasi RAL",
      ],
      applications: ["Ristrutturazioni di pregio", "Loft e case moderne", "Studi di architettura", "Uffici design"],
    },
    en: {
      name: "ASW34",
      tagline: "Slim-look system. Aesthetic minimalism and high thermal insulation.",
      description: "ASW34 is a thermally broken window with a minimal appearance: visible aluminium sections are reduced to a minimum, allowing the glazing to take centre stage and interiors to gain light. The slender aesthetic recalls the steel windows favoured by architects, whilst insulation performance ensures the comfort of a modern system. Available with inward or outward opening, it is also ideal for refurbishments where an industrial character is to be retained.",
      features: [
        "Uw 1.74 W/m²K",
        "Frame depth 82/105 mm — vent 92 mm",
        "Profile wall thickness 2 mm",
        "Glazing up to 42 mm",
        "Thermal insulation bar 34 mm",
        "Inward, outward, bottom-hung, tilt & turn",
        "Steel-look appearance — minimal visible sections",
        "Electrostatic paint or anodising — any RAL",
      ],
      applications: ["Premium refurbishments", "Modern homes and lofts", "Architecture studios", "Design offices"],
    },
    image: "/catalog2026/asw34.webp",
    gallery: [
      "/catalog2026/alu-asw34-amb.webp",
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/1241ifha_ASW34%20MINIMAL.png",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,74 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.74 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 42 mm", "note": "Massima superficie vetrata grazie ai profili minimali"}, "en": {"label": "Glazing", "value": "up to 42 mm", "note": "Maximum glass surface thanks to minimal profiles"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Verso interno, esterno, vasistas, anta-ribalta"}, "en": {"label": "Opening types", "value": "Inward, outward, bottom-hung, tilt & turn"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "82/105 mm", "note": "Anta 92 mm — estetica \"steel look\" minimale"}, "en": {"label": "Frame depth", "value": "82/105 mm", "note": "Vent 92 mm — minimal steel-look aesthetics"}}],
  },

  "asas-rwt75f": {
    slug: "asas-rwt75f",
    category: "alluminio-porte-finestre",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/14_RWT75F-710.pdf",
    quickSpecs: { frame: 75, glass: 58, thermal: 34 },
    it: {
      name: "RWT75F",
      tagline: "La piattaforma da 75 mm. Isolamento elevato, grande solidità.",
      description: "RWT75F è il sistema in alluminio a taglio termico che unisce isolamento e robustezza in modo equilibrato: la speciale barriera termica \"flag\" da 34 mm raggiunge da sola valori di isolamento che nei sistemi tradizionali richiederebbero materiali aggiuntivi. La gamma copre finestre a una o due ante e porte apribili verso l'interno o l'esterno, e l'anta accetta la stessa ferramenta dei serramenti in PVC — un vantaggio pratico per manutenzione e ricambi. È la scelta equilibrata per case moderne ad alta efficienza.",
      features: [
        "Uw 1,64 W/m²K — fino a 0,87 W/m²K con vetro Ug 0,5",
        "Profondità telaio 75 mm — anta 85 mm",
        "Spessore parete profilo 1,8 mm",
        "Vetro fino a 48–58 mm",
        "Barra taglio termico flag 34 mm — no isolanti aggiuntivi",
        "Apertura interno, vasistas, anta-ribalta",
        "Compatibile con accessori PVC",
        "Verniciatura elettrostatica o anodizzazione — qualsiasi RAL",
      ],
      applications: ["Residenziale premium", "Case in classe A", "Retrofit", "Progetti architettonici"],
    },
    en: {
      name: "RWT75F",
      tagline: "75 mm platform. High insulation, high strength.",
      description: "RWT75F is the thermal-break aluminium system that balances insulation and strength: its special 34 mm flag thermal barrier alone achieves insulation values that traditional systems require additional materials to reach. The range covers single- and double-sash windows and inward- or outward-opening doors, and the sash accepts the same hardware as PVC windows — a practical advantage for maintenance and spare parts. The balanced choice for modern, high-efficiency homes.",
      features: [
        "Uw 1.64 W/m²K — down to 0.87 W/m²K with Ug 0.5 glass",
        "Frame depth 75 mm — vent 85 mm",
        "Profile wall thickness 1.8 mm",
        "Glazing 48–58 mm",
        "34 mm flag thermal barrier — no extra insulation",
        "Inward, bottom-hung, tilt & turn",
        "Compatible with PVC accessories",
        "Electrostatic paint or anodising — any RAL",
      ],
      applications: ["Premium residential", "Class-A homes", "Retrofit", "Architectural projects"],
    },
    image: "/catalog2026/rwt75f.webp",
    gallery: [
      "/catalog2026/alu-rwt75f-amb.webp",
      "/catalog2026/rwt75f-profilo.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw fino a 0,87 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw down to 0.87 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 48–58 mm"}, "en": {"label": "Glazing", "value": "up to 48–58 mm"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Battente interno, vasistas, anta-ribalta"}, "en": {"label": "Opening types", "value": "Inward casement, bottom-hung, tilt & turn"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "75 mm"}, "en": {"label": "Frame depth", "value": "75 mm"}}],
  },
  "asas-rwt95": {
    slug: "asas-rwt95",
    category: "alluminio-porte-finestre",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/RWT95_KATALOG-599.pdf",
    quickSpecs: { frame: 95, glass: 85, thermal: 54, passive: true },
    it: {
      name: "RWT95",
      tagline: "Certificato Passive House. La massima efficienza termica in alluminio.",
      description: "RWT95 è il sistema in alluminio pensato per chi vuole il massimo dell'efficienza energetica: la barriera termica da 54 mm e i materiali isolanti dedicati gli hanno permesso di ottenere la certificazione del Passive House Institute, il riferimento mondiale per l'edilizia a basso consumo. Accoglie vetri fino a 85 mm — anche tripli o quadrupli — e mantiene ottime prestazioni statiche pur con ante di grandi dimensioni. La soluzione ideale per case passive, edifici NZEB e riqualificazioni energetiche spinte.",
      features: [
        "Uw 1,5 W/m²K — 0,8 W/m²K in configurazione Passive House",
        "Profondità telaio 95 mm — anta 105 mm",
        "Spessore parete profilo 2 mm",
        "Vetro fino a 85 mm (triplo/quadruplo)",
        "Barra taglio termico 54 mm",
        "Certificato Passive House Institute",
        "Aperture: interno, esterno, vasistas, anta-ribalta",
        "Accessoristica condivisa con altri sistemi ASAŞ",
      ],
      applications: ["Case passive", "NZEB", "Retrofit energetici", "Residenziale classe A+"],
    },
    en: {
      name: "RWT95",
      tagline: "Passive House certified. Maximum thermal efficiency in aluminium.",
      description: "RWT95 is the aluminium system designed for those who require maximum energy efficiency: the 54 mm thermal break and dedicated insulating materials have enabled it to achieve Passive House Institute certification, the global benchmark for low-energy construction. It accommodates glazing up to 85 mm thick — including triple or quadruple glazing — and maintains excellent static performance even with large sashes. The ideal solution for passive houses, NZEB buildings and deep energy retrofits.",
      features: [
        "Uw 1.5 W/m²K — 0.8 W/m²K in Passive House configuration",
        "Frame depth 95 mm — vent 105 mm",
        "Profile wall thickness 2 mm",
        "Glazing up to 85 mm (triple/quad)",
        "Thermal insulation bar 54 mm",
        "Passive House Institute certified",
        "Openings: inward, outward, bottom-hung, tilt & turn",
        "Fittings shared with other ASAŞ systems",
      ],
      applications: ["Passive houses", "NZEB", "Energy retrofit", "Class A+ residential"],
    },
    image: "/catalog2026/rwt95.webp",
    gallery: [
      "/catalog2026/alu-rwt95-amb.webp",
      "/catalog2026/rwt95-profilo.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw fino a 0,8 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni. Configurazione Passive House"}, "en": {"label": "Thermal insulation", "value": "Uw up to 0.8 W/m²K", "note": "System value: varies with glazing and size. Passive House configuration"}}, {"icon": "thermal", "it": {"label": "Certificazione Passive House", "value": "Certificato Passive House Institute", "note": "Idoneo per edifici NZEB e case passive"}, "en": {"label": "Passive House certification", "value": "Passive House Institute certified", "note": "Suitable for NZEB buildings and passive houses"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 85 mm", "note": "Compatibile con vetri tripli e quadrupli"}, "en": {"label": "Glazing", "value": "up to 85 mm", "note": "Compatible with triple and quadruple glazing"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "95 mm", "note": "Barriera termica da 54 mm"}, "en": {"label": "Frame depth", "value": "95 mm", "note": "54 mm thermal insulation bar"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Interno, esterno, vasistas, anta-ribalta"}, "en": {"label": "Opening types", "value": "Inward, outward, bottom-hung, tilt & turn"}}],
  },
  "asas-rwt67": {
    slug: "asas-rwt67",
    category: "alluminio-porte-finestre",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/11_RWT67_KATALOG-488.pdf",
    quickSpecs: { frame: 67, glass: 24, thermal: 24 },
    it: {
      name: "RWT67",
      tagline: "Anta a scomparsa. Estetica pulita anche a finestra aperta.",
      description: "RWT67 ha una particolarità che si nota subito… non notandola: l'anta è nascosta dietro il telaio, quindi dall'esterno la finestra aperta e quella chiusa appaiono identiche. Il risultato è una facciata sempre ordinata e uniforme, molto apprezzata in condomini, uffici e progetti dove l'estetica d'insieme conta. Il montante centrale rinforzato garantisce resistenza anche alle forti pressioni del vento. Sistema a taglio termico con aperture a battente, anta-ribalta e anta a scomparsa.",
      features: [
        "Uw 1,94 W/m²K — isolamento acustico 35,5 dB",
        "Profondità telaio 67,1 mm — anta 72,1 mm",
        "Spessore parete 1,6 / 1,7 / 2 mm",
        "Vetro fino a 24 mm",
        "Barra taglio termico 24 mm",
        "Anta nascosta dall'esterno — estetica pulita",
        "Montante centrale rinforzato — resistente al vento",
        "Aperture: battente, anta-ribalta, anta a scomparsa",
      ],
      applications: ["Facciate residenziali", "Uffici direzionali", "Retail architettonico", "Facciate uniformi"],
    },
    en: {
      name: "RWT67",
      tagline: "Concealed sash. Clean aesthetics even when open.",
      description: "RWT67 has a distinctive feature you notice immediately… by not noticing it: the sash is hidden behind the frame, so from the outside the window looks identical whether open or closed. The result is a façade that remains orderly and uniform at all times, highly valued in apartment buildings, offices and projects where overall aesthetics matter. The reinforced central mullion provides resistance even to strong wind loads. Thermal-break system with side-hung, tilt & turn and concealed-sash openings.",
      features: [
        "Uw 1.94 W/m²K — acoustic 35.5 dB",
        "Frame depth 67.1 mm — vent 72.1 mm",
        "Wall thickness 1.6 / 1.7 / 2 mm",
        "Glazing up to 24 mm",
        "Thermal barrier 24 mm",
        "Sash hidden from outside — clean look",
        "Reinforced middle mullion — wind resistant",
        "Openings: casement, tilt & turn, concealed vent",
      ],
      applications: ["Residential facades", "HQ offices", "Architectural retail", "Uniform facades"],
    },
    image: "/catalog2026/rwt67.webp",
    gallery: [
      "/catalog2026/alu-rwt67-amb.webp",
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/fzwokr4k_Anta%20a%20scomparsa.png",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,94 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.94 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "fino a 35,5 dB", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "up to 35.5 dB", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 24 mm"}, "en": {"label": "Glazing", "value": "up to 24 mm"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Battente, anta-ribalta, anta a scomparsa", "note": "Anta nascosta dall'esterno per estetica uniforme"}, "en": {"label": "Opening types", "value": "Casement, tilt & turn, concealed vent", "note": "Sash hidden from outside for clean aesthetics"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "67,1 mm"}, "en": {"label": "Frame depth", "value": "67.1 mm"}}],
  },
  "asas-refd77": {
    slug: "asas-refd77",
    category: "alluminio-scorrevole",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/REFD77_Flyer-468.pdf",
    quickSpecs: { frame: 77, folding: 7 },
    it: {
      name: "REFD77",
      tagline: "Porta a libro. Design, performance, flessibilità e sicurezza.",
      description: "REFD77 è la porta a libro che trasforma una parete vetrata in un passaggio completamente aperto: le ante si ripiegano una sull'altra e si raccolgono di lato, liberando quasi tutta la luce dell'apertura. Le cerniere a rulli scaricano il peso sul telaio inferiore, così si arriva fino a 7 ante consecutive da 120 kg ciascuna e 3,50 m di altezza. La soglia può essere standard, incassata o ribassata per un passaggio senza gradini, ogni anta ha il proprio blocco di sicurezza e il taglio termico mantiene il comfort anche a parete chiusa.",
      features: [
        "Uw 1,66 W/m²K — certificazione antieffrazione PAS24",
        "Profondità profilo 77 mm — taglio termico",
        "Fino a 7 ante impacchettabili consecutive",
        "Portata anta fino a 120 kg",
        "Altezza anta fino a 3,50 m",
        "Cerniera a rulli — carico scaricato sul telaio inferiore",
        "Soglia standard, incassata o ribassata",
        "Blocco su ogni anta — massima sicurezza",
        "Isolamento termico avanzato",
      ],
      applications: ["Ville", "Verande convertibili", "Ristoranti outdoor", "Progetti architettonici"],
    },
    en: {
      name: "REFD77",
      tagline: "Folding door. Design, performance, flexibility and security.",
      description: "REFD77 is the folding door that transforms a glazed wall into a fully open passage: the leaves fold onto one another and stack to the side, freeing almost the entire width of the opening. The roller hinges transfer the load to the lower frame, allowing up to 7 consecutive leaves of 120 kg each and 3.50 m in height. The threshold can be standard, recessed or low-profile for step-free access, each leaf has its own security lock and the thermal break maintains comfort even when the wall is closed.",
      features: [
        "Uw 1.66 W/m²K — PAS24 security certified",
        "77 mm profile depth — thermal break",
        "Up to 7 consecutive folding vents",
        "Vent load up to 120 kg",
        "Vent height up to 3.50 m",
        "Roller hinge — load on the lower frame",
        "Standard, embedded or low-threshold",
        "Locking on every vent — max security",
        "Advanced thermal insulation",
      ],
      applications: ["Villas", "Convertible verandas", "Outdoor F&B", "Architectural projects"],
    },
    image: "/catalog2026/refd77.webp",
    gallery: [
      "/catalog2026/alu-refd77-amb.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,66 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.66 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "opening", "it": {"label": "Tipologia di apertura", "value": "A libro con impacchettamento", "note": "Fino a 7 ante consecutive"}, "en": {"label": "Opening type", "value": "Folding with stacking", "note": "Up to 7 consecutive vents"}}, {"icon": "size", "it": {"label": "Dimensioni massime anta", "value": "Fino a 120 kg e 3,50 m di altezza"}, "en": {"label": "Maximum vent dimensions", "value": "Up to 120 kg and 3.50 m height"}}, {"icon": "security", "it": {"label": "Sicurezza", "value": "Certificazione antieffrazione PAS24", "note": "Blocco su ogni anta"}, "en": {"label": "Security", "value": "PAS24 anti-burglary certification", "note": "Locking on every vent"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "77 mm"}, "en": {"label": "Profile depth", "value": "77 mm"}}],
  },

  // ALLUMINIO — Scorrevoli e Alzanti (Catalogo ASAŞ 2026)
  "asas-rst116": {
    slug: "asas-rst116",
    category: "alluminio-scorrevole",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/RST116-505.pdf",
    quickSpecs: { frame: 116, glass: 33, thermal: 15 },
    it: {
      name: "RST116",
      tagline: "Lo scorrevole flessibile. Anche in versione alzante.",
      description: "RST116 è lo scorrevole in alluminio a taglio termico che si adatta a quasi ogni situazione: può essere configurato come scorrevole semplice o come alzante scorrevole, su binario singolo, doppio o triplo. I profili rinforzati permettono di realizzare anche ante molto alte senza rinunciare alla fluidità di manovra. Una soluzione versatile per balconi, verande e aperture di medie e grandi dimensioni.",
      features: [
        "Uw 2,16–2,41 W/m²K — isolamento acustico 30 dB",
        "Profondità telaio min. 116,4 mm — max 180,8 mm",
        "Profondità anta 52,1 mm",
        "Spessore parete 1,6 / 1,8 / 2 mm",
        "Vetro fino a 33 mm",
        "Barra taglio termico 14,8 mm",
        "Alzante-scorrevole + scorrevole semplice",
        "Mono, doppio, triplo binario",
        "Ante di grande altezza con profili rinforzati",
      ],
      applications: ["Residenziale", "Balconi ampi", "Verande", "Uffici"],
    },
    en: {
      name: "RST116",
      tagline: "The flexible slider. Also as lift-and-slide.",
      description: "RST116 is the thermally broken aluminium slider that adapts to almost any situation: it can be configured as a simple slider or as a lift-and-slide, on single, double or triple track. Reinforced profiles allow very tall sashes without compromising smooth operation. A versatile solution for balconies, conservatories and medium to large openings.",
      features: [
        "Uw 2.16–2.41 W/m²K — acoustic 30 dB",
        "Frame depth min. 116.4 mm — max 180.8 mm",
        "Sash depth 52.1 mm",
        "Wall thickness 1.6 / 1.8 / 2 mm",
        "Glazing up to 33 mm",
        "Thermal barrier 14.8 mm",
        "Lift-and-slide + simple slide",
        "Mono, double, triple rail",
        "Tall sashes with reinforced profiles",
      ],
      applications: ["Residential", "Wide balconies", "Verandas", "Offices"],
    },
    image: "/catalog2026/rst116.webp",
    gallery: [
      "/catalog2026/alu-rst116-amb.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 2,16–2,41 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 2.16–2.41 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "fino a 30 dB", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "up to 30 dB", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 33 mm"}, "en": {"label": "Glazing", "value": "up to 33 mm"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Alzante-scorrevole e scorrevole semplice", "note": "Mono, doppio o triplo binario"}, "en": {"label": "Opening types", "value": "Lift-and-slide and simple slide", "note": "Mono, double or triple rail"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "116,4–180,8 mm"}, "en": {"label": "Frame depth", "value": "116.4–180.8 mm"}}, {"icon": "size", "it": {"label": "Grandi dimensioni", "value": "Ante di grande altezza con profili rinforzati"}, "en": {"label": "Large sizes", "value": "Tall sashes with reinforced profiles"}}],
  },
  "asas-rst162": {
    slug: "asas-rst162",
    category: "alluminio-scorrevole",
    brochure: "https://www.rescara.com.tr/sites/1/upload/files/RST162_00_teknik_ozellikler-558.pdf",
    quickSpecs: { frame: 162, glass: 52, thermal: 34 },
    it: {
      name: "RST162",
      tagline: "Alzante scorrevole isolato. Look minimal senza rinunciare all'isolamento.",
      description: "RST162 è l'alzante scorrevole per grandi vetrate che non vuole farsi notare: i profili a bordo sottile riducono l'alluminio in vista, mentre l'isolamento in schiuma EPDM mantiene alte le prestazioni termiche. Disponibile a binario singolo o triplo e con combinazioni d'anta a 45° per assecondare geometrie particolari. Il compromesso perfetto tra design pulito e comfort per ville, attici e grandi spazi abitativi.",
      features: [
        "Uw 1,63 W/m²K — tenuta all'acqua E750",
        "Profondità telaio min. 162 / max 253 mm",
        "Profondità anta 71 mm",
        "Spessore parete 1,8 mm",
        "Vetro fino a 52 mm",
        "Barra taglio termico 34 mm",
        "Isolamento schiuma EPDM",
        "Combinazioni ante a 45°",
        "Mono-binario e triplo-binario",
      ],
      applications: ["Ville panoramiche", "Loft di grandi dimensioni", "Hotel di pregio", "Attici e roof"],
    },
    en: {
      name: "RST162",
      tagline: "Insulated lift-and-slide. Minimal aesthetic without compromising thermal performance.",
      description: "RST162 is a lift-and-slide system for large glazed openings designed to remain discreet: slim-edge profiles minimise visible aluminium, whilst EPDM foam insulation maintains high thermal performance. Available in single or triple track configurations, with 45° sash combinations to accommodate distinctive geometries. The ideal balance between clean design and comfort for villas, penthouses and large living spaces.",
      features: [
        "Uw 1.63 W/m²K — watertightness E750",
        "Frame depth min. 162 / max 253 mm",
        "Sash depth 71 mm",
        "Wall thickness 1.8 mm",
        "Glazing up to 52 mm",
        "Thermal barrier 34 mm",
        "EPDM foam insulation",
        "45° vent combinations",
        "Mono-rail and triple-rail",
      ],
      applications: ["Panoramic villas", "Large lofts", "Premium hotels", "Attics and rooftops"],
    },
    image: "/catalog2026/rst162.webp",
    gallery: [
      "/catalog2026/alu-rst162-amb.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,63 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.63 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 52 mm"}, "en": {"label": "Glazing", "value": "up to 52 mm"}}, {"icon": "size", "it": {"label": "Grandi superfici vetrate", "value": "Profili a bordo sottile", "note": "Design minimalista per massima trasparenza"}, "en": {"label": "Large glazed surfaces", "value": "Slim profiles", "note": "Minimalist design for maximum transparency"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "162–253 mm", "note": "Configurazioni mono-binario e triplo-binario"}, "en": {"label": "Frame depth", "value": "162–253 mm", "note": "Mono-rail and triple-rail configurations"}}],
  },
  "asas-resf32": {
    slug: "asas-resf32",
    category: "alluminio-scorrevole",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/RESF32_Skyfeel_Katalog-612.pdf",
    quickSpecs: { frame: 104, glass: 32, load: 600 },
    it: {
      name: "RESF32 Skyfeel",
      tagline: "Minimal sliding isolato. Aperture ampie, spazi luminosi, alluminio quasi invisibile.",
      description: "RESF32 Skyfeel è lo scorrevole panoramico che fa sparire l'alluminio: i meccanismi si incassano sotto il pavimento e nel controtelaio, lasciando in vista solo sottilissime linee di profilo e tanto vetro. Ogni anta può pesare fino a 600 kg, quindi si possono realizzare vetrate enormi che scorrono con un dito. Il tutto senza rinunciare all'isolamento termico: è la soluzione per chi vuole vivere il paesaggio da dentro casa, tutto l'anno.",
      features: [
        "Uw 1,96 W/m²K — barretta 24 mm",
        "Profondità telaio 104 / 155 mm",
        "Vetro fino a 32 mm",
        "Peso anta max 600 kg",
        "Sezioni in vista quasi invisibili — dettagli sotto pavimento",
        "Isolamento termico incrementato",
        "Grandi ante panoramiche per aperture ampie",
        "Vista libera — senza montante centrale visibile",
      ],
      applications: ["Ville minimaliste", "Progetti architettonici", "Verande a tutto vetro", "Ristoranti panoramici"],
    },
    en: {
      name: "RESF32 Skyfeel",
      tagline: "Insulated minimal sliding. Wide openings, bright spaces, near-invisible aluminium.",
      description: "RESF32 Skyfeel is the panoramic sliding system that makes the aluminium disappear: the mechanisms are recessed beneath the floor and within the structural frame, leaving only ultra-slim profile lines and expansive glazing visible. Each sash can weigh up to 600 kg, enabling vast glazed panels that glide at a fingertip. All without compromising thermal insulation: the solution for those who want to experience the landscape from indoors, all year round.",
      features: [
        "Uw 1.96 W/m²K — 24 mm thermal bar",
        "Frame depth 104 / 155 mm",
        "Glazing up to 32 mm",
        "Max sash weight 600 kg",
        "Almost invisible visible sections — details under floor",
        "Increased thermal insulation",
        "Large panoramic sashes for wide openings",
        "Clear view — no visible central mullion",
      ],
      applications: ["Minimalist villas", "Architectural projects", "All-glass verandas", "Panoramic restaurants"],
    },
    image: "/catalog2026/alu-resf32.webp",
    gallery: [
      "/catalog2026/alu-resf32-amb.webp",
      "/catalog2026/resf32-profilo.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,96 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.96 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 32 mm"}, "en": {"label": "Glazing", "value": "up to 32 mm"}}, {"icon": "size", "it": {"label": "Peso anta massimo", "value": "600 kg", "note": "Per grandi superfici vetrate panoramiche"}, "en": {"label": "Max sash weight", "value": "600 kg", "note": "For large panoramic glazed surfaces"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "104 / 155 mm"}, "en": {"label": "Frame depth", "value": "104 / 155 mm"}}],
  },

  // ALLUMINIO — Facciate e Grandi Aperture (Catalogo ASAŞ 2026)
  "asas-ref60": {
    slug: "asas-ref60",
    category: "alluminio-facciate",
    brochure: "https://www.rescara.com.tr/Sites/1/upload/files/08_REF60-542.pdf",
    quickSpecs: { profile: 60, glass: 57, thermal: 34 },
    it: {
      name: "REF60",
      tagline: "Facciata di nuova generazione. Tutte le aperture, tutte le geometrie.",
      description: "REF60 è il sistema di facciata continua che copre praticamente ogni esigenza progettuale: versione a coprigiunto, strutturale o semi-strutturale, con tutte le tipologie di apertura integrabili, anche ad anta nascosta. Montanti e traversi sono disponibili in molte profondità, così la stessa piattaforma serve dal piccolo fronte commerciale al grattacielo, comprese facciate angolari e coperture vetrate. Accetta vetri fino a 57 mm e si completa con frangisole per gestire la luce naturale. Arriva in cantiere pronto per il montaggio, riducendo tempi e costi di posa.",
      features: [
        "Ucw fino a 1,09 W/m²K nella versione ad alto isolamento",
        "Larghezza profilo 60 mm",
        "Montanti min. 80 mm – max 255 mm",
        "Traversi min. 68 mm – max 248 mm",
        "Spessore parete 1,6 / 1,8 / 2 / 2,5 mm",
        "Vetro fino a 57 mm",
        "Barra taglio termico 14,8 / 24 / 34 mm",
        "Facciata coprigiunto, strutturale, semi-strutturale, alto isolamento",
        "Anta interna a scomparsa, anta-ribalta, rinforzo acciaio",
        "Compatibile con frangisole RSS",
      ],
      applications: ["Grattacieli iconici", "Uffici direzionali", "Facciate angolari", "Tetti vetrati"],
    },
    en: {
      name: "REF60",
      tagline: "New-generation curtain wall. Every opening, every geometry.",
      description: "REF60 is the curtain wall system that covers virtually every design requirement: capped, structural or semi-structural version, with all opening types available for integration, including concealed sashes. Mullions and transoms are available in multiple depths, so the same platform serves everything from small commercial frontages to high-rise buildings, including angular facades and glazed roofs. Accommodates glazing up to 57 mm and can be completed with brise-soleil to manage natural light. Arrives on site ready for installation, reducing fitting time and cost.",
      features: [
        "Ucw down to 1.09 W/m²K in high-insulation version",
        "Profile width 60 mm",
        "Mullion min. 80 mm – max 255 mm",
        "Transom min. 68 mm – max 248 mm",
        "Wall thickness 1.6 / 1.8 / 2 / 2.5 mm",
        "Glazing up to 57 mm",
        "Thermal barrier 14.8 / 24 / 34 mm",
        "Capped, structural, semi-structural, high-insulation facade",
        "Inward hidden vent, tilt & turn, steel reinforcement",
        "Compatible with RSS sunshades",
      ],
      applications: ["Iconic high-rises", "HQ offices", "Angular facades", "Glass roofs"],
    },
    image: "/catalog2026/ref60.webp",
    gallery: [
      "/catalog2026/alu-ref60-amb.webp",
      "/catalog2026/ref60-profilo.webp",
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Ucw fino a 1,09 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Ucw down to 1.09 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 57 mm"}, "en": {"label": "Glazing", "value": "up to 57 mm"}}, {"icon": "structure", "it": {"label": "Tipologie di facciata", "value": "Coprigiunto, strutturale, semi-strutturale, alto isolamento"}, "en": {"label": "Facade types", "value": "Capped, structural, semi-structural, high-insulation"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Anta interna a scomparsa, anta-ribalta", "note": "Con rinforzo in acciaio disponibile"}, "en": {"label": "Opening types", "value": "Inward hidden vent, tilt & turn", "note": "Steel reinforcement available"}}],
  },



  // ALLUMINIO — Nuovi sistemi (Catalogo Architettonico ASAŞ 2026)
  "asas-rwt55": {
    "slug": "asas-rwt55",
    "category": "alluminio-porte-finestre",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/06_RWT55_KATALOG-418.pdf",
    "quickSpecs": {
      "frame": 55,
      "glass": 36,
      "thermal": 14.8
    },
    "it": {
      "name": "RWT55",
      "tagline": "Il taglio termico versatile. Tutte le aperture in un solo sistema.",
      "description": "RWT55 è il sistema a taglio termico da 55 mm che copre quasi ogni esigenza di porte e finestre: apertura a battente, anta-ribalta, vasistas, scorrevole-ribalta, a libro e a bilico. Il traverso intermedio rinforzato regge carichi statici elevati e le ante sono predisposte per la ferramenta da PVC, così la produzione resta semplice. È la base affidabile per il residenziale e i piccoli edifici commerciali.",
      "features": [
        "Profondità telaio 55 mm — anta 65 mm",
        "Spessore parete 1,6 / 1,8 / 2 mm",
        "Vetro fino a 36 mm",
        "Barretta di taglio termico 14,8 mm",
        "Uw 2,19 W/m²K — isolamento acustico 32 dB",
        "Battente, anta-ribalta, vasistas, a bilico, a libro, scorrevole-ribalta",
        "Ante compatibili con ferramenta da PVC"
      ],
      "applications": [
        "Residenziale",
        "Ristrutturazioni",
        "Piccoli edifici commerciali",
        "Uffici"
      ]
    },
    "en": {
      "name": "RWT55",
      "tagline": "The versatile thermal-break system. Every opening in one range.",
      "description": "RWT55 is a 55 mm thermally broken system covering nearly every door and window requirement: casement, tilt & turn, bottom-hung, tilt & slide, folding and pivot openings. The reinforced intermediate transom handles high static loads and sashes are designed for PVC hardware, keeping fabrication straightforward. A dependable foundation for residential and small commercial buildings.",
      "features": [
        "Frame depth 55 mm — vent 65 mm",
        "Wall thickness 1.6 / 1.8 / 2 mm",
        "Glazing up to 36 mm",
        "Thermal bar 14.8 mm",
        "Uw 2.19 W/m²K — acoustic 32 dB",
        "Casement, tilt & turn, bottom-hung, pivot, folding, tilt & slide",
        "Vents for PVC hardware"
      ],
      "applications": [
        "Residential",
        "Renovations",
        "Small commercial buildings",
        "Offices"
      ]
    },
    "image": "/catalog2026/alu-rwt55.webp",
    "gallery": [
      "/catalog2026/alu-rwt55.webp",
      "/catalog2026/alu-rwt55-amb.webp"
    ],
    highlights: [
      { icon: "thermal", it: { label: "Isolamento termico", value: "Uw 2,19 W/m²K", note: "Valore di sistema: varia con vetro e dimensioni" }, en: { label: "Thermal insulation", value: "Uw 2.19 W/m²K", note: "System value: varies with glazing and size" } },
      { icon: "acoustic", it: { label: "Isolamento acustico", value: "fino a 32 dB", note: "In base alla vetratura scelta" }, en: { label: "Acoustic insulation", value: "up to 32 dB", note: "Depending on the chosen glazing" } },
      { icon: "glass", it: { label: "Vetratura", value: "fino a 36 mm" }, en: { label: "Glazing", value: "up to 36 mm" } },
      { icon: "opening", it: { label: "Tipologie di apertura", value: "Battente, anta-ribalta, vasistas, a bilico, a libro, scorrevole-ribalta" }, en: { label: "Opening types", value: "Casement, tilt & turn, bottom-hung, pivot, folding, tilt & slide" } },
      { icon: "depth", it: { label: "Profondità del telaio", value: "55 mm" }, en: { label: "Frame depth", value: "55 mm" } },
    ]
  },
  "asas-rwt55-plus": {
    "slug": "asas-rwt55-plus",
    "category": "alluminio-porte-finestre",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/07_RWT55_Plus-560.pdf",
    "quickSpecs": {
      "frame": 55,
      "glass": 36,
      "thermal": 14.8
    },
    "it": {
      "name": "RWT55+",
      "tagline": "Taglio termico conveniente, produzione più veloce.",
      "description": "RWT55+ è la versione economica del 55 mm a taglio termico, pensata per chi produce: i canali per viti semplificano assemblaggio e montaggio della ferramenta. Offre apertura a battente, anta-ribalta, vasistas e a bilico con ante compatibili con gli accessori da PVC, per porte e finestre interne ed esterne dal buon rapporto qualità-prezzo.",
      "features": [
        "Profondità telaio 55 mm — anta 65 mm",
        "Spessore parete 1,6 / 2 mm",
        "Vetro fino a 36 mm",
        "Barretta di taglio termico 14,8 mm",
        "Uw 2,21 W/m²K — isolamento acustico 35 dB",
        "Canali per viti: lavorazione più rapida",
        "Battente, anta-ribalta, vasistas, a bilico"
      ],
      "applications": [
        "Residenziale",
        "Edilizia economica",
        "Interni ed esterni",
        "Sostituzione serramenti"
      ]
    },
    "en": {
      "name": "RWT55+",
      "tagline": "Affordable thermal break, faster fabrication.",
      "description": "RWT55+ is the economical 55 mm thermally broken system, designed for fabricators: screw channels simplify assembly and hardware fitting. It offers casement, tilt & turn, bottom-hung and pivot openings with sashes compatible with PVC accessories, for internal and external doors and windows offering excellent value for money.",
      "features": [
        "Frame depth 55 mm — vent 65 mm",
        "Wall thickness 1.6 / 2 mm",
        "Glazing up to 36 mm",
        "Thermal bar 14.8 mm",
        "Uw 2.21 W/m²K — acoustic 35 dB",
        "Screw channels for faster fabrication",
        "Casement, tilt & turn, bottom-hung, pivot"
      ],
      "applications": [
        "Residential",
        "Cost-effective construction",
        "Indoor and outdoor",
        "Window replacement"
      ]
    },
    "image": "/catalog2026/alu-rwt55-plus.webp",
    "gallery": [
      "/catalog2026/alu-rwt55-plus.webp",
      "/catalog2026/alu-rwt55-plus-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 2,21 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 2.21 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "fino a 35 dB", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "up to 35 dB", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 36 mm"}, "en": {"label": "Glazing", "value": "up to 36 mm"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Battente, anta-ribalta, vasistas, a bilico"}, "en": {"label": "Opening types", "value": "Casement, tilt & turn, bottom-hung, pivot"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "55 mm"}, "en": {"label": "Frame depth", "value": "55 mm"}}],
  },
  "asas-rwt56": {
    "slug": "asas-rwt56",
    "category": "alluminio-porte-finestre",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/08_RWT56_KATALOG-485.pdf",
    "quickSpecs": {
      "frame": 56,
      "glass": 39,
      "thermal": 14.8
    },
    "it": {
      "name": "RWT56",
      "tagline": "Linee dritte o arrotondate. Il taglio termico che si adatta allo stile.",
      "description": "RWT56 propone due estetiche nello stesso sistema: telaio a linee dritte, moderno e geometrico, oppure a profilo arrotondato. Per le porte è disponibile la versione complanare, con anta e telaio sullo stesso piano. La cava Euro e la battuta da 24 mm lo rendono compatibile con la ferramenta più diffusa.",
      "features": [
        "Telaio linea dritta 55,8 mm — linea arrotondata 64,8 mm",
        "Spessore parete 1,4 / 1,6 / 1,8 / 2 mm",
        "Vetro fino a 39 mm (29 mm versione arrotondata)",
        "Barretta di taglio termico 14,8 mm",
        "Uw 2,17 W/m²K",
        "Porta complanare con apertura interna o esterna",
        "Cava Euro — battuta 24 mm"
      ],
      "applications": [
        "Residenziale",
        "Ristrutturazioni",
        "Negozi e studi",
        "Edifici pubblici"
      ]
    },
    "en": {
      "name": "RWT56",
      "tagline": "Straight or rounded lines. Thermal break that adapts to style.",
      "description": "RWT56 offers two aesthetics in one system: a straight-line frame, modern and geometric, or a rounded profile. For doors, a coplanar version is available, with sash and frame on the same plane. The Euro groove and 24 mm rebate make it compatible with the most common hardware.",
      "features": [
        "Flat frame 55.8 mm — oval frame 64.8 mm",
        "Wall thickness 1.4 / 1.6 / 1.8 / 2 mm",
        "Glazing up to 39 mm (29 mm oval)",
        "Thermal bar 14.8 mm",
        "Uw 2.17 W/m²K",
        "Coplanar door, inward or outward",
        "Eurogroove — 24 mm flange"
      ],
      "applications": [
        "Residential",
        "Renovations",
        "Shops and studios",
        "Public buildings"
      ]
    },
    "image": "/catalog2026/alu-rwt56.webp",
    "gallery": [
      "/catalog2026/alu-rwt56.webp",
      "/catalog2026/alu-rwt56-amb.webp",
      "/catalog2026/alu-rwt56-amb2.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 2,17 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 2.17 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 39 mm", "note": "29 mm nella versione a profilo arrotondato"}, "en": {"label": "Glazing", "value": "up to 39 mm", "note": "29 mm in oval profile version"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "55,8 mm linea dritta — 64,8 mm linea arrotondata"}, "en": {"label": "Frame depth", "value": "55.8 mm flat — 64.8 mm oval"}}, {"icon": "opening", "it": {"label": "Porta complanare", "value": "Anta e telaio sullo stesso piano", "note": "Apertura interna o esterna"}, "en": {"label": "Coplanar door", "value": "Flush sash and frame", "note": "Inward or outward opening"}}],
  },
  "asas-rwt64": {
    "slug": "asas-rwt64",
    "category": "alluminio-porte-finestre",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/09_RWT64_KATALOG-486.pdf",
    "quickSpecs": {
      "frame": 64,
      "glass": 44,
      "thermal": 24
    },
    "it": {
      "name": "RWT64",
      "tagline": "Il passo avanti nell'isolamento. 64 mm per ogni progetto.",
      "description": "RWT64 alza il livello di isolamento grazie alla barretta da 24 mm e a vetri fino a 44 mm, adatti anche ai tripli vetri sottili. Mantiene la flessibilità della gamma: battente, anta-ribalta, vasistas, scorrevole-ribalta, a libro e a bilico, con ante compatibili con gli accessori da PVC. Un ottimo equilibrio tra prestazioni e costo.",
      "features": [
        "Profondità telaio 64,2 mm — anta 74,2 mm",
        "Spessore parete 1,6 / 1,8 / 2 mm",
        "Vetro fino a 44 mm",
        "Barretta di taglio termico 24 mm",
        "Uw 1,84 W/m²K — tenuta all'acqua E900",
        "Battente, anta-ribalta, vasistas, a bilico, a libro, scorrevole-ribalta",
        "Ante compatibili con ferramenta da PVC"
      ],
      "applications": [
        "Residenziale",
        "Condomini",
        "Uffici",
        "Strutture ricettive"
      ]
    },
    "en": {
      "name": "RWT64",
      "tagline": "A step forward in insulation. 64 mm for every project.",
      "description": "RWT64 raises the level of insulation thanks to its 24 mm thermal break and glazing up to 44 mm, suitable for slim triple glazing as well. It maintains the flexibility of the range: casement, tilt & turn, bottom-hung, tilt & slide, folding and pivot, with sashes compatible with PVC hardware. An excellent balance between performance and cost.",
      "features": [
        "Frame depth 64.2 mm — vent 74.2 mm",
        "Wall thickness 1.6 / 1.8 / 2 mm",
        "Glazing up to 44 mm",
        "Thermal bar 24 mm",
        "Uw 1.84 W/m²K — watertightness E900",
        "Casement, tilt & turn, bottom-hung, pivot, folding, tilt & slide",
        "Vents for PVC hardware"
      ],
      "applications": [
        "Residential",
        "Apartment blocks",
        "Offices",
        "Hospitality"
      ]
    },
    "image": "/catalog2026/alu-rwt64.webp",
    "gallery": [
      "/catalog2026/alu-rwt64.webp",
      "/catalog2026/alu-rwt64-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,84 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.84 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 44 mm", "note": "Compatibile con tripli vetri sottili"}, "en": {"label": "Glazing", "value": "up to 44 mm", "note": "Compatible with thin triple glazing"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Battente, anta-ribalta, vasistas, a bilico, a libro, scorrevole-ribalta"}, "en": {"label": "Opening types", "value": "Casement, tilt & turn, bottom-hung, pivot, folding, tilt & slide"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "64,2 mm"}, "en": {"label": "Frame depth", "value": "64.2 mm"}}],
  },
  "asas-rwtp64": {
    "slug": "asas-rwtp64",
    "category": "alluminio-porte-finestre",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/10_RWTP64_KATALOG-487.pdf",
    "quickSpecs": {
      "frame": 64,
      "glass": 44,
      "thermal": 24
    },
    "it": {
      "name": "RWTP64",
      "tagline": "Il 64 mm potenziato. Isolanti speciali, meno dispersioni.",
      "description": "RWTP64 parte dalla piattaforma da 64 mm e aggiunge isolanti speciali in schiuma nella barretta da 24 mm, abbassando sensibilmente le dispersioni del telaio. Il traverso intermedio rinforzato sostiene carichi statici elevati e l'isolamento acustico arriva a 39,5 dB: ideale dove si cercano più comfort e silenzio senza passare a sistemi più profondi.",
      "features": [
        "Profondità telaio 64,2 mm — anta 74,2 mm",
        "Spessore parete 1,6 / 1,8 / 2 mm",
        "Vetro fino a 44 mm",
        "Barretta 24 mm con isolante in schiuma",
        "Uw 1,78 W/m²K — isolamento acustico 39,5 dB",
        "Tenuta all'acqua fino a E1200",
        "Battente, anta-ribalta, vasistas, a bilico, a libro, scorrevole-ribalta"
      ],
      "applications": [
        "Residenziale di qualità",
        "Zone trafficate",
        "Uffici",
        "Hotel"
      ]
    },
    "en": {
      "name": "RWTP64",
      "tagline": "Enhanced 64 mm system. Special insulation, reduced losses.",
      "description": "RWTP64 builds on the 64 mm platform and incorporates special foam insulation within the 24 mm thermal break, significantly reducing frame heat loss. The reinforced intermediate transom supports high static loads, whilst acoustic insulation reaches 39.5 dB: ideal where enhanced comfort and quietness are required without transitioning to deeper systems.",
      "features": [
        "Frame depth 64.2 mm — vent 74.2 mm",
        "Wall thickness 1.6 / 1.8 / 2 mm",
        "Glazing up to 44 mm",
        "24 mm bar with foam insulation",
        "Uw 1.78 W/m²K — acoustic 39.5 dB",
        "Watertightness up to E1200",
        "Casement, tilt & turn, bottom-hung, pivot, folding, tilt & slide"
      ],
      "applications": [
        "Quality residential",
        "Busy urban areas",
        "Offices",
        "Hotels"
      ]
    },
    "image": "/catalog2026/alu-rwtp64.webp",
    "gallery": [
      "/catalog2026/alu-rwtp64.webp",
      "/catalog2026/alu-rwtp64-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,78 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.78 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "fino a 39,5 dB", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "up to 39.5 dB", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 44 mm"}, "en": {"label": "Glazing", "value": "up to 44 mm"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Battente, anta-ribalta, vasistas, a bilico, a libro, scorrevole-ribalta"}, "en": {"label": "Opening types", "value": "Casement, tilt & turn, bottom-hung, pivot, folding, tilt & slide"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "64,2 mm"}, "en": {"label": "Frame depth", "value": "64.2 mm"}}],
  },
  "asas-rwt75": {
    "slug": "asas-rwt75",
    "category": "alluminio-porte-finestre",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/12_RWT75_KATALOG-489.pdf",
    "quickSpecs": {
      "frame": 75,
      "glass": 58,
      "thermal": 34,
      "highInsulation": true
    },
    "it": {
      "name": "RWT75",
      "tagline": "Alto isolamento e grande solidità. Il 75 mm per progetti esigenti.",
      "description": "RWT75 è il sistema ad alto isolamento della gamma: barretta da 34 mm con isolanti speciali, vetri fino a 58 mm e una struttura robusta che regge ante grandi e pesanti. Per le porte offre versioni complanari, con cava PVC e soglie dedicate. Con 42 dB di isolamento acustico e tenuta all'acqua fino a E1650, è adatto a ville, edifici esposti e progetti ad alta efficienza energetica.",
      "features": [
        "Profondità telaio 75 mm — anta 75/85 mm",
        "Spessore parete 1,6 / 2 mm",
        "Vetro fino a 48 / 58 mm",
        "Barretta 34 mm con isolante in schiuma",
        "Uw 1,62 W/m²K — isolamento acustico 42 dB",
        "Tenuta all'acqua fino a E1650",
        "Porte complanari, soglie speciali, apertura interna ed esterna"
      ],
      "applications": [
        "Ville e residenze di pregio",
        "Edifici ad alta efficienza",
        "Zone esposte al vento",
        "Hotel"
      ]
    },
    "en": {
      "name": "RWT75",
      "tagline": "High insulation and exceptional strength for demanding projects.",
      "description": "RWT75 is the high-insulation system in the range: 34 mm thermal break with special insulating materials, glazing up to 58 mm and a robust structure that supports large, heavy sashes. For doors, it offers coplanar versions, PVC rebate options and dedicated thresholds. With 42 dB acoustic insulation and watertightness up to E1650, it is suitable for villas, exposed buildings and high-performance energy-efficiency projects.",
      "features": [
        "Frame depth 75 mm — vent 75/85 mm",
        "Wall thickness 1.6 / 2 mm",
        "Glazing up to 48 / 58 mm",
        "34 mm bar with foam insulation",
        "Uw 1.62 W/m²K — acoustic 42 dB",
        "Watertightness up to E1650",
        "Coplanar doors, special sills, inward and outward"
      ],
      "applications": [
        "Premium villas",
        "High-efficiency buildings",
        "Wind-exposed sites",
        "Hotels"
      ]
    },
    "image": "/catalog2026/alu-rwt75.webp",
    "gallery": [
      "/catalog2026/alu-rwt75.webp",
      "/catalog2026/alu-rwt75-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,62 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.62 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "fino a 42 dB", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "up to 42 dB", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 58 mm"}, "en": {"label": "Glazing", "value": "up to 58 mm"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "75 mm"}, "en": {"label": "Frame depth", "value": "75 mm"}}],
  },
  "asas-repf160": {
    "slug": "asas-repf160",
    "category": "alluminio-scorrevole",
    "brochure": "/catalog2026/schede/ASAS_REPF160.pdf",
    "quickSpecs": {
      "frame": 158,
      "glass": 52,
      "thermal": 34
    },
    "it": {
      "name": "REPF160",
      "tagline": "Lo scorrevole intelligente per edifici di prestigio.",
      "description": "REPF160 è lo scorrevole ad alte prestazioni pensato per edifici prestigiosi ed esposti a forti venti. In chiusura le ante vengono serrate contro le guarnizioni da un meccanismo intelligente, silenzioso e facile da usare, con chiusura semplificata. Profili e componenti dimensionati per alte pressioni del vento e isolanti speciali mantengono ottimi valori termici.",
      "features": [
        "Profondità telaio 157,8 mm — anta 71,2 mm",
        "Spessore parete 1,7 / 1,8 / 2 mm",
        "Vetro fino a 52 mm",
        "Barretta di taglio termico 34 mm",
        "Uw 1,66 W/m²K — isolamento acustico 33,7 dB",
        "Chiusura intelligente a tenuta — tenuta all'acqua E750",
        "Unione ante a 45° — telaio monobinario"
      ],
      "applications": [
        "Edifici alti",
        "Residenze di lusso",
        "Hotel e resort",
        "Zone ventose e costiere"
      ]
    },
    "en": {
      "name": "REPF160",
      "tagline": "The intelligent sliding system for prestigious buildings.",
      "description": "REPF160 is a high-performance sliding system designed for prestigious buildings exposed to high wind loads. On closing, the sashes are drawn tight against the seals by an intelligent mechanism that is silent, easy to use and ensures reliable closure. Profiles and components dimensioned for high wind pressures, together with specialist insulation, maintain excellent thermal values.",
      "features": [
        "Frame depth 157.8 mm — vent 71.2 mm",
        "Wall thickness 1.7 / 1.8 / 2 mm",
        "Glazing up to 52 mm",
        "Thermal bar 34 mm",
        "Uw 1.66 W/m²K — acoustic 33.7 dB",
        "Smart sealed closing — watertightness E750",
        "45° vent joint — mono-rail frame"
      ],
      "applications": [
        "High-rise buildings",
        "Luxury residences",
        "Hotels and resorts",
        "Windy and coastal areas"
      ]
    },
    "image": "/catalog2026/alu-repf160.webp",
    "gallery": [
      "/catalog2026/alu-repf160.webp",
      "/catalog2026/alu-repf160-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,66 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.66 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "fino a 33,7 dB", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "up to 33.7 dB", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 52 mm"}, "en": {"label": "Glazing", "value": "up to 52 mm"}}, {"icon": "security", "it": {"label": "Tenuta all'acqua", "value": "E750", "note": "Chiusura intelligente a tenuta per edifici esposti a forti venti"}, "en": {"label": "Watertightness", "value": "E750", "note": "Smart sealed closing for buildings exposed to strong winds"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "157,8 mm"}, "en": {"label": "Frame depth", "value": "157.8 mm"}}],
  },
  "asas-e50": {
    "slug": "asas-e50",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/03_E50-547.pdf",
    "quickSpecs": {
      "profile": 50,
      "glass": 38,
      "thermal": 14.8
    },
    "it": {
      "name": "E50",
      "tagline": "La facciata continua più isolante della gamma da 50 mm.",
      "description": "E50 è la facciata continua con i valori di isolamento più alti tra i sistemi da 50 mm. Funziona su edifici bassi e alti e, nella versione strutturale, crea una superficie in vetro senza interruzioni. È disponibile anche con coprigiunto e semi-strutturale e accoglie ante a sporgere a scomparsa e ad apertura parallela.",
      "features": [
        "Larghezza profilo 50 mm",
        "Montanti 44–209,7 mm — traversi 60–216,3 mm",
        "Vetro fino a 38 mm",
        "Barretta di taglio termico 14,8 mm",
        "Ucw 1,68 W/m²K (coprigiunto) — 1,91 W/m²K (strutturale)",
        "Tenuta all'acqua RE900 — vento ±1320 Pa",
        "Coprigiunto, strutturale, semi-strutturale — ante a scomparsa e parallele"
      ],
      "applications": [
        "Uffici",
        "Edifici commerciali",
        "Edifici pubblici",
        "Residenziale multipiano"
      ]
    },
    "en": {
      "name": "E50",
      "tagline": "The most thermally efficient 50 mm curtain wall in the range.",
      "description": "E50 is the curtain wall system with the highest insulation values among 50 mm systems. Suitable for low-rise and high-rise buildings, the structural glazed version creates an uninterrupted glass surface. Also available with cap and semi-structural options, and accommodates concealed projected and parallel opening sashes.",
      "features": [
        "Profile width 50 mm",
        "Mullions 44–209.7 mm — transoms 60–216.3 mm",
        "Glazing up to 38 mm",
        "Thermal bar 14.8 mm",
        "Ucw 1.68 W/m²K (capped) — 1.91 W/m²K (structural)",
        "Watertightness RE900 — wind ±1320 Pa",
        "Capped, structural, semi-structural — hidden and parallel vents"
      ],
      "applications": [
        "Offices",
        "Commercial buildings",
        "Public buildings",
        "Multi-storey residential"
      ]
    },
    "image": "/catalog2026/alu-e50.webp",
    "gallery": [
      "/catalog2026/alu-e50.webp",
      "/catalog2026/alu-e50-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Ucw 1,68 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni. Versione coprigiunto."}, "en": {"label": "Thermal insulation", "value": "Ucw 1.68 W/m²K", "note": "System value: varies with glazing and size. Capped version."}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 38 mm"}, "en": {"label": "Glazing", "value": "up to 38 mm"}}, {"icon": "depth", "it": {"label": "Larghezza del profilo", "value": "50 mm"}, "en": {"label": "Profile width", "value": "50 mm"}}, {"icon": "structure", "it": {"label": "Tipologie di facciata", "value": "Coprigiunto, strutturale, semi-strutturale", "note": "Ante a scomparsa e ad apertura parallela integrabili"}, "en": {"label": "Façade types", "value": "Capped, structural, semi-structural", "note": "Hidden and parallel opening vents can be integrated"}}],
  },
  "asas-r50": {
    "slug": "asas-r50",
    "category": "alluminio-facciate",
    "brochure": "/catalog2026/schede/ASAS_R50.pdf",
    "quickSpecs": {
      "profile": 50,
      "glass": 44,
      "thermal": 14.8
    },
    "it": {
      "name": "R50",
      "tagline": "La facciata completa: coprigiunto, strutturale e rinforzo in acciaio.",
      "description": "R50 riunisce in un unico sistema facciata a coprigiunto, semi-strutturale, strutturale e con rinforzo in acciaio. Nella versione strutturale l'anta si realizza senza telaio aggiuntivo, e su richiesta si possono inserire ante a scomparsa a sporgere o ad apertura parallela. Adatta a edifici bassi e alti, offre una superficie in vetro continua e pulita.",
      "features": [
        "Larghezza profilo 50 mm",
        "Montanti 80–290 mm — traversi 30–166 mm",
        "Vetro fino a 44 mm (coprigiunto) — 37 mm (strutturale)",
        "Barretta di taglio termico 14,8 mm",
        "Ucw 1,73 W/m²K (coprigiunto) — 1,94 W/m²K (strutturale)",
        "Resistenza al vento ±1200 Pa",
        "Versione con rinforzo in acciaio per grandi luci"
      ],
      "applications": [
        "Uffici",
        "Centri commerciali",
        "Edifici alti",
        "Showroom"
      ]
    },
    "en": {
      "name": "R50",
      "tagline": "The complete façade: capped, structural and steel-reinforced.",
      "description": "R50 combines capped, semi-structural, structural and steel-reinforced curtain wall systems in one. In the structural version, opening vents require no additional frame, and concealed tilt or parallel-opening vents can be integrated on request. Suitable for low- and high-rise buildings, it offers a continuous, clean glazed surface.",
      "features": [
        "Profile width 50 mm",
        "Mullions 80–290 mm — transoms 30–166 mm",
        "Glazing up to 44 mm (capped) — 37 mm (structural)",
        "Thermal bar 14.8 mm",
        "Ucw 1.73 W/m²K (capped) — 1.94 W/m²K (structural)",
        "Wind resistance ±1200 Pa",
        "Steel-reinforced version for large spans"
      ],
      "applications": [
        "Offices",
        "Shopping centres",
        "High-rise buildings",
        "Showrooms"
      ]
    },
    "image": "/catalog2026/alu-r50.webp",
    "gallery": [
      "/catalog2026/alu-r50.webp",
      "/catalog2026/alu-r50-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Ucw 1,73 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni. Ucw 1,94 W/m²K versione strutturale"}, "en": {"label": "Thermal insulation", "value": "Ucw 1.73 W/m²K", "note": "System value: varies with glazing and size. Ucw 1.94 W/m²K structural version"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 44 mm", "note": "44 mm coprigiunto — 37 mm strutturale"}, "en": {"label": "Glazing", "value": "up to 44 mm", "note": "44 mm capped — 37 mm structural"}}, {"icon": "structure", "it": {"label": "Tipologia di facciata", "value": "Coprigiunto, semi-strutturale, strutturale", "note": "Versione strutturale senza telaio aggiuntivo per superficie continua"}, "en": {"label": "Façade type", "value": "Capped, semi-structural, structural", "note": "Structural version without additional frame for continuous surface"}}, {"icon": "opening", "it": {"label": "Aperture integrate", "value": "Ante a scomparsa a sporgere o parallele", "status": "richiesta"}, "en": {"label": "Integrated openings", "value": "Concealed tilt or parallel opening vents", "status": "richiesta"}}],
  },
  "asas-rt50": {
    "slug": "asas-rt50",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/02_RT50-548.pdf",
    "quickSpecs": {
      "profile": 50,
      "glass": 42,
      "thermal": 15
    },
    "it": {
      "name": "RT50",
      "tagline": "La facciata economica: stessi profili per montanti e traversi.",
      "description": "RT50 usa gli stessi profili come montanti e come traversi: meno codici, sfridi ridotti al minimo e costi più contenuti. Gli accessori dedicati garantiscono un drenaggio continuo e senza interruzioni. Disponibile strutturale, a coprigiunto e semi-strutturale, con ante a sporgere a scomparsa, per edifici bassi e alti.",
      "features": [
        "Larghezza profilo 50 mm",
        "Montanti e traversi 30–146 mm",
        "Spessore parete 1,5 / 1,8 mm",
        "Vetro fino a 42 mm",
        "Ucw 1,74 W/m²K (coprigiunto) — 1,96 W/m²K (strutturale)",
        "Tenuta all'acqua RE900 — vento ±1200 Pa",
        "Drenaggio continuo con accessori dedicati"
      ],
      "applications": [
        "Edifici commerciali",
        "Uffici",
        "Capannoni e showroom",
        "Residenziale multipiano"
      ]
    },
    "en": {
      "name": "RT50",
      "tagline": "The economical curtain wall: same profiles for mullions and transoms.",
      "description": "RT50 uses the same profiles as both mullions and transoms: fewer codes, minimal waste and lower costs. Dedicated accessories ensure continuous, uninterrupted drainage. Available in structural, capped and semi-structural versions, with concealed projected casements, for low-rise and high-rise buildings.",
      "features": [
        "Profile width 50 mm",
        "Mullions and transoms 30–146 mm",
        "Wall thickness 1.5 / 1.8 mm",
        "Glazing up to 42 mm",
        "Ucw 1.74 W/m²K (capped) — 1.96 W/m²K (structural)",
        "Watertightness RE900 — wind ±1200 Pa",
        "Seamless drainage with dedicated accessories"
      ],
      "applications": [
        "Commercial buildings",
        "Offices",
        "Industrial showrooms",
        "Multi-storey residential"
      ]
    },
    "image": "/catalog2026/alu-rt50.webp",
    "gallery": [
      "/catalog2026/alu-rt50.webp",
      "/catalog2026/alu-rt50-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Ucw 1,74 W/m²K (coprigiunto) — 1,96 W/m²K (strutturale)", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Ucw 1.74 W/m²K (capped) — 1.96 W/m²K (structural)", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 42 mm"}, "en": {"label": "Glazing", "value": "up to 42 mm"}}, {"icon": "structure", "it": {"label": "Tipologie disponibili", "value": "Strutturale, coprigiunto e semi-strutturale", "note": "Con ante a sporgere a scomparsa, per edifici bassi e alti"}, "en": {"label": "Available types", "value": "Structural, capped and semi-structural", "note": "With concealed projected vents, for low and high-rise buildings"}}, {"icon": "security", "it": {"label": "Prestazioni", "value": "Tenuta all'acqua RE900 — vento ±1200 Pa"}, "en": {"label": "Performance", "value": "Watertightness RE900 — wind ±1200 Pa"}}],
  },
  "asas-rpe82": {
    "slug": "asas-rpe82",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/07_RPE82-543.pdf",
    "quickSpecs": {
      "glass": 35,
      "unitized": true
    },
    "it": {
      "name": "RPE82",
      "tagline": "La facciata a cellule: si assembla in fabbrica, si monta in fretta.",
      "description": "RPE82 è la facciata unitizzata per edifici alti: ogni cellula, di solito alta un piano, viene assemblata in fabbrica con profili, vetri e pannelli compositi, poi arriva in cantiere pronta da agganciare. Il risultato sono tempi di posa più brevi e una qualità controllata in stabilimento. Ideale per torri per uffici, hotel, ospedali ed edifici pubblici.",
      "features": [
        "Larghezza profilo 36–87 mm",
        "Montanti 137–182,7 mm — traversi 133,5–169 mm",
        "Spessore parete 2 mm",
        "Vetro fino a 35 mm",
        "Ucw 1,34 W/m²K (strutturale) — 1,53 W/m²K (coprigiunto)",
        "Cellule preassemblate in fabbrica",
        "Strutturale o a coprigiunto — ante a sporgere a scomparsa"
      ],
      "applications": [
        "Torri per uffici",
        "Hotel",
        "Ospedali",
        "Edifici pubblici"
      ]
    },
    "en": {
      "name": "RPE82",
      "tagline": "The unitised facade: factory-assembled, fast to install.",
      "description": "RPE82 is a unitised curtain wall system for high-rise buildings: each unit, typically one storey high, is fully assembled in the factory with profiles, glazing and composite panels, then delivered to site ready to fix. The result is shorter installation times and factory-controlled quality. Ideal for office towers, hotels, hospitals and public buildings.",
      "features": [
        "Profile width 36–87 mm",
        "Mullions 137–182.7 mm — transoms 133.5–169 mm",
        "Wall thickness 2 mm",
        "Glazing up to 35 mm",
        "Ucw 1.34 W/m²K (structural) — 1.53 W/m²K (capped)",
        "Factory pre-assembled units",
        "Structural or capped — outward hidden vents"
      ],
      "applications": [
        "Office towers",
        "Hotels",
        "Hospitals",
        "Public buildings"
      ]
    },
    "image": "/catalog2026/alu-rpe82.webp",
    "gallery": [
      "/catalog2026/alu-rpe82.webp",
      "/catalog2026/alu-rpe82-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Ucw da 1,34 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Ucw from 1.34 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 35 mm"}, "en": {"label": "Glazing", "value": "up to 35 mm"}}, {"icon": "structure", "it": {"label": "Sistema di assemblaggio", "value": "Cellule unitizzate preassemblate", "note": "Montaggio rapido in cantiere, qualità controllata in fabbrica"}, "en": {"label": "Assembly system", "value": "Pre-assembled unitized cells", "note": "Fast on-site installation, factory-controlled quality"}}, {"icon": "opening", "it": {"label": "Tipologie disponibili", "value": "Strutturale o a coprigiunto", "note": "Con ante a sporgere a scomparsa"}, "en": {"label": "Available types", "value": "Structural or capped", "note": "With outward hidden vents"}}],
  },
  "asas-reww141": {
    "slug": "asas-reww141",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/09_REWW141-541.pdf",
    "quickSpecs": {
      "profile": 52,
      "thermal": 22,
      "windowWall": true
    },
    "it": {
      "name": "REWW141",
      "tagline": "Window wall da solaio a solaio, montata dall'interno.",
      "description": "REWW141 è il sistema window wall che si appoggia da solaio a solaio, creando facciate eleganti per progetti commerciali e residenziali moderni. Si monta dall'interno dell'edificio senza ponteggi, con un notevole risparmio di tempi e costi. Accoglie al suo interno porte, finestre e scorrevoli ASAŞ ed è progettato secondo le norme europee CE e americane ASTM.",
      "features": [
        "Larghezza in vista 48 / 52 mm",
        "Profondità sistema 141 mm",
        "Barretta di taglio termico 22 mm",
        "Ucw 1,4 W/m²K",
        "Resistenza al vento ±2600 Pa",
        "Posa dall'interno, senza ponteggi",
        "Integra porte, finestre e scorrevoli ASAŞ"
      ],
      "applications": [
        "Residenziale multipiano",
        "Edifici commerciali",
        "Hotel",
        "Riqualificazione di facciate"
      ]
    },
    "en": {
      "name": "REWW141",
      "tagline": "Floor-to-floor window wall, installed from inside.",
      "description": "REWW141 is a floor-to-floor window wall system creating elegant facades for modern commercial and residential projects. It is installed from inside the building without scaffolding, delivering significant time and cost savings. It accommodates ASAŞ doors, windows and sliding systems, and is designed in accordance with European CE and American ASTM standards.",
      "features": [
        "Sight line 48 / 52 mm",
        "System depth 141 mm",
        "Thermal break 22 mm",
        "Ucw 1.4 W/m²K",
        "Wind resistance ±2600 Pa",
        "Installed from inside, no scaffolding",
        "Integrates ASAŞ doors, windows and sliders"
      ],
      "applications": [
        "Multi-storey residential",
        "Commercial buildings",
        "Hotels",
        "Facade refurbishment"
      ]
    },
    "image": "/catalog2026/alu-reww141.webp",
    "gallery": [
      "/catalog2026/alu-reww141.webp",
      "/catalog2026/alu-reww141-amb.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Ucw 1,4 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Ucw 1.4 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "depth", "it": {"label": "Profondità del sistema", "value": "141 mm"}, "en": {"label": "System depth", "value": "141 mm"}}, {"icon": "structure", "it": {"label": "Resistenza al vento", "value": "±2600 Pa"}, "en": {"label": "Wind resistance", "value": "±2600 Pa"}}, {"icon": "size", "it": {"label": "Montaggio semplificato", "value": "Posa dall'interno, senza ponteggi", "note": "Risparmio di tempi e costi in cantiere"}, "en": {"label": "Simplified installation", "value": "Installed from inside, no scaffolding", "note": "Saves time and costs on site"}}],
  },
  "asas-rsk50": {
    "slug": "asas-rsk50",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/05_RSK50-545.pdf",
    "quickSpecs": {
      "profile": 50,
      "glass": 36
    },
    "it": {
      "name": "RSK50",
      "tagline": "Il lucernario in alluminio per coperture vetrate luminose.",
      "description": "RSK50 è il sistema per lucernari e coperture vetrate, disponibile a coprigiunto, semi-strutturale e strutturale. Può essere montato su strutture in acciaio e collega montanti e traversi senza intagli. Il drenaggio avviene attraverso le guarnizioni e i valori di isolamento sono elevati, per portare luce dall'alto senza rinunciare al comfort.",
      "features": [
        "Larghezza profilo 50 mm",
        "Spessore parete 1,8 mm",
        "Vetro fino a 36 mm (8+16+5/5 o 6/6 mm)",
        "Uw 1,47 W/m²K",
        "Collegamento montanti-traversi senza intagli",
        "Drenaggio dell'acqua attraverso le guarnizioni",
        "Coprigiunto, strutturale, semi-strutturale — su acciaio"
      ],
      "applications": [
        "Atri e lucernari",
        "Centri commerciali",
        "Coperture di cortili",
        "Giardini d'inverno"
      ]
    },
    "en": {
      "name": "RSK50",
      "tagline": "The aluminium skylight system for luminous glazed roofing.",
      "description": "RSK50 is a skylight and glazed roofing system, available in capped, semi-structural and structural versions. It can be mounted on steel structures and connects mullions and transoms without notching. Drainage occurs through the gaskets and insulation values are high, bringing light from above without compromising comfort.",
      "features": [
        "Profile width 50 mm",
        "Wall thickness 1.8 mm",
        "Glazing up to 36 mm (8+16+5/5 or 6/6 mm)",
        "Uw 1.47 W/m²K",
        "Notch-free mullion-transom joints",
        "Drainage through gaskets",
        "Capped, structural, semi-capped — on steel"
      ],
      "applications": [
        "Atriums and skylights",
        "Shopping centres",
        "Courtyard roofs",
        "Winter gardens"
      ]
    },
    "image": "/catalog2026/alu-rsk50.webp",
    "gallery": [
      "/catalog2026/alu-rsk50.webp",
      "/catalog2026/alu-rsk50-amb.webp",
      "/catalog2026/alu-rsk50-amb2.webp"
    ],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,47 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.47 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 36 mm", "note": "Configurazioni 8+16+5/5 o 6/6 mm"}, "en": {"label": "Glazing", "value": "up to 36 mm", "note": "Configurations 8+16+5/5 or 6/6 mm"}}, {"icon": "structure", "it": {"label": "Tipologie disponibili", "value": "Coprigiunto, strutturale, semi-strutturale", "note": "Montaggio su strutture in acciaio"}, "en": {"label": "Available types", "value": "Capped, structural, semi-structural", "note": "Installation on steel structures"}}, {"icon": "depth", "it": {"label": "Larghezza profilo", "value": "50 mm"}, "en": {"label": "Profile width", "value": "50 mm"}}],
  },
  "asas-rss": {
    "slug": "asas-rss",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/06_RSS-544.pdf",
    "quickSpecs": {
      "profileMin": 80,
      "profileMax": 450,
      "sunshade": true
    },
    "it": {
      "name": "RSS",
      "tagline": "Frangisole in alluminio per controllare luce e calore in facciata.",
      "description": "RSS è il sistema di frangisole a lame in alluminio dalla forma affusolata, disponibile in diverse dimensioni. Riduce l'irraggiamento diretto e il surriscaldamento degli ambienti, dando carattere alla facciata. Il sistema comprende tutti gli accessori e i fissaggi necessari per il montaggio, anche abbinato alle facciate continue ASAŞ.",
      "features": [
        "Lame da 80 a 450 mm",
        "Spessore parete da 1,4 a 2,8 mm",
        "Profilo a forma affusolata",
        "Accessori e staffe di fissaggio dedicati",
        "Abbinabile alle facciate ASAŞ",
        "Verniciatura elettrostatica o anodizzazione — qualsiasi RAL"
      ],
      "applications": [
        "Uffici",
        "Scuole ed edifici pubblici",
        "Facciate esposte a sud",
        "Residenziale contemporaneo"
      ]
    },
    "en": {
      "name": "RSS",
      "tagline": "Aluminium brise-soleil for controlling light and heat on the facade.",
      "description": "RSS is a brise-soleil system with tapered aluminium blades, available in various sizes. It reduces direct solar radiation and overheating of internal spaces, adding character to the facade. The system includes all accessories and fixings required for installation, including integration with ASAŞ curtain wall systems.",
      "features": [
        "Louvres from 80 to 450 mm",
        "Wall thickness from 1.4 to 2.8 mm",
        "Shuttle-shaped profile",
        "Dedicated accessories and brackets",
        "Combines with ASAŞ facades",
        "Powder coating or anodising — any RAL"
      ],
      "applications": [
        "Offices",
        "Schools and public buildings",
        "South-facing facades",
        "Contemporary residential"
      ]
    },
    "image": "/catalog2026/alu-rss.webp",
    "gallery": [
      "/catalog2026/alu-rss.webp",
      "/catalog2026/alu-rss-amb.webp",
      "/catalog2026/alu-rss-amb2.webp"
    ],
    highlights: [{"icon": "louvres", "it": {"label": "Schermatura solare", "value": "Frangisole in alluminio a lame orientabili", "note": "Riduce l'irraggiamento diretto e il surriscaldamento"}, "en": {"label": "Sun shading", "value": "Aluminium brise-soleil with adjustable louvres", "note": "Reduces direct radiation and overheating"}}, {"icon": "size", "it": {"label": "Dimensioni delle lame", "value": "da 80 a 450 mm", "note": "Diverse configurazioni disponibili per ogni esigenza"}, "en": {"label": "Louvre sizes", "value": "from 80 to 450 mm", "note": "Multiple configurations available for every need"}}, {"icon": "structure", "it": {"label": "Finitura", "value": "Verniciatura elettrostatica o anodizzazione", "note": "Qualsiasi colore RAL disponibile"}, "en": {"label": "Finish", "value": "Powder coating or anodising", "note": "Any RAL colour available"}}, {"icon": "structure", "it": {"label": "Sistema completo", "value": "Accessori e fissaggi inclusi", "note": "Compatibile con le facciate continue ASAŞ"}, "en": {"label": "Complete system", "value": "Accessories and brackets included", "note": "Compatible with ASAŞ curtain walls"}}],
  },
  "asas-sn42": {
    "slug": "asas-sn42",
    "category": "alluminio-facciate",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/09_SN42_KATALOG-496.pdf",
    "quickSpecs": {
      "sunshade": true
    },
    "it": {
      "name": "SN42 Sun Slide",
      "tagline": "Pannelli frangisole scorrevoli che cambiano il volto della facciata.",
      "description": "SN42 Sun Slide è un sistema di pannelli frangisole scorrevoli che protegge gli ambienti da sole, pioggia, neve e grandine, arricchendo al tempo stesso l'aspetto della facciata. Le lamiere forate e ottiche, disponibili in molti disegni, offrono agli architetti ampia libertà creativa: i pannelli si aprono per la vista e si chiudono per ombra e riservatezza.",
      "features": [
        "Pannelli scorrevoli in alluminio",
        "Lamiere forate e ottiche in vari disegni",
        "Protezione da sole, pioggia, neve e grandine",
        "Controllo di luce e riservatezza",
        "Arricchisce l'immagine della facciata",
        "Verniciatura elettrostatica — qualsiasi RAL"
      ],
      "applications": [
        "Residenziale contemporaneo",
        "Uffici",
        "Hotel",
        "Logge e terrazzi"
      ]
    },
    "en": {
      "name": "SN42 Sun Slide",
      "tagline": "Sliding brise-soleil panels that transform the façade.",
      "description": "SN42 Sun Slide is a sliding brise-soleil system that shields interiors from sun, rain, snow and hail, whilst enhancing the façade's appearance. The perforated and optical sheets, available in numerous patterns, offer architects extensive creative freedom: panels slide open for views and close for shade and privacy.",
      "features": [
        "Sliding aluminium panels",
        "Perforated and optical sheets in many patterns",
        "Protection from sun, rain, snow and hail",
        "Light and privacy control",
        "Enhances the facade design",
        "Powder coating — any RAL"
      ],
      "applications": [
        "Contemporary residential",
        "Offices",
        "Hotels",
        "Loggias and terraces"
      ]
    },
    "image": "/catalog2026/alu-sn42.webp",
    "gallery": [
      "/catalog2026/alu-sn42.webp",
      "/catalog2026/alu-sn42-amb.webp",
      "/catalog2026/alu-sn42-amb2.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Struttura", "value": "Pannelli scorrevoli in alluminio verniciato", "note": "Verniciatura elettrostatica, qualsiasi colore RAL"}, "en": {"label": "Structure", "value": "Sliding powder-coated aluminium panels", "note": "Electrostatic coating, any RAL colour"}}, {"icon": "louvres", "it": {"label": "Regolazione della luce", "value": "Lamiere forate e ottiche in vari disegni", "note": "Controllo personalizzabile di luce e riservatezza"}, "en": {"label": "Light control", "value": "Perforated and optical sheets in many patterns", "note": "Customisable light and privacy control"}}, {"icon": "rain", "it": {"label": "Protezione da intemperie", "value": "Sole, pioggia, neve e grandine"}, "en": {"label": "Weather protection", "value": "Sun, rain, snow and hail"}}],
  },
  "asas-comp50": {
    "slug": "asas-comp50",
    "category": "alluminio-rivestimenti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/01_COMP50-554.pdf",
    "quickSpecs": {
      "profile": 90
    },
    "it": {
      "name": "COMP50",
      "tagline": "La sottostruttura per facciate in pannelli compositi.",
      "description": "COMP50 è la sottostruttura in alluminio per rivestimenti in pannelli compositi. È composta da profili a H e a F e si fissa all'edificio con ancoraggi in alluminio. Le fughe tra i pannelli possono essere chiuse con coprifuga in alluminio oppure con guarnizione, per un risultato pulito e duraturo.",
      "features": [
        "Larghezza profilo 90 mm",
        "Spessore parete 1,8 / 2 mm",
        "Per pannelli compositi da 4 mm",
        "Profili a H e a F",
        "Fughe con coprifuga in alluminio o guarnizione",
        "Fissaggio con ancoraggi in alluminio"
      ],
      "applications": [
        "Edifici commerciali",
        "Capannoni e showroom",
        "Uffici",
        "Riqualificazione di facciate"
      ]
    },
    "en": {
      "name": "COMP50",
      "tagline": "The substructure for composite panel façades.",
      "description": "COMP50 is an aluminium substructure for composite panel cladding. It comprises H-section and F-section profiles and is fixed to the building with aluminium brackets. The joints between panels can be closed with aluminium cover strips or with gaskets, for a clean and durable finish.",
      "features": [
        "Profile width 90 mm",
        "Wall thickness 1.8 / 2 mm",
        "For 4 mm composite panels",
        "H and F profiles",
        "Joints with aluminium cover or gasket",
        "Aluminium anchors"
      ],
      "applications": [
        "Commercial buildings",
        "Industrial showrooms",
        "Offices",
        "Facade refurbishment"
      ]
    },
    "image": "/catalog2026/alu-comp50.webp",
    "gallery": [
      "/catalog2026/alu-comp50.webp",
      "/catalog2026/alu-comp50-amb.webp",
      "/catalog2026/alu-comp50-amb2.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Struttura", "value": "Profili in alluminio a H e a F", "note": "Larghezza 90 mm, spessore parete 1,8 / 2 mm"}, "en": {"label": "Structure", "value": "H and F aluminium profiles", "note": "Width 90 mm, wall thickness 1.8 / 2 mm"}}, {"icon": "size", "it": {"label": "Compatibilità pannelli", "value": "Pannelli compositi da 4 mm"}, "en": {"label": "Panel compatibility", "value": "4 mm composite panels"}}, {"icon": "structure", "it": {"label": "Finitura delle fughe", "value": "Coprifuga in alluminio o guarnizione"}, "en": {"label": "Joint finishing", "value": "Aluminium cover or gasket"}}],
  },
  "asas-rtc22": {
    "slug": "asas-rtc22",
    "category": "alluminio-rivestimenti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/02_RTC22-553.pdf",
    "quickSpecs": {},
    "it": {
      "name": "RTC22",
      "tagline": "Il rivestimento in terracotta su sottostruttura in alluminio.",
      "description": "RTC22 è il sistema di rivestimento in terracotta con sottostruttura in alluminio: semplice da posare, resistente nel tempo e di grande effetto estetico. I dettagli elastici assorbono i movimenti dell'edificio e lavorano in piena armonia con strutture metalliche, serramenti e facciate. Si usa sia all'esterno sia all'interno.",
      "features": [
        "Spessore parete 1,8 / 2 / 2,2 mm",
        "Sottostruttura in alluminio per lastre in terracotta",
        "Dettagli elastici che assorbono i movimenti dell'edificio",
        "Compatibile con serramenti e facciate ASAŞ",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Edifici pubblici",
        "Residenziale di pregio",
        "Uffici",
        "Riqualificazione di facciate"
      ]
    },
    "en": {
      "name": "RTC22",
      "tagline": "Terracotta cladding on aluminium substructure.",
      "description": "RTC22 is a terracotta cladding system with aluminium substructure: simple to install, durable over time and highly aesthetic. The flexible details absorb building movement and work in full harmony with metal structures, windows and facades. Suitable for both external and internal use.",
      "features": [
        "Wall thickness 1.8 / 2 / 2.2 mm",
        "Aluminium substructure for terracotta tiles",
        "Flexible details for building movements",
        "Compatible with ASAŞ windows and facades",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Public buildings",
        "Premium residential",
        "Offices",
        "Facade refurbishment"
      ]
    },
    "image": "/catalog2026/alu-rtc22.webp",
    "gallery": [
      "/catalog2026/alu-rtc22.webp",
      "/catalog2026/alu-rtc22-amb.webp",
      "/catalog2026/alu-rtc22-amb2.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Struttura", "value": "Sottostruttura in alluminio per lastre in terracotta"}, "en": {"label": "Structure", "value": "Aluminium substructure for terracotta tiles"}}, {"icon": "depth", "it": {"label": "Spessore parete", "value": "1,8 / 2 / 2,2 mm"}, "en": {"label": "Wall thickness", "value": "1.8 / 2 / 2.2 mm"}}],
  },
  "asas-rtc22-plus": {
    "slug": "asas-rtc22-plus",
    "category": "alluminio-rivestimenti",
    "brochure": "/catalog2026/schede/ASAS_RTC22plus.pdf",
    "quickSpecs": {},
    "it": {
      "name": "RTC22+",
      "tagline": "Terracotta senza fughe visibili, per forme architettoniche libere.",
      "description": "RTC22+ è l'evoluzione del rivestimento in terracotta, pensata per le esigenze di progetto più attuali e per forme architettoniche flessibili. Le alette aggiunte al sistema chiudono lo spazio tra lastre e profilo portante, così la facciata appare continua e uniforme.",
      "features": [
        "Spessore parete 1,8 / 2 / 2,2 mm",
        "Alette di chiusura tra lastre e profilo portante",
        "Facciata continua senza vuoti visibili",
        "Adatto a forme architettoniche complesse",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Edifici di rappresentanza",
        "Residenziale di pregio",
        "Musei e cultura",
        "Uffici"
      ]
    },
    "en": {
      "name": "RTC22+",
      "tagline": "Seamless terracotta cladding for free-form architectural expression.",
      "description": "RTC22+ is an evolved terracotta cladding system designed for contemporary project requirements and flexible architectural forms. Added tabs close the space between panels and the supporting profile, creating a continuous, uniform façade appearance.",
      "features": [
        "Wall thickness 1.8 / 2 / 2.2 mm",
        "Tabs between tiles and carrier profile",
        "Seamless facade with no visible gaps",
        "Suits complex architectural forms",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Landmark buildings",
        "Premium residential",
        "Museums and culture",
        "Offices"
      ]
    },
    "image": "/catalog2026/alu-rtc22-plus.webp",
    "gallery": [
      "/catalog2026/alu-rtc22-plus.webp",
      "/catalog2026/alu-rtc22-plus-amb.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Estetica della facciata", "value": "Superficie continua senza giunti visibili", "note": "Alette di chiusura tra lastre e profilo portante"}, "en": {"label": "Facade aesthetics", "value": "Seamless surface with no visible joints", "note": "Closing tabs between tiles and carrier profile"}}, {"icon": "depth", "it": {"label": "Spessore parete", "value": "1,8 / 2 / 2,2 mm"}, "en": {"label": "Wall thickness", "value": "1.8 / 2 / 2.2 mm"}}],
  },
  "asas-rdp": {
    "slug": "asas-rdp",
    "category": "alluminio-rivestimenti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/03_RDP-552.pdf",
    "quickSpecs": {
      "profileMin": 150,
      "profileMax": 250
    },
    "it": {
      "name": "RDP",
      "tagline": "Doghe decorative in alluminio, a incastro e senza manutenzione.",
      "description": "RDP è il rivestimento a doghe in alluminio dall'aspetto decorativo, disponibile in diversi profili. Non richiede pittura e non si deforma nel tempo. Il sistema a incastro rende la posa modulare, rapida e semplice, sia in esterno sia in interno.",
      "features": [
        "Doghe da 150 / 250 mm",
        "Spessore parete 1,8 mm",
        "Sistema a incastro modulare",
        "Non richiede pittura, non si deforma",
        "Sottostruttura dedicata",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Facciate residenziali",
        "Negozi e showroom",
        "Controsoffitti e pareti interne",
        "Riqualificazione"
      ]
    },
    "en": {
      "name": "RDP",
      "tagline": "Decorative interlocking aluminium planks, maintenance-free.",
      "description": "RDP is an aluminium plank cladding with a decorative appearance, available in various profiles. It requires no painting and does not deform over time. The interlocking system makes installation modular, quick and simple, both externally and internally.",
      "features": [
        "Planks 150 / 250 mm",
        "Wall thickness 1.8 mm",
        "Modular interlocking system",
        "No painting, no deformation",
        "Dedicated substructure",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Residential facades",
        "Shops and showrooms",
        "Ceilings and interior walls",
        "Refurbishment"
      ]
    },
    "image": "/catalog2026/alu-rdp.webp",
    "gallery": [
      "/catalog2026/alu-rdp.webp",
      "/catalog2026/alu-rdp-amb.webp",
      "/catalog2026/alu-rdp-amb2.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Materiale", "value": "Alluminio", "note": "Non richiede pittura e non si deforma nel tempo"}, "en": {"label": "Material", "value": "Aluminium", "note": "No painting required, no deformation over time"}}, {"icon": "size", "it": {"label": "Dimensioni doghe", "value": "150 / 250 mm"}, "en": {"label": "Plank sizes", "value": "150 / 250 mm"}}, {"icon": "structure", "it": {"label": "Sistema di montaggio", "value": "Incastro modulare", "note": "Posa rapida e semplice"}, "en": {"label": "Installation system", "value": "Modular interlocking", "note": "Quick and easy installation"}}],
  },
  "asas-rdm50": {
    "slug": "asas-rdm50",
    "category": "alluminio-rivestimenti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/05_RDM50-550.pdf",
    "quickSpecs": {
      "profile": 50
    },
    "it": {
      "name": "RDM50",
      "tagline": "Lamelle verticali decorative per facciate in movimento.",
      "description": "RDM50 è il rivestimento a lamelle verticali in alluminio che dà ritmo e movimento alla facciata. Le lamelle, larghe 50 mm e disponibili in diverse profondità, si agganciano a un profilo portante. Si può scegliere tra linee arrotondate o squadrate e superfici rigate, all'esterno come all'interno.",
      "features": [
        "Lamelle larghe 50 mm in diverse profondità",
        "Profilo portante con lamelle a innesto",
        "Linee arrotondate o squadrate",
        "Finitura liscia o rigata",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Facciate di uffici",
        "Negozi e showroom",
        "Hall e reception",
        "Residenziale contemporaneo"
      ]
    },
    "en": {
      "name": "RDM50",
      "tagline": "Vertical aluminium fins that bring rhythm and movement to facades.",
      "description": "RDM50 is a vertical fin cladding system in aluminium that brings rhythm and movement to the facade. The 50 mm wide fins, available in various depths, clip onto a carrier profile. Choose between rounded or angular profiles and ribbed surfaces, for both exterior and interior applications.",
      "features": [
        "50 mm fins in different depths",
        "Carrier profile with clip-on fins",
        "Oval or angular lines",
        "Smooth or ribbed finish",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Office facades",
        "Shops and showrooms",
        "Lobbies and receptions",
        "Contemporary residential"
      ]
    },
    "image": "/catalog2026/alu-rdm50.webp",
    "gallery": [
      "/catalog2026/alu-rdm50.webp",
      "/catalog2026/alu-rdm50-amb.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Larghezza lamelle", "value": "50 mm", "note": "Disponibili in diverse profondità"}, "en": {"label": "Fin width", "value": "50 mm", "note": "Available in different depths"}}, {"icon": "size", "it": {"label": "Design e finitura", "value": "Linee arrotondate o squadrate, superficie liscia o rigata"}, "en": {"label": "Design and finish", "value": "Oval or angular lines, smooth or ribbed surface"}}, {"icon": "structure", "it": {"label": "Installazione", "value": "Sistema a innesto su profilo portante"}, "en": {"label": "Installation", "value": "Clip-on system on carrier profile"}}],
  },
  "asas-skypanel": {
    "slug": "asas-skypanel",
    "category": "alluminio-rivestimenti",
    "brochure": "/catalog2026/schede/ASAS_SkyPanel_RESP23.pdf",
    "quickSpecs": {},
    "it": {
      "name": "Sky Panel",
      "tagline": "Lastre in alluminio incombustibili, anche forate e in 3D.",
      "description": "Sky Panel è il rivestimento di facciata ventilata con lastre in alluminio da 2 e 3 mm, incombustibili in classe A1/A2. Comprende molte varianti per facciate creative: disegni 3D, lamiere forate e ottiche. La versione RESP23 Ombrae usa fori inclinati che creano giochi di ombra e riflessi, rendendo tridimensionale il disegno scelto.",
      "features": [
        "Lastre in alluminio da 2 / 3 mm",
        "Classe di reazione al fuoco A1 / A2",
        "Lastre fino a 1500 × 3000 mm",
        "Leghe 5005, 3105, 5754",
        "Varianti forate, ottiche e in 3D",
        "RESP23 Ombrae: effetto 3D con fori inclinati"
      ],
      "applications": [
        "Edifici alti",
        "Edifici pubblici",
        "Centri commerciali",
        "Facciate d'autore"
      ]
    },
    "en": {
      "name": "Sky Panel",
      "tagline": "Non-combustible aluminium panels, including perforated and three-dimensional designs.",
      "description": "Sky Panel is a ventilated facade cladding system with 2 mm and 3 mm aluminium panels, non-combustible to class A1/A2. It includes numerous variants for creative facades: three-dimensional patterns, perforated sheets and optical effects. The RESP23 Ombrae version uses angled perforations that create shadow play and reflections, giving depth to the chosen design.",
      "features": [
        "2 / 3 mm aluminium sheets",
        "Fire class A1 / A2",
        "Sheets up to 1500 × 3000 mm",
        "Alloys 5005, 3105, 5754",
        "Perforated, optical and 3D variants",
        "RESP23 Ombrae: 3D effect with angled holes"
      ],
      "applications": [
        "High-rise buildings",
        "Public buildings",
        "Shopping centres",
        "Signature facades"
      ]
    },
    "image": "/catalog2026/alu-skypanel.webp",
    "gallery": [
      "/catalog2026/alu-skypanel.webp",
      "/catalog2026/alu-skypanel-amb.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Materiale e spessore", "value": "Lastre in alluminio 2 / 3 mm", "note": "Leghe 5005, 3105, 5754"}, "en": {"label": "Material and thickness", "value": "Aluminium sheets 2 / 3 mm", "note": "Alloys 5005, 3105, 5754"}}, {"icon": "security", "it": {"label": "Reazione al fuoco", "value": "Classe A1 / A2", "note": "Materiale incombustibile certificato"}, "en": {"label": "Fire reaction", "value": "Class A1 / A2", "note": "Certified non-combustible material"}}, {"icon": "size", "it": {"label": "Dimensioni massime", "value": "fino a 1500 × 3000 mm"}, "en": {"label": "Maximum dimensions", "value": "up to 1500 × 3000 mm"}}, {"icon": "structure", "it": {"label": "Varianti estetiche", "value": "Forate, ottiche e in 3D", "note": "RESP23 Ombrae con fori inclinati per effetti tridimensionali"}, "en": {"label": "Aesthetic variants", "value": "Perforated, optical and 3D", "note": "RESP23 Ombrae with angled holes for 3D effects"}}],
  },
  "asas-rsp22": {
    "slug": "asas-rsp22",
    "category": "alluminio-rivestimenti",
    "brochure": "/catalog2026/schede/ASAS_Skynova_RSP22.pdf",
    "quickSpecs": {},
    "it": {
      "name": "Skynova RSP22",
      "tagline": "Rivestimento a incastro senza fughe, in tante forme.",
      "description": "Skynova RSP22 è un rivestimento decorativo da 22 mm di profondità con sistema a incastro: non ha fughe e mantiene un ritmo continuo su tutta la facciata. Rispetto ad altri rivestimenti si distingue per la posa semplice e l'elevata resistenza al fuoco (classe A1/A2). È disponibile con profili triangolari, a onda, a mezzo esagono e a mattoncino in varie misure.",
      "features": [
        "Profondità 22 mm",
        "Sistema a incastro senza fughe",
        "Classe di reazione al fuoco A1 / A2",
        "Profili triangolari, a onda, a mezzo esagono, a mattoncino",
        "Posa semplice e rapida"
      ],
      "applications": [
        "Facciate residenziali",
        "Uffici",
        "Negozi",
        "Riqualificazione"
      ]
    },
    "en": {
      "name": "Skynova RSP22",
      "tagline": "Jointless interlocking cladding in a range of profiles.",
      "description": "Skynova RSP22 is a 22 mm deep decorative cladding system with an interlocking joint: it has no visible joints and maintains a continuous rhythm across the entire facade. Compared to other cladding systems, it is distinguished by straightforward installation and high fire resistance (class A1/A2). Available in triangular, wave, half-hexagon and brick profiles in various sizes.",
      "features": [
        "22 mm depth",
        "Jointless interlocking system",
        "Fire class A1 / A2",
        "Triangular, wave, half-hexagon, brick profiles",
        "Quick, easy installation"
      ],
      "applications": [
        "Residential facades",
        "Offices",
        "Shops",
        "Refurbishment"
      ]
    },
    "image": "/catalog2026/alu-rsp22.webp",
    "gallery": [
      "/catalog2026/alu-rsp22.webp",
      "/catalog2026/alu-rsp22-amb.webp"
    ],
    highlights: [{"icon": "depth", "it": {"label": "Profondità del rivestimento", "value": "22 mm"}, "en": {"label": "Cladding depth", "value": "22 mm"}}, {"icon": "structure", "it": {"label": "Sistema di montaggio", "value": "A incastro senza fughe", "note": "Mantiene un ritmo continuo su tutta la facciata"}, "en": {"label": "Installation system", "value": "Jointless interlocking", "note": "Maintains continuous rhythm across the entire facade"}}, {"icon": "security", "it": {"label": "Resistenza al fuoco", "value": "Classe A1 / A2", "note": "Classe di reazione al fuoco certificata"}, "en": {"label": "Fire resistance", "value": "Class A1 / A2", "note": "Certified fire reaction class"}}],
  },
  "asas-rpc40": {
    "slug": "asas-rpc40",
    "category": "alluminio-rivestimenti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/25_RPC40_KATALOG-568.pdf",
    "quickSpecs": {},
    "it": {
      "name": "Skynova RPC40",
      "tagline": "L'effetto di un rivestimento a tubolari 40×40, senza fughe.",
      "description": "Skynova RPC40 è un rivestimento a incastro da 40 mm di profondità, senza fughe, che riproduce il ritmo di tubolari 40×40 mm. È ideale per edifici bassi, hall d'ingresso e pareti cieche di giardini e verande. Come tutta la linea Skynova, si posa facilmente e offre un'elevata resistenza al fuoco (classe A1/A2).",
      "features": [
        "Profondità 40 mm",
        "Effetto tubolare 40 × 40 mm",
        "Sistema a incastro senza fughe",
        "Classe di reazione al fuoco A1 / A2",
        "Posa semplice e rapida"
      ],
      "applications": [
        "Hall d'ingresso",
        "Ville e residenze",
        "Giardini e verande",
        "Negozi"
      ]
    },
    "en": {
      "name": "Skynova RPC40",
      "tagline": "The appearance of 40×40 mm box-section cladding, without joints.",
      "description": "Skynova RPC40 is a 40 mm deep interlocking cladding system, without joints, that reproduces the rhythm of 40×40 mm box sections. It is ideal for low-rise buildings, entrance halls and solid garden and veranda walls. Like the entire Skynova range, it installs easily and offers high fire resistance (class A1/A2).",
      "features": [
        "40 mm depth",
        "40 × 40 mm box-profile look",
        "Jointless interlocking system",
        "Fire class A1 / A2",
        "Quick, easy installation"
      ],
      "applications": [
        "Entrance lobbies",
        "Villas and residences",
        "Gardens and verandas",
        "Shops"
      ]
    },
    "image": "/catalog2026/alu-rpc40.webp",
    "gallery": [
      "/catalog2026/alu-rpc40.webp",
      "/catalog2026/alu-rpc40-amb.webp"
    ],
    highlights: [{"icon": "depth", "it": {"label": "Profondità del profilo", "value": "40 mm"}, "en": {"label": "Profile depth", "value": "40 mm"}}, {"icon": "structure", "it": {"label": "Sistema di posa", "value": "Incastro senza fughe", "note": "Effetto tubolare 40×40 mm"}, "en": {"label": "Installation system", "value": "Jointless interlocking", "note": "40×40 mm box-profile look"}}, {"icon": "security", "it": {"label": "Resistenza al fuoco", "value": "Classe A1 / A2"}, "en": {"label": "Fire resistance", "value": "Class A1 / A2"}}],
  },
  "asas-rb90": {
    "slug": "asas-rb90",
    "category": "alluminio-parapetti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/15_RB90-525.pdf",
    "quickSpecs": {
      "glass": 16
    },
    "it": {
      "name": "RB90",
      "tagline": "Parapetto in vetro con base in alluminio, regolabile.",
      "description": "RB90 è il parapetto in vetro con profilo di base in alluminio da 90 mm. Permette di inclinare il vetro verso l'interno o l'esterno grazie a una regolazione di 50 mm, così la posa resta precisa anche su supporti non perfetti. Sono disponibili diversi tipi di copertura e si usa sia all'esterno sia all'interno.",
      "features": [
        "Profilo 90 × 90 mm",
        "Vetro stratificato fino a 8+8 mm",
        "Carico 100 kg/m — prova ASTM E 935 1 kN/m²",
        "Regolazione dell'inclinazione fino a 50 mm",
        "Diversi tipi di copertura",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Balconi e terrazzi",
        "Scale e soppalchi",
        "Hall e uffici",
        "Bordi piscina"
      ]
    },
    "en": {
      "name": "RB90",
      "tagline": "Glass balustrade with adjustable aluminium base profile.",
      "description": "RB90 is a glass balustrade with a 90 mm aluminium base profile. It allows the glazing to be angled inwards or outwards with 50 mm adjustment, ensuring accurate installation even on imperfect substrates. Various cover options are available, and it is suitable for both exterior and interior use.",
      "features": [
        "Profile 90 × 90 mm",
        "Laminated glass up to 8+8 mm",
        "Load 100 kg/m — ASTM E 935 1 kN/m²",
        "Inclination adjustment up to 50 mm",
        "Different cover options",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Balconies and terraces",
        "Stairs and mezzanines",
        "Lobbies and offices",
        "Pool edges"
      ]
    },
    "image": "/catalog2026/alu-rb90.webp",
    "gallery": [
      "/catalog2026/alu-rb90.webp",
      "/catalog2026/alu-rb90-amb.webp",
      "/catalog2026/alu-rb90-amb2.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "Vetro stratificato fino a 8+8 mm"}, "en": {"label": "Glazing", "value": "Laminated glass up to 8+8 mm"}}, {"icon": "security", "it": {"label": "Resistenza ai carichi", "value": "100 kg/m — prova ASTM E 935 1 kN/m²"}, "en": {"label": "Load resistance", "value": "100 kg/m — ASTM E 935 1 kN/m²"}}, {"icon": "structure", "it": {"label": "Profilo di base", "value": "90 × 90 mm", "note": "Regolazione dell'inclinazione fino a 50 mm"}, "en": {"label": "Base profile", "value": "90 × 90 mm", "note": "Inclination adjustment up to 50 mm"}}, {"icon": "size", "it": {"label": "Versatilità di installazione", "value": "Uso interno ed esterno", "note": "Diversi tipi di copertura disponibili"}, "en": {"label": "Installation versatility", "value": "Indoor and outdoor use", "note": "Different cover options available"}}],
  },
  "asas-rb120": {
    "slug": "asas-rb120",
    "category": "alluminio-parapetti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/16_RB120-524.pdf",
    "quickSpecs": {
      "glass": 20
    },
    "it": {
      "name": "RB120",
      "tagline": "Il parapetto in vetro per carichi maggiori.",
      "description": "RB120 è la versione rinforzata del parapetto in vetro: il profilo di base da 120 mm accoglie vetri stratificati fino a 10+10 mm e sostiene 150 kg/m. Mantiene la regolazione di 50 mm per inclinare il vetro e le diverse coperture disponibili, ideale per edifici pubblici, terrazzi ampi e luoghi molto frequentati.",
      "features": [
        "Profilo 120 × 90 mm",
        "Vetro stratificato fino a 10+10 mm",
        "Carico 150 kg/m — prova ASTM E 935 1,5 kN/m²",
        "Regolazione dell'inclinazione fino a 50 mm",
        "Diversi tipi di copertura",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Edifici pubblici",
        "Centri commerciali",
        "Terrazzi panoramici",
        "Hotel"
      ]
    },
    "en": {
      "name": "RB120",
      "tagline": "The glass balustrade for higher loads.",
      "description": "RB120 is the reinforced version of the glass balustrade: the 120 mm base profile accommodates laminated glass up to 10+10 mm and supports 150 kg/m. It retains the 50 mm adjustment to angle the glass and the various cover options available, ideal for public buildings, large terraces and high-traffic areas.",
      "features": [
        "Profile 120 × 90 mm",
        "Laminated glass up to 10+10 mm",
        "Load 150 kg/m — ASTM E 935 1.5 kN/m²",
        "Inclination adjustment up to 50 mm",
        "Different cover options",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Public buildings",
        "Shopping centres",
        "Panoramic terraces",
        "Hotels"
      ]
    },
    "image": "/catalog2026/alu-rb120.webp",
    "gallery": [
      "/catalog2026/alu-rb120.webp",
      "/catalog2026/alu-rb120-amb.webp",
      "/catalog2026/alu-rb120-amb2.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 10+10 mm stratificato"}, "en": {"label": "Glazing", "value": "up to 10+10 mm laminated"}}, {"icon": "security", "it": {"label": "Capacità di carico", "value": "150 kg/m", "note": "Testato secondo ASTM E 935 a 1,5 kN/m²"}, "en": {"label": "Load capacity", "value": "150 kg/m", "note": "Tested to ASTM E 935 at 1.5 kN/m²"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "120 mm"}, "en": {"label": "Profile depth", "value": "120 mm"}}, {"icon": "structure", "it": {"label": "Regolazione inclinazione", "value": "fino a 50 mm", "note": "Per adattamento al piano di posa"}, "en": {"label": "Inclination adjustment", "value": "up to 50 mm", "note": "For adaptation to the installation plane"}}],
  },
  "asas-rbsl65": {
    "slug": "asas-rbsl65",
    "category": "alluminio-parapetti",
    "brochure": "/catalog2026/schede/ASAS_RBSL65.pdf",
    "quickSpecs": {
      "glass": 17.5
    },
    "it": {
      "name": "RBSL65",
      "tagline": "Il parapetto in vetro slim, essenziale e facile da montare.",
      "description": "RBSL65 è il parapetto in vetro dal profilo sottile, senza copertura: il vetro emerge pulito dalla base per un look minimale e moderno. I nuovi accessori rendono il montaggio del vetro semplice e veloce.",
      "features": [
        "Profilo largo 65 mm — altezza 90–120 mm",
        "Vetro fino a 17,5 mm",
        "Design slim senza copertura",
        "Nuovi accessori per un montaggio rapido del vetro",
        "Uso interno ed esterno"
      ],
      "applications": [
        "Balconi residenziali",
        "Terrazzi",
        "Scale interne",
        "Negozi e uffici"
      ]
    },
    "en": {
      "name": "RBSL65",
      "tagline": "The slim glass balustrade: minimal, clean and easy to install.",
      "description": "RBSL65 is a slim-profile glass balustrade without a cap rail: the glass emerges cleanly from the base channel for a minimal, contemporary appearance. New accessories make glazing installation simple and quick.",
      "features": [
        "Profile width 65 mm — height 90–120 mm",
        "Glass up to 17.5 mm",
        "Slim cap-free design",
        "New accessories for fast glazing",
        "Indoor and outdoor use"
      ],
      "applications": [
        "Residential balconies",
        "Terraces",
        "Interior stairs",
        "Shops and offices"
      ]
    },
    "image": "/catalog2026/alu-rbsl65.webp",
    "gallery": [
      "/catalog2026/alu-rbsl65.webp",
      "/catalog2026/alu-rbsl65-amb.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 17,5 mm"}, "en": {"label": "Glazing", "value": "up to 17.5 mm"}}, {"icon": "structure", "it": {"label": "Design", "value": "Profilo sottile senza copertura", "note": "Look minimale e moderno con vetro a filo"}, "en": {"label": "Design", "value": "Slim cap-free profile", "note": "Minimalist modern look with flush glass"}}, {"icon": "size", "it": {"label": "Dimensioni profilo", "value": "Larghezza 65 mm — Altezza 90–120 mm"}, "en": {"label": "Profile dimensions", "value": "Width 65 mm — Height 90–120 mm"}}],
  },
  "asas-rejb50": {
    "slug": "asas-rejb50",
    "category": "alluminio-parapetti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/05_REJB50-535.pdf",
    "quickSpecs": {
      "profile": 50
    },
    "it": {
      "name": "REJB50",
      "tagline": "Il parapetto in vetro davanti alla portafinestra (balcone alla francese).",
      "description": "REJB50 crea una protezione in vetro davanti a porte e finestre, il classico balcone alla francese. Si fissa direttamente al telaio del serramento oppure alla muratura, ma il montaggio sul telaio è il più pratico. Va usato con vetro di sicurezza temprato e stratificato e supera la prova di urto da 600 J.",
      "features": [
        "Larghezza profilo 50 mm — profondità 30,5–38,5 mm",
        "Vetro stratificato 10,76 / 12,76 / 16,76 / 20,76 mm",
        "Vetro largo 500–1400 mm, alto 800–1200 mm",
        "Prova di urto 600 J (NF P 01-013)",
        "Fissaggio al telaio o alla muratura"
      ],
      "applications": [
        "Portefinestre senza balcone",
        "Residenziale urbano",
        "Hotel",
        "Ristrutturazioni"
      ]
    },
    "en": {
      "name": "REJB50",
      "tagline": "Glass balustrade for French windows and Juliet balconies.",
      "description": "REJB50 creates a glass safety barrier in front of windows and doors, the classic Juliet balcony. It can be fixed directly to the window frame or to the masonry, though frame mounting is more practical. Must be used with tempered laminated safety glass and withstands impact testing at 600 J.",
      "features": [
        "Profile width 50 mm — depth 30.5–38.5 mm",
        "Laminated glass 10.76 / 12.76 / 16.76 / 20.76 mm",
        "Glass width 500–1400 mm, height 800–1200 mm",
        "Impact test 600 J (NF P 01-013)",
        "Frame or wall mounting"
      ],
      "applications": [
        "French windows without balcony",
        "Urban residential",
        "Hotels",
        "Renovations"
      ]
    },
    "image": "/catalog2026/alu-rejb50.webp",
    "gallery": [
      "/catalog2026/alu-rejb50.webp",
      "/catalog2026/alu-rejb50-amb.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura di sicurezza", "value": "Vetro stratificato 10,76–20,76 mm", "note": "Temperato e stratificato"}, "en": {"label": "Safety glazing", "value": "Laminated glass 10.76–20.76 mm", "note": "Tempered and laminated"}}, {"icon": "security", "it": {"label": "Sicurezza certificata", "value": "Prova di urto 600 J", "note": "Conforme a NF P 01-013"}, "en": {"label": "Certified safety", "value": "Impact test 600 J", "note": "Compliant with NF P 01-013"}}, {"icon": "size", "it": {"label": "Dimensioni vetro", "value": "Larghezza 500–1400 mm, altezza 800–1200 mm"}, "en": {"label": "Glass dimensions", "value": "Width 500–1400 mm, height 800–1200 mm"}}, {"icon": "structure", "it": {"label": "Fissaggio", "value": "Al telaio o alla muratura", "note": "Montaggio su telaio consigliato per praticità"}, "en": {"label": "Mounting", "value": "Frame or wall mounting", "note": "Frame mounting recommended for ease"}}],
  },
  "asas-rfg46": {
    "slug": "asas-rfg46",
    "category": "alluminio-parapetti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/09_RFG46-531.pdf",
    "quickSpecs": {
      "glass": 10
    },
    "it": {
      "name": "RFG46",
      "tagline": "La vetrata a pacchetto che trasforma il balcone in una stanza in più.",
      "description": "RFG46 è la vetrata per balconi a pacchetto: chiude il balcone e lo rende parte della casa, ma si apre completamente quando serve. Accoglie vetri temprati da 8 o 10 mm, gira negli angoli a 90°, 135°, 162° e 180° e offre ruote in PVC o in metallo e diversi accessori.",
      "features": [
        "Spessore parete 1,8 mm",
        "Vetro temprato 8 / 10 mm",
        "Angoli a 90°, 135°, 162° e 180°",
        "Ruote in PVC o in metallo",
        "Guarnizioni a spazzolino",
        "Ante impacchettabili per aprire tutto"
      ],
      "applications": [
        "Balconi",
        "Verande",
        "Terrazzi",
        "Bar e ristoranti"
      ]
    },
    "en": {
      "name": "RFG46",
      "tagline": "The folding glazing system that transforms your balcony into extra space.",
      "description": "RFG46 is a folding glazing system for balconies: it encloses the balcony and makes it part of the home, yet opens completely when needed. It accommodates 8 or 10 mm tempered glass, turns corners at 90°, 135°, 162° and 180°, and offers PVC or metal rollers and various accessories.",
      "features": [
        "Wall thickness 1.8 mm",
        "Tempered glass 8 / 10 mm",
        "Corners at 90°, 135°, 162° and 180°",
        "PVC or metal wheels",
        "Brush gaskets",
        "Fully stackable panels"
      ],
      "applications": [
        "Balconies",
        "Verandas",
        "Terraces",
        "Bars and restaurants"
      ]
    },
    "image": "/catalog2026/alu-rfg46.webp",
    "gallery": [
      "/catalog2026/alu-rfg46.webp",
      "/catalog2026/alu-rfg46-amb.webp",
      "/catalog2026/alu-rfg46-amb2.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "Vetro temprato 8 o 10 mm"}, "en": {"label": "Glazing", "value": "Tempered glass 8 or 10 mm"}}, {"icon": "opening", "it": {"label": "Apertura totale", "value": "Ante impacchettabili", "note": "Sistema a pacchetto: si apre completamente quando serve"}, "en": {"label": "Full opening", "value": "Fully stackable panels", "note": "Stacking system: opens completely when needed"}}, {"icon": "structure", "it": {"label": "Configurazione angoli", "value": "90°, 135°, 162° e 180°", "note": "Adattabile a diverse geometrie di balcone"}, "en": {"label": "Corner configuration", "value": "90°, 135°, 162° and 180°", "note": "Adaptable to different balcony geometries"}}, {"icon": "opening", "it": {"label": "Ruote di scorrimento", "value": "In PVC o in metallo", "note": "Diverse opzioni disponibili per il movimento"}, "en": {"label": "Sliding wheels", "value": "PVC or metal", "note": "Different options available for movement"}}],
  },
  "asas-rfg46-plus": {
    "slug": "asas-rfg46-plus",
    "category": "alluminio-parapetti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/10_RFG46plus-556.pdf",
    "quickSpecs": {
      "glass": 24
    },
    "it": {
      "name": "RFG46+",
      "tagline": "La vetrata a pacchetto con vetrocamera, più isolata.",
      "description": "RFG46+ porta la vetrata a pacchetto a un livello superiore: guarnizioni ad alte prestazioni e vetrocamera 4+16+4 mm migliorano isolamento e tenuta. Mantiene gli angoli inclinati, le ruote in PVC o in metallo e può avere la maniglia a cremonese.",
      "features": [
        "Spessore parete 1,8 mm",
        "Vetrocamera 4+16+4 mm (fino a 24 mm)",
        "Guarnizioni ad alte prestazioni",
        "Angoli a 90° e inclinati",
        "Ruote in PVC o in metallo",
        "Maniglia a cremonese disponibile"
      ],
      "applications": [
        "Verande abitabili",
        "Balconi chiusi tutto l'anno",
        "Giardini d'inverno",
        "Ristoranti"
      ]
    },
    "en": {
      "name": "RFG46+",
      "tagline": "The most insulated folding glass system with double glazing.",
      "description": "RFG46+ takes the folding glass system to a higher level: high-performance gaskets and 4+16+4 mm double glazing improve insulation and sealing. It retains the angled corners, PVC or metal wheels, and can be fitted with an espagnolette handle.",
      "features": [
        "Wall thickness 1.8 mm",
        "Double glazing 4+16+4 mm (up to 24 mm)",
        "High-performance gaskets",
        "90° and angled corners",
        "PVC or metal wheels",
        "Espagnolette handle available"
      ],
      "applications": [
        "Year-round verandas",
        "Enclosed balconies",
        "Winter gardens",
        "Restaurants"
      ]
    },
    "image": "/catalog2026/alu-rfg46-plus.webp",
    "gallery": [
      "/catalog2026/alu-rfg46-plus.webp",
      "/catalog2026/alu-rfg46-plus-amb.webp",
      "/catalog2026/alu-rfg46-plus-amb2.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "Vetrocamera 4+16+4 mm", "note": "Fino a 24 mm di spessore"}, "en": {"label": "Glazing", "value": "Double glazing 4+16+4 mm", "note": "Up to 24 mm thickness"}}, {"icon": "opening", "it": {"label": "Sistema di apertura", "value": "Vetrata a pacchetto scorrevole"}, "en": {"label": "Opening system", "value": "Sliding folding glass system"}}, {"icon": "structure", "it": {"label": "Configurazione angoli", "value": "90° e inclinati", "note": "Flessibilità di installazione per diverse geometrie"}, "en": {"label": "Corner configuration", "value": "90° and angled", "note": "Installation flexibility for different geometries"}}],
  },
  "asas-rsg104": {
    "slug": "asas-rsg104",
    "category": "alluminio-parapetti",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/11_RSG104-529.pdf",
    "quickSpecs": {
      "glass": 24
    },
    "it": {
      "name": "RSG104",
      "tagline": "La vetrata scorrevole per balconi, fino a 5 ante.",
      "description": "RSG104 è la vetrata scorrevole per balconi, verande e dehors. Monta vetri da 8 o 10 mm e scorre fluida grazie a ruote speciali, con apertura fino a 5 ante, con o senza soglia. La versione RSG104+ accoglie la vetrocamera da 24 mm per un isolamento migliore.",
      "features": [
        "Spessore parete 1,8 mm",
        "Vetro 8 / 10 mm — vetrocamera 24 mm (RSG104+)",
        "Fino a 5 ante scorrevoli",
        "Con o senza soglia",
        "Ruote speciali per uno scorrimento fluido",
        "Angoli a 90° e inclinati"
      ],
      "applications": [
        "Balconi",
        "Giardini d'inverno",
        "Ristoranti e dehors",
        "Verande"
      ]
    },
    "en": {
      "name": "RSG104",
      "tagline": "Sliding balcony glazing system, up to five panels.",
      "description": "RSG104 is a sliding glazing system for balconies, verandas and outdoor areas. It accommodates 8 mm or 10 mm glass and runs smoothly on special wheels, with configurations up to five panels, with or without threshold. The RSG104+ version accepts 24 mm insulating glazing for improved thermal performance.",
      "features": [
        "Wall thickness 1.8 mm",
        "Glass 8 / 10 mm — 24 mm double glazing (RSG104+)",
        "Up to 5 sliding panels",
        "With or without threshold",
        "Special wheels for smooth sliding",
        "90° and angled corners"
      ],
      "applications": [
        "Balconies",
        "Conservatories",
        "Restaurants and terraces",
        "Verandas"
      ]
    },
    "image": "/catalog2026/alu-rsg104.webp",
    "gallery": [
      "/catalog2026/alu-rsg104.webp",
      "/catalog2026/alu-rsg104-amb.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 24 mm", "note": "Vetro singolo 8/10 mm o vetrocamera 24 mm (RSG104+)"}, "en": {"label": "Glazing", "value": "up to 24 mm", "note": "Single glass 8/10 mm or double glazing 24 mm (RSG104+)"}}, {"icon": "opening", "it": {"label": "Configurazione", "value": "Fino a 5 ante scorrevoli"}, "en": {"label": "Configuration", "value": "Up to 5 sliding panels"}}, {"icon": "structure", "it": {"label": "Soglia", "value": "Con o senza soglia", "note": "Configurabile in base alle esigenze"}, "en": {"label": "Threshold", "value": "With or without threshold", "note": "Configurable according to needs"}}, {"icon": "opening", "it": {"label": "Scorrimento", "value": "Ruote speciali per scorrimento fluido"}, "en": {"label": "Sliding", "value": "Special wheels for smooth sliding"}}],
  },
  "asas-rd55": {
    "slug": "asas-rd55",
    "category": "alluminio-pareti-ufficio",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/06_RD55-534.pdf",
    "quickSpecs": {},
    "it": {
      "name": "RD55",
      "tagline": "La porta per interni che si adatta allo spessore del muro.",
      "description": "RD55 è la porta in alluminio per interni, igienica e dall'aspetto curato, pensata per uffici e ambienti di lavoro. Il telaio regolabile si adatta a muri da 85 a 240 mm (da 100 a 210 mm nella versione RD55+) e accoglie ante in legno o in vetro, con diverse soluzioni di montaggio.",
      "features": [
        "Spessore parete 1,6 / 2 mm",
        "Muri da 85 a 240 mm (RD55+: 100–210 mm)",
        "Telaio regolabile in base al muro",
        "Ante in legno o in vetro",
        "Senza taglio termico — per interni",
        "Superfici igieniche e facili da pulire"
      ],
      "applications": [
        "Uffici",
        "Studi medici e cliniche",
        "Scuole",
        "Hotel"
      ]
    },
    "en": {
      "name": "RD55",
      "tagline": "The interior door that adapts to wall thickness.",
      "description": "RD55 is an aluminium interior door system, hygienic and refined in appearance, designed for offices and workplaces. The adjustable frame accommodates walls from 85 to 240 mm (100 to 210 mm in the RD55+ version) and accepts timber or glass leaves, with various installation solutions.",
      "features": [
        "Wall thickness 1.6 / 2 mm",
        "Walls from 85 to 240 mm (RD55+: 100–210 mm)",
        "Adjustable frame",
        "Wooden or glass leaves",
        "Non-insulated — for interiors",
        "Hygienic, easy-clean surfaces"
      ],
      "applications": [
        "Offices",
        "Clinics",
        "Schools",
        "Hotels"
      ]
    },
    "image": "/catalog2026/alu-rd55.webp",
    "gallery": [
      "/catalog2026/alu-rd55.webp",
      "/catalog2026/alu-rd55-amb.webp"
    ],
    highlights: [{"icon": "structure", "it": {"label": "Materiale", "value": "Alluminio per interni", "note": "Superfici igieniche e facili da pulire"}, "en": {"label": "Material", "value": "Aluminium for interiors", "note": "Hygienic, easy-clean surfaces"}}, {"icon": "size", "it": {"label": "Adattabilità al muro", "value": "Muri da 85 a 240 mm", "note": "Telaio regolabile (RD55+: 100–210 mm)"}, "en": {"label": "Wall adaptability", "value": "Walls from 85 to 240 mm", "note": "Adjustable frame (RD55+: 100–210 mm)"}}, {"icon": "glass", "it": {"label": "Tipologie di anta", "value": "Legno o vetro"}, "en": {"label": "Leaf types", "value": "Wooden or glass"}}],
  },
  "asas-ro26": {
    "slug": "asas-ro26",
    "category": "alluminio-pareti-ufficio",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/04_RO26-536.pdf",
    "quickSpecs": {
      "glass": 10.76
    },
    "it": {
      "name": "RO26",
      "tagline": "La parete divisoria a vetro singolo, trasparenza senza interruzioni.",
      "description": "RO26 è la parete divisoria a vetro singolo per uffici open space. Con un telaio di soli 26 × 33 mm e giunti vetro-vetro, le pareti risultano continue e luminose. I canali passacavi nascondono i cavi di luci e postazioni; sono disponibili pannelli e porte in legno, oltre a porte in vetro con o senza telaio.",
      "features": [
        "Telaio 26 × 33 mm",
        "Vetro singolo o stratificato 8,76 / 10 / 10,76 mm",
        "Giunto vetro-vetro — vista continua",
        "Telaio a U o con fermavetro",
        "Angoli a 90°",
        "Canali passacavi integrati",
        "Porte in vetro o legno, con o senza telaio"
      ],
      "applications": [
        "Uffici open space",
        "Sale riunioni",
        "Banche e studi professionali",
        "Coworking"
      ]
    },
    "en": {
      "name": "RO26",
      "tagline": "Single-glazed partition wall: uninterrupted transparency.",
      "description": "RO26 is a single-glazed partition wall for open-plan offices. With a slender 26 × 33 mm frame and glass-to-glass joints, the partitions remain continuous and light-filled. Integrated cable channels conceal wiring for lighting and workstations; wooden panels and doors are available, as well as framed or frameless glazed doors.",
      "features": [
        "Frame 26 × 33 mm",
        "Single or laminated glass 8.76 / 10 / 10.76 mm",
        "Glass-to-glass joint — continuous view",
        "U frame or beaded frame",
        "90° corners",
        "Integrated cable channels",
        "Glass or wooden doors, framed or frameless"
      ],
      "applications": [
        "Open-plan offices",
        "Meeting rooms",
        "Banks and practices",
        "Coworking"
      ]
    },
    "image": "/catalog2026/alu-ro26.webp",
    "gallery": [
      "/catalog2026/alu-ro26.webp",
      "/catalog2026/alu-ro26-amb.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 10,76 mm", "note": "Vetro singolo o stratificato"}, "en": {"label": "Glazing", "value": "up to 10.76 mm", "note": "Single or laminated glass"}}, {"icon": "structure", "it": {"label": "Estetica e continuità", "value": "Telaio 26 × 33 mm con giunto vetro-vetro", "note": "Massima trasparenza e luminosità"}, "en": {"label": "Aesthetics and continuity", "value": "26 × 33 mm frame with glass-to-glass joint", "note": "Maximum transparency and brightness"}}, {"icon": "opening", "it": {"label": "Tipologie di porte", "value": "Vetro o legno, con o senza telaio"}, "en": {"label": "Door types", "value": "Glass or wood, framed or frameless"}}],
  },
  "asas-ro77": {
    "slug": "asas-ro77",
    "category": "alluminio-pareti-ufficio",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/03_RO77-538.pdf",
    "quickSpecs": {
      "glass": 12
    },
    "it": {
      "name": "RO77",
      "tagline": "La parete a doppio vetro: più silenzio, tende integrate.",
      "description": "RO77 è la parete divisoria a doppio vetro per uffici: con un solo montante e un solo coprifilo accoglie vetri da 6 a 12 mm, usando pochissimi profili per mantenere l'effetto open space. Con vetri acustici stratificati e vetrocamera migliora l'isolamento acustico e termico, e le veneziane tra i vetri regolano luce e riservatezza.",
      "features": [
        "Profondità 82 / 88 mm — altezza telaio 35 mm",
        "Vetri 6 / 8 / 10 / 12 mm",
        "Doppio vetro con veneziane integrate",
        "Vetri acustici per maggiore silenzio",
        "Canali passacavi integrati",
        "Porte in legno o in vetro, con o senza telaio"
      ],
      "applications": [
        "Uffici direzionali",
        "Sale riunioni",
        "Studi medici",
        "Coworking"
      ]
    },
    "en": {
      "name": "RO77",
      "tagline": "Double-glazed partition: enhanced acoustics, integrated blinds.",
      "description": "RO77 is a double-glazed office partition system: a single mullion and trim accommodate 6 to 12 mm glass, using minimal profiles to preserve the open-plan aesthetic. Acoustic laminated glass and insulating glazing improve sound and thermal insulation, whilst integrated blinds between the panes control light and privacy.",
      "features": [
        "Depth 82 / 88 mm — frame height 35 mm",
        "Glass 6 / 8 / 10 / 12 mm",
        "Double glazing with integrated blinds",
        "Acoustic glass for more privacy",
        "Integrated cable channels",
        "Wooden or glass doors, framed or frameless"
      ],
      "applications": [
        "Executive offices",
        "Meeting rooms",
        "Medical practices",
        "Coworking"
      ]
    },
    "image": "/catalog2026/alu-ro77.webp",
    "gallery": [
      "/catalog2026/alu-ro77.webp",
      "/catalog2026/alu-ro77-amb.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 12 mm", "note": "Vetro singolo o doppio vetro con veneziane integrate"}, "en": {"label": "Glazing", "value": "up to 12 mm", "note": "Single or double glazing with integrated blinds"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "Vetri acustici stratificati", "note": "Per maggiore privacy e riduzione del rumore"}, "en": {"label": "Acoustic insulation", "value": "Laminated acoustic glass", "note": "For enhanced privacy and noise reduction"}}, {"icon": "depth", "it": {"label": "Profondità della parete", "value": "82 / 88 mm"}, "en": {"label": "Wall depth", "value": "82 / 88 mm"}}, {"icon": "opening", "it": {"label": "Tipologie di porte", "value": "In legno o vetro, con o senza telaio"}, "en": {"label": "Door types", "value": "Wooden or glass, framed or frameless"}}],
  },
  "asas-ro108": {
    "slug": "asas-ro108",
    "category": "alluminio-pareti-ufficio",
    "brochure": "https://www.rescara.com.tr/Sites/1/upload/files/02_RO108-539.pdf",
    "quickSpecs": {
      "glass": 8.76
    },
    "it": {
      "name": "RO108",
      "tagline": "La parete a doppio vetro che disegna gli spazi: T, Y e angoli liberi.",
      "description": "RO108 è la parete divisoria a doppio vetro da 108,6 mm che permette di disegnare l'ufficio in modo libero: giunzioni a T e a Y e angoli a 90°, 120° e 176°. Pochi profili mantengono la sensazione di spazio aperto, mentre vetri acustici, vetrocamera e veneziane integrate garantiscono comfort, silenzio e riservatezza.",
      "features": [
        "Profondità 108,6 mm — altezza telaio 32,4 mm",
        "Vetri 6 / 8 / 8,76 mm",
        "Giunzioni a T e a Y — angoli a 90°, 120°, 176°",
        "Doppio vetro con veneziane integrate",
        "Canali passacavi integrati",
        "Porte in legno o in vetro, con o senza telaio"
      ],
      "applications": [
        "Sedi aziendali",
        "Uffici direzionali",
        "Sale riunioni",
        "Spazi espositivi"
      ]
    },
    "en": {
      "name": "RO108",
      "tagline": "Double-glazed partition that shapes space: T, Y and free angles.",
      "description": "RO108 is the 108.6 mm double-glazed partition system that allows free-form office design: T and Y junctions and 90°, 120° and 176° corners. Minimal framing maintains an open-space feel, whilst acoustic glass, insulating glazing units and integrated blinds ensure comfort, acoustic performance and privacy.",
      "features": [
        "Depth 108.6 mm — frame height 32.4 mm",
        "Glass 6 / 8 / 8.76 mm",
        "T and Y joints — 90°, 120°, 176° corners",
        "Double glazing with integrated blinds",
        "Integrated cable channels",
        "Wooden or glass doors, framed or frameless"
      ],
      "applications": [
        "Corporate headquarters",
        "Executive offices",
        "Meeting rooms",
        "Exhibition spaces"
      ]
    },
    "image": "/catalog2026/alu-ro108.webp",
    "gallery": [
      "/catalog2026/alu-ro108.webp",
      "/catalog2026/alu-ro108-amb.webp"
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "Doppio vetro fino a 8,76 mm", "note": "Con possibilità di veneziane integrate"}, "en": {"label": "Glazing", "value": "Double glazing up to 8.76 mm", "note": "With integrated blinds option"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "Vetri acustici disponibili", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "Acoustic glass available", "note": "Depending on the chosen glazing"}}, {"icon": "structure", "it": {"label": "Configurazione flessibile", "value": "Giunzioni a T e a Y", "note": "Angoli a 90°, 120° e 176°"}, "en": {"label": "Flexible configuration", "value": "T and Y joints", "note": "90°, 120° and 176° corners"}}, {"icon": "depth", "it": {"label": "Profondità della parete", "value": "108,6 mm"}, "en": {"label": "Wall depth", "value": "108.6 mm"}}],
  },
  // PVC — Porte e Finestre (Catalogo ASAŞ 2026)
  "asas-elegans-70": {
    slug: "asas-elegans-70",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 70, glass: 40, chambers: 5 },
    it: {
      name: "Elegans 70",
      tagline: "Comfort quotidiano, linee essenziali.",
      description: "Un sistema versatile per l'edilizia residenziale e la sostituzione dei vecchi serramenti. Il profilo a cinque camere unisce una profondità contenuta a diverse possibilità di vetratura, fino a 40 mm; le linee dritte e le varianti di anta permettono di adattare l'aspetto della finestra a ogni casa. Si abbina facilmente a zanzariere e oscuranti: la soluzione concreta per avere buon comfort senza far crescere il budget.",
      features: [
        "Profondità profilo 70 mm",
        "5 camere interne",
        "Vetro 4–40 mm con diverse tipologie di fermavetro",
        "Anta piana o sagomata",
        "Camera di drenaggio inclinata — alta tenuta all'acqua",
        "Scanalatura per un raccordo pulito con la muratura",
        "Compatibile con zanzariere, persiane e avvolgibili",
        "Permeabilità all'aria classe 4 — vento C5/B5",
      ],
      applications: ["Edilizia residenziale", "Sostituzione serramenti", "Prime case", "Appartamenti"],
    },
    en: {
      name: "Elegans 70",
      tagline: "Everyday comfort, essential lines.",
      description: "A versatile system for residential construction and the replacement of old windows. The five-chamber profile combines a compact depth with various glazing options, up to 40 mm; straight lines and sash variants allow the window's appearance to be adapted to any home. Easily combined with insect screens and shading systems: a practical solution for good comfort without increasing the budget.",
      features: [
        "Air permeability class 4 — wind C5/B5",
        "Profile depth 70 mm",
        "5 internal chambers",
        "Inner and outer gaskets",
        "Glazing up to 40 mm",
        "Straight lines and sash variants",
        "Compatible with insect screens and shutters",
      ],
      applications: ["Residential construction", "Window replacement", "First homes", "Apartments"],
    },
    image: "/catalog2026/elegans-70.webp",
    gallery: ["/catalog2026/elegans-70.webp", "/catalog2026/pvc-elegans-70-amb.webp", "/catalog2026/pvc-elegans-70-sez.webp"],
    highlights: [{"icon": "depth", "it": {"label": "Profondità del telaio", "value": "70 mm"}, "en": {"label": "Frame depth", "value": "70 mm"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 40 mm", "note": "Diverse tipologie di fermavetro disponibili"}, "en": {"label": "Glazing", "value": "up to 40 mm", "note": "Various glazing bead types available"}}, {"icon": "structure", "it": {"label": "Sistema a 5 camere", "value": "Profilo multicamera", "note": "Camera di drenaggio inclinata per alta tenuta all'acqua"}, "en": {"label": "5-chamber system", "value": "Multi-chamber profile", "note": "Inclined drainage chamber for high water tightness"}}, {"icon": "security", "it": {"label": "Resistenza al vento", "value": "Classe C5/B5"}, "en": {"label": "Wind resistance", "value": "Class C5/B5"}}],
  },
  "asas-inova-76-md": {
    slug: "asas-inova-76-md",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 76, glass: 50, gaskets: 3 },
    it: {
      name: "INOVA 76 MD",
      tagline: "Tre guarnizioni per il comfort abitativo.",
      description: "INOVA 76 MD è la finestra in PVC per chi cerca il massimo comfort in casa: oltre alle classiche guarnizioni interna ed esterna, una terza guarnizione centrale crea un'ulteriore barriera contro freddo, spifferi e rumore. I profili multicamera e i vetri fino a 50 mm permettono configurazioni ad altissimo isolamento termico e acustico, e le guarnizioni TPE saldate agli angoli assicurano una tenuta continua, senza punti deboli.",
      features: [
        "Profondità telaio 76 mm",
        "5, 6 o 7 camere secondo il profilo",
        "3 guarnizioni, con guarnizione centrale",
        "Vetro 24–50 mm",
        "Guarnizioni TPE saldabili — tenuta continua agli angoli",
        "Permeabilità all'aria classe 4 — vento C5/B5",
        "Soglia in alluminio a taglio termico ad altezza ridotta",
      ],
      applications: ["Residenziale ad alto comfort", "Zone rumorose", "Riqualificazione energetica", "Nuove costruzioni"],
    },
    en: {
      name: "INOVA 76 MD",
      tagline: "Three gaskets for enhanced living comfort.",
      description: "INOVA 76 MD is the PVC window for those seeking maximum comfort at home: in addition to the standard inner and outer gaskets, a third central gasket creates an additional barrier against cold, draughts and noise. Multi-chamber profiles and glazing up to 50 mm permit configurations with exceptional thermal and acoustic insulation, whilst TPE gaskets welded at the corners ensure continuous sealing with no weak points.",
      features: [
        "Frame depth 76 mm",
        "5, 6 or 7 chambers depending on profile",
        "3 gaskets, with central gasket",
        "Glazing 24–50 mm",
        "Weldable TPE gaskets — continuous corner sealing",
        "High thermal and acoustic insulation configurations",
      ],
      applications: ["High-comfort residential", "Noisy areas", "Energy retrofit", "New builds"],
    },
    image: "/catalog2026/inova-76-md.webp",
    gallery: ["/catalog2026/inova-76-md.webp", "/catalog2026/pvc-inova-76-md-amb.webp", "/catalog2026/pvc-inova-76-md-sez.webp"],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Configurazioni ad altissimo isolamento", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Very high insulation configurations", "note": "System value: varies with glazing and size"}}, {"icon": "acoustic", "it": {"label": "Isolamento acustico", "value": "Configurazioni ad altissimo isolamento", "note": "In base alla vetratura scelta"}, "en": {"label": "Acoustic insulation", "value": "Very high insulation configurations", "note": "Depending on the chosen glazing"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 50 mm"}, "en": {"label": "Glazing", "value": "up to 50 mm"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "76 mm", "note": "5, 6 o 7 camere secondo il profilo, con 3 guarnizioni"}, "en": {"label": "Frame depth", "value": "76 mm", "note": "5, 6 or 7 chambers depending on profile, with 3 gaskets"}}],
  },
  "asas-inova-plus": {
    slug: "asas-inova-plus",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 76, profile: 94 },
    it: {
      name: "INOVA+",
      tagline: "Estetica complanare e linee squadrate.",
      description: "INOVA+ è la finestra in PVC dal look contemporaneo: all'esterno anta e telaio sono complanari, cioè sullo stesso piano, per un fronte pulito e squadrato che ricorda i serramenti di design. I fermavetri sono disponibili con taglio a 90° o a 45°, due stili diversi per lo stesso serramento. L'estetica moderna non toglie nulla alla sostanza: comfort termico e acustico restano al centro del sistema.",
      features: [
        "Profondità telaio 76 mm — anta 94 mm",
        "Aspetto esterno complanare",
        "Linee dritte, disegno essenziale",
        "Fermavetri a 90° o 45°",
        "Comfort termico e acustico",
      ],
      applications: ["Architettura contemporanea", "Design minimale", "Ville e residenze moderne", "Ristrutturazioni di pregio"],
    },
    en: {
      name: "INOVA+",
      tagline: "Flush aesthetics and squared lines.",
      description: "INOVA+ is a PVC window with a contemporary look: on the exterior, the sash and frame are flush, sitting on the same plane to create a clean, squared profile reminiscent of design-led fenestration. Glazing beads are available with 90° or 45° cuts, offering two distinct styles for the same window. Modern aesthetics without compromise: thermal and acoustic comfort remain at the heart of the system.",
      features: [
        "Frame depth 76 mm — sash 94 mm",
        "Flush external appearance",
        "Straight lines, essential design",
        "90° or 45° glazing beads",
        "Thermal and acoustic comfort",
      ],
      applications: ["Contemporary architecture", "Minimal design", "Modern villas and residences", "Premium refurbishments"],
    },
    image: "/catalog2026/inova-plus.webp",
    gallery: ["/catalog2026/inova-plus.webp"],
    highlights: [{"icon": "depth", "it": {"label": "Profondità del telaio", "value": "76 mm", "note": "Anta 94 mm"}, "en": {"label": "Frame depth", "value": "76 mm", "note": "Sash 94 mm"}}, {"icon": "structure", "it": {"label": "Design", "value": "Estetica complanare moderna", "note": "Anta e telaio sullo stesso piano, linee essenziali"}, "en": {"label": "Design", "value": "Modern flush appearance", "note": "Sash and frame on the same plane, clean lines"}}],
  },
  "asas-inova-76-ph": {
    slug: "asas-inova-76-ph",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 76, glass: 50, passive: true },
    it: {
      name: "INOVA 76 PH",
      tagline: "Sistema con certificazione Passive House.",
      description: "INOVA 76 PH è la finestra in PVC per i progetti dove l'isolamento conta davvero: il sistema è certificato dal Passivhaus Institut, il riferimento internazionale per l'edilizia a bassissimo consumo energetico. Base da 76 mm, vetrature isolanti fino a 50 mm ed estetica esterna complanare, con fermavetri a 90° o 45°. La scelta naturale per case passive, edifici NZEB e riqualificazioni energetiche ambiziose.",
      features: [
        "Profondità telaio 76 mm — anta 94 mm",
        "Vetro 24–50 mm",
        "Certificazione Passive House, secondo ASAŞ",
        "Estetica esterna complanare",
        "Fermavetri a 90° o 45°",
      ],
      applications: ["Case passive", "NZEB", "Progetti ad alto isolamento", "Riqualificazioni energetiche"],
    },
    en: {
      name: "INOVA 76 PH",
      tagline: "PVC window system certified by the Passivhaus Institut.",
      description: "INOVA 76 PH is the PVC window for projects where insulation truly matters: the system is certified by the Passivhaus Institut, the international benchmark for ultra-low energy buildings. 76 mm frame depth, insulating glazing up to 50 mm and flush external aesthetics, with 90° or 45° glazing beads. The natural choice for passive houses, NZEB buildings and ambitious energy retrofits.",
      features: [
        "Frame depth 76 mm — sash 94 mm",
        "Glazing 24–50 mm",
        "Passive House qualification, per ASAŞ",
        "Flush external aesthetics",
        "90° or 45° glazing beads",
      ],
      applications: ["Passive houses", "NZEB", "High-insulation projects", "Energy retrofits"],
    },
    image: "/catalog2026/inova-76-ph.webp",
    gallery: ["/catalog2026/inova-76-ph.webp"],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Certificato Passive House", "note": "Sistema qualificato dall'istituto Passivhaus per edifici passivi"}, "en": {"label": "Thermal insulation", "value": "Passive House certified", "note": "System qualified by Passivhaus Institut for passive buildings"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "24–50 mm"}, "en": {"label": "Glazing", "value": "24–50 mm"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "76 mm"}, "en": {"label": "Frame depth", "value": "76 mm"}}],
  },
  "asas-inova-76-door": {
    slug: "asas-inova-76-door",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 76 },
    it: {
      name: "INOVA 76 Door",
      tagline: "La piattaforma INOVA per gli accessi.",
      description: "La porta d'ingresso in PVC della famiglia INOVA, pensata per chi entra ed esce tante volte al giorno: profili robusti, rinforzi dedicati e ferramenta che regge l'uso intenso nel tempo. Condivide la piattaforma da 76 mm delle finestre INOVA, quindi si abbina perfettamente al resto dei serramenti della casa. Anta, soglia e finiture si scelgono in base al progetto.",
      features: [
        "Famiglia di profili INOVA 76 mm",
        "Profili robusti per uso frequente",
        "Diverse finiture disponibili",
        "Anta, soglia e ferramenta su progetto",
      ],
      applications: ["Ingressi residenziali", "Collegamenti tra ambienti", "Accessi ad uso frequente", "Porte di servizio"],
    },
    en: {
      name: "INOVA 76 Door",
      tagline: "The INOVA platform for entrance doors.",
      description: "The PVC entrance door from the INOVA family, designed for high-frequency use: robust profiles, dedicated reinforcements and hardware engineered to withstand intensive use over time. It shares the 76 mm platform with INOVA windows, ensuring seamless integration with the rest of the home's fenestration. Sash, threshold and finishes are selected according to project requirements.",
      features: [
        "INOVA 76 mm profile family",
        "Robust profiles for frequent use",
        "Various finishes available",
        "Sash, threshold and hardware per project",
      ],
      applications: ["Residential entrances", "Room connections", "Frequently used accesses", "Service doors"],
    },
    image: "/catalog2026/inova-76-door.webp",
    gallery: ["/catalog2026/inova-76-door.webp"],
    highlights: [{"icon": "depth", "it": {"label": "Profondità del telaio", "value": "76 mm"}, "en": {"label": "Frame depth", "value": "76 mm"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Profili robusti per uso intenso", "note": "Progettata per accessi frequenti"}, "en": {"label": "Structure", "value": "Robust profiles for heavy-duty use", "note": "Designed for frequent access"}}],
  },

  "asas-inova-76": {
    slug: "asas-inova-76",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 76, glass: 50, chambers: 6 },
    it: {
      name: "INOVA 76",
      tagline: "La piattaforma INOVA nella versione a doppia guarnizione.",
      description: "INOVA 76 porta l'isolamento della famiglia INOVA in una configurazione più semplice, con doppia guarnizione di battuta. La struttura multicamera da 76 mm e i vetri fino a 50 mm garantiscono comunque ottime prestazioni termiche e acustiche: la scelta giusta quando si vuole il comfort della piattaforma INOVA con un occhio in più al budget.",
      features: [
        "Profondità profilo 76 mm",
        "5 o 6 camere secondo il profilo",
        "Vetro 24–50 mm",
        "Struttura multicamera ad alto isolamento",
        "Apertura a battente, anta-ribalta e solo anta",
        "Profili sostenibili e senza piombo",
      ],
      applications: ["Residenziale", "Nuove costruzioni", "Riqualificazione energetica", "Appartamenti"],
    },
    en: {
      name: "INOVA 76",
      tagline: "The INOVA platform in a double-gasket configuration.",
      description: "INOVA 76 brings the insulation performance of the INOVA family in a simpler configuration, with double rebate gaskets. The 76 mm multi-chamber profile and glazing up to 50 mm still ensure excellent thermal and acoustic performance: the right choice when INOVA comfort is required with closer attention to budget.",
      features: [
        "Profile depth 76 mm",
        "5 or 6 chambers depending on profile",
        "Glazing 24–50 mm",
        "High-insulation multi-chamber structure",
        "Turn, tilt & turn and fixed-sash openings",
        "Sustainable, lead-free profiles",
      ],
      applications: ["Residential", "New builds", "Energy retrofit", "Apartments"],
    },
    image: "/catalog2026/pvc-inova-76-corner.webp",
    gallery: ["/catalog2026/pvc-inova-76-corner.webp", "/catalog2026/pvc-inova-76-amb.webp"],
    highlights: [{"icon": "depth", "it": {"label": "Profondità del telaio", "value": "76 mm"}, "en": {"label": "Frame depth", "value": "76 mm"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "24–50 mm"}, "en": {"label": "Glazing", "value": "24–50 mm"}}, {"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Struttura multicamera ad alto isolamento", "note": "5 o 6 camere secondo il profilo"}, "en": {"label": "Thermal insulation", "value": "High-insulation multi-chamber structure", "note": "5 or 6 chambers depending on profile"}}, {"icon": "opening", "it": {"label": "Tipologie di apertura", "value": "Battente, anta-ribalta e solo anta"}, "en": {"label": "Opening types", "value": "Turn, tilt & turn and fixed-sash"}}],
  },
  "asas-maxi-majestic": {
    slug: "asas-maxi-majestic",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 70, glass: 40, chambers: 5 },
    it: {
      name: "Maxi Majestic",
      tagline: "La finestra che si apre verso l'esterno.",
      description: "Maxi Majestic è il sistema pensato per chi ha bisogno di finestre con apertura verso l'esterno: telaio, anta e montante centrale sono progettati appositamente per questa configurazione, diffusa nelle verande, nelle cucine su balcone e in molti contesti dove l'anta non deve ingombrare l'interno. Base da 70 mm a 5 camere e vetri fino a 40 mm per un buon comfort termico.",
      features: [
        "Profondità profilo 70 mm",
        "5 camere interne",
        "Vetro 4–40 mm",
        "Apertura verso l'esterno con profili dedicati",
        "Telaio, anta e montante centrale specifici",
        "Profili sostenibili e senza piombo",
      ],
      applications: ["Verande", "Cucine su balcone", "Spazi interni ridotti", "Edilizia residenziale"],
    },
    en: {
      name: "Maxi Majestic",
      tagline: "The window that opens outwards.",
      description: "Maxi Majestic is the system designed for those who need outward-opening windows: frame, sash and central mullion are purpose-built for this configuration, common in conservatories, balcony kitchens and many contexts where the sash must not encroach on interior space. 70 mm, 5-chamber profile with glazing up to 40 mm for good thermal comfort.",
      features: [
        "Profile depth 70 mm",
        "5 internal chambers",
        "Glazing 4–40 mm",
        "Outward opening with dedicated profiles",
        "Specific frame, sash and central mullion",
        "Sustainable, lead-free profiles",
      ],
      applications: ["Verandas", "Balcony kitchens", "Compact interiors", "Residential construction"],
    },
    image: "/catalog2026/pvc-maxi-majestic-corner.webp",
    gallery: ["/catalog2026/pvc-maxi-majestic-corner.webp", "/catalog2026/pvc-maxi-majestic-amb.webp"],
    highlights: [{"icon": "opening", "it": {"label": "Apertura verso l'esterno", "value": "Con profili dedicati telaio, anta e montante"}, "en": {"label": "Outward opening", "value": "With dedicated frame, sash and mullion profiles"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 40 mm"}, "en": {"label": "Glazing", "value": "up to 40 mm"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "70 mm"}, "en": {"label": "Profile depth", "value": "70 mm"}}, {"icon": "structure", "it": {"label": "Sistema a 5 camere", "value": "Profili sostenibili senza piombo"}, "en": {"label": "5-chamber system", "value": "Sustainable, lead-free profiles"}}],
  },
  "asas-maxi-empire": {
    slug: "asas-maxi-empire",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 120, glass: 40, chambers: 5 },
    it: {
      name: "Maxi Empire",
      tagline: "Progettato per gli edifici alti.",
      description: "Maxi Empire è il sistema in PVC per l'edilizia verticale: i profili larghi 120 mm a 5 camere offrono prestazioni di isolamento superiori alle aspettative anche ai piani alti, dove vento e sbalzi termici si fanno sentire. La superficie esterna inclinata non trattiene sporco e acqua, mantenendo il serramento pulito nel tempo. Trasmittanza Uw fino a 1,45 W/m²K e tenuta all'aria in classe 5.",
      features: [
        "Profondità profilo 120 mm",
        "5 camere interne",
        "Vetro 4–40 mm",
        "Trasmittanza termica Uw 1,45 W/m²K",
        "Permeabilità all'aria classe 5 — vento C5/B5",
        "Superficie esterna inclinata autopulente",
      ],
      applications: ["Edifici alti", "Condomini", "Torri residenziali", "Facciate esposte al vento"],
    },
    en: {
      name: "Maxi Empire",
      tagline: "Engineered for high-rise buildings.",
      description: "Maxi Empire is the PVC system for vertical construction: 120 mm wide, 5-chamber profiles deliver insulation performance beyond expectations even on upper floors, where wind and thermal variations are most pronounced. The inclined outer surface does not retain dirt or water, keeping the window clean over time. Uw down to 1.45 W/m²K and class 5 air tightness.",
      features: [
        "Profile depth 120 mm",
        "5 internal chambers",
        "Glazing 4–40 mm",
        "Thermal transmittance Uw 1.45 W/m²K",
        "Air permeability class 5 — wind C5/B5",
        "Self-cleaning inclined outer surface",
      ],
      applications: ["High-rise buildings", "Condominiums", "Residential towers", "Wind-exposed facades"],
    },
    image: "/catalog2026/pvc-maxi-empire-corner.webp",
    gallery: ["/catalog2026/pvc-maxi-empire-corner.webp", "/catalog2026/pvc-maxi-empire-amb.webp"],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw 1,45 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni"}, "en": {"label": "Thermal insulation", "value": "Uw 1.45 W/m²K", "note": "System value: varies with glazing and size"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 40 mm"}, "en": {"label": "Glazing", "value": "up to 40 mm"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "120 mm", "note": "Con 5 camere interne per massimo isolamento"}, "en": {"label": "Profile depth", "value": "120 mm", "note": "With 5 internal chambers for maximum insulation"}}, {"icon": "structure", "it": {"label": "Tenuta all'aria e al vento", "value": "Classe 5 (aria) — C5/B5 (vento)", "note": "Ideale per edifici verticali e piani alti"}, "en": {"label": "Air and wind resistance", "value": "Class 5 (air) — C5/B5 (wind)", "note": "Ideal for high-rise buildings and upper floors"}}],
  },
  "asas-elegans-60": {
    slug: "asas-elegans-60",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 60, glass: 30, chambers: 4 },
    it: {
      name: "Elegans 60",
      tagline: "L'essenziale, in 60 millimetri.",
      description: "Il fratello compatto dell'Elegans 70: struttura a 4 camere in 60 mm di profondità, con vetri da 4 a 30 mm e diverse opzioni di fermavetro. Mantiene i dettagli che rendono pratica la serie Elegans — camera di drenaggio inclinata, scanalatura per un raccordo pulito con la muratura, compatibilità con zanzariere, persiane e avvolgibili — ed è disponibile anche con apertura verso l'esterno. Ideale dove serve un buon serramento con ingombri e budget ridotti.",
      features: [
        "Profondità profilo 60 mm",
        "3 o 4 camere secondo il profilo",
        "Vetro 4–30 mm con diverse opzioni di fermavetro",
        "Apertura verso l'interno o verso l'esterno",
        "Camera di drenaggio inclinata — alta tenuta all'acqua",
        "Compatibile con zanzariere, persiane e avvolgibili",
      ],
      applications: ["Sostituzione serramenti", "Seconde case", "Edilizia economica", "Locali di servizio"],
    },
    en: {
      name: "Elegans 60",
      tagline: "The essential, in 60 millimetres.",
      description: "The compact sibling of the Elegans 70: a 4-chamber profile with 60 mm depth, accommodating glazing from 4 to 30 mm and various glazing bead options. It retains the practical details that define the Elegans series—inclined drainage chamber, groove for clean masonry integration, compatibility with insect screens, louvred shutters and roller shutters—and is also available with outward opening. Ideal where a quality window is required with reduced installation depth and budget.",
      features: [
        "Profile depth 60 mm",
        "3 or 4 chambers depending on profile",
        "Glazing 4–30 mm with several bead options",
        "Inward or outward opening",
        "Inclined drainage chamber — high water tightness",
        "Compatible with insect screens, louvres and shutters",
      ],
      applications: ["Window replacement", "Second homes", "Budget construction", "Service rooms"],
    },
    image: "/catalog2026/pvc-elegans-60-corner.webp",
    gallery: ["/catalog2026/pvc-elegans-60-corner.webp", "/catalog2026/pvc-elegans-60-amb.webp"],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "da 4 a 30 mm", "note": "Diverse opzioni di fermavetro disponibili"}, "en": {"label": "Glazing", "value": "from 4 to 30 mm", "note": "Several bead options available"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "60 mm", "note": "Struttura a 3 o 4 camere secondo il profilo"}, "en": {"label": "Profile depth", "value": "60 mm", "note": "3 or 4 chambers depending on profile"}}, {"icon": "opening", "it": {"label": "Direzione di apertura", "value": "Verso l'interno o verso l'esterno"}, "en": {"label": "Opening direction", "value": "Inward or outward"}}, {"icon": "security", "it": {"label": "Tenuta all'acqua", "value": "Camera di drenaggio inclinata", "note": "Garantisce un'elevata protezione dall'infiltrazione d'acqua"}, "en": {"label": "Water tightness", "value": "Inclined drainage chamber", "note": "Ensures high protection against water infiltration"}}],
  },
  "asas-diamond-60": {
    slug: "asas-diamond-60",
    category: "pvc-porte-finestre",
    quickSpecs: { frame: 60, glass: 30, chambers: 4 },
    it: {
      name: "Diamond 60",
      tagline: "Anta liscia o scanalata: due caratteri, un sistema.",
      description: "Diamond 60 gioca sull'estetica: l'anta è disponibile in versione liscia o scanalata, per adattarsi sia alle case moderne sia a quelle dal gusto più classico. Il profilo del telaio con scanalatura assicura un raccordo ordinato con la muratura e un aspetto curato della superficie interna. Il design facilita il deflusso dell'acqua garantendo un'elevata tenuta, e il sistema lavora in sintonia con zanzariere, persiane e avvolgibili.",
      features: [
        "Permeabilità all'aria classe 4 — vento C2/A4",
        "Profondità profilo 60 mm",
        "4 camere interne",
        "Vetro 4–30 mm",
        "Anta liscia o scanalata",
        "Raccordo pulito con la muratura",
        "Compatibile con zanzariere, persiane e avvolgibili",
      ],
      applications: ["Residenziale classico e moderno", "Sostituzione serramenti", "Case indipendenti", "Appartamenti"],
    },
    en: {
      name: "Diamond 60",
      tagline: "Flat or fluted sash: two styles, one system.",
      description: "Diamond 60 offers aesthetic flexibility: the sash is available in flat or fluted versions, adapting to both modern homes and those with more classic taste. The grooved frame profile ensures neat integration with the masonry and a refined interior surface finish. The design facilitates water drainage whilst ensuring superior sealing, and the system works seamlessly with insect screens, shutters and roller blinds.",
      features: [
        "Air permeability class 4 — wind C2/A4",
        "Profile depth 60 mm",
        "4 internal chambers",
        "Glazing 4–30 mm",
        "Flat or fluted sash",
        "Clean wall connection",
        "Compatible with insect screens, louvres and shutters",
      ],
      applications: ["Classic and modern residential", "Window replacement", "Detached homes", "Apartments"],
    },
    image: "/catalog2026/pvc-diamond-60-corner.webp",
    gallery: ["/catalog2026/pvc-diamond-60-corner.webp", "/catalog2026/pvc-diamond-60-amb.webp"],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "da 4 a 30 mm"}, "en": {"label": "Glazing", "value": "4 to 30 mm"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "60 mm"}, "en": {"label": "Profile depth", "value": "60 mm"}}, {"icon": "structure", "it": {"label": "Design dell'anta", "value": "Liscia o scanalata", "note": "Per adattarsi a stili moderni o classici"}, "en": {"label": "Sash design", "value": "Flat or fluted", "note": "To suit modern or classic styles"}}, {"icon": "structure", "it": {"label": "Tenuta all'aria e al vento", "value": "Classe 4 (aria) — C2/A4 (vento)"}, "en": {"label": "Air and wind tightness", "value": "Class 4 (air) — C2/A4 (wind)"}}],
  },

  // PVC — Scorrevoli (Catalogo ASAŞ 2026)
  "asas-sliding-74": {
    slug: "asas-sliding-74",
    category: "pvc-scorrevole",
    quickSpecs: { frame: 74, glass: 30 },
    it: {
      name: "Sliding System 74",
      tagline: "Più spazio, apertura scorrevole.",
      description: "Lo scorrevole che risolve i problemi di spazio: le ante scorrono parallele al telaio, quindi niente ingombri quando si apre. Si può configurare con due, tre o quattro elementi, per finestre e porte scorrevoli di ogni misura. La gamma offre più profondità di telaio, la zanzariera integrata e dettagli studiati per far defluire bene l'acqua piovana. Pratico ed economico, ideale per balconi e verande.",
      features: [
        "Telai disponibili 74 / 76 / 94,5 / 137 mm",
        "Vetro 4–30 mm",
        "Configurazioni a 2, 3 o 4 elementi",
        "Scorrimento con configurazione a labirinto",
        "Permeabilità all'aria classe 4 — vento C3/B3",
        "Zanzariere su tutte le tipologie",
      ],
      applications: ["Balconi e verande", "Finestre scorrevoli", "Porte scorrevoli", "Spazi ridotti"],
    },
    en: {
      name: "Sliding System 74",
      tagline: "Space-saving sliding system.",
      description: "The sliding system that solves space constraints: the sashes slide parallel to the frame, eliminating projection when open. Available in two, three or four-element configurations for sliding windows and doors of any size. The range offers multiple frame depths, integrated insect screens and details engineered for effective rainwater drainage. Practical and economical, ideal for balconies and conservatories.",
      features: [
        "Frames available 74 / 76 / 94.5 / 137 mm",
        "3, 4 or 5 chambers depending on profile",
        "Glazing up to 30 mm",
        "2, 3 or 4-element configurations",
        "Integrated insect-screen solutions",
        "Water drainage details",
      ],
      applications: ["Balconies and verandas", "Sliding windows", "Sliding doors", "Compact spaces"],
    },
    image: "/catalog2026/sliding-system-74.webp",
    gallery: ["/catalog2026/sliding-system-74.webp", "/catalog2026/pvc-sliding-74-amb.webp", "/catalog2026/pvc-sliding-74-sez.webp"],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 30 mm"}, "en": {"label": "Glazing", "value": "up to 30 mm"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "74 / 76 / 94,5 / 137 mm", "note": "Diverse opzioni disponibili per diverse esigenze"}, "en": {"label": "Frame depth", "value": "74 / 76 / 94.5 / 137 mm", "note": "Various options available for different needs"}}, {"icon": "opening", "it": {"label": "Configurazioni", "value": "2, 3 o 4 elementi scorrevoli", "note": "Sistema a scorrimento parallelo salvaspazio"}, "en": {"label": "Configurations", "value": "2, 3 or 4 sliding elements", "note": "Parallel sliding space-saving system"}}, {"icon": "security", "it": {"label": "Permeabilità all'aria", "value": "Classe 4", "note": "Resistenza al vento C3/B3"}, "en": {"label": "Air permeability", "value": "Class 4", "note": "Wind resistance C3/B3"}}],
  },
  "asas-inova-sliding": {
    slug: "asas-inova-sliding",
    category: "pvc-scorrevole",
    quickSpecs: { frame: 147, glass: 50, load: 400 },
    it: {
      name: "INOVA Sliding",
      tagline: "Grandi superfici vetrate, chiusura a pressione.",
      description: "Lo scorrevole in PVC pensato per le grandi vetrate: alla chiusura, punti di pressione distribuiti su tutto il perimetro spingono l'anta contro le guarnizioni, garantendo una tenuta ad aria e acqua superiore a quella degli scorrevoli tradizionali. I test eseguiti presso il laboratorio certificato IFT Rosenheim (Germania) gli attribuiscono il miglior valore di isolamento tra gli scorrevoli esistenti, con trasmittanza Uw fino a 1,40 W/m²K. La ferramenta porta fino a 400 kg per anta e permette aperture fino a 3000×3600 mm: perfetto per collegare soggiorno, terrazza e giardino.",
      features: [
        "Profondità sistema 147 mm",
        "Trasmittanza termica Uw 1,40 W/m²K — testato IFT Rosenheim",
        "Chiusura a punti di pressione perimetrali",
        "Vetro 24–50 mm — fino a 80 kg/m²",
        "Portata ferramenta fino a 400 kg per anta",
        "Aperture fino a 3000×3600 mm",
        "Permeabilità all'aria classe 4 — vento classe B3",
      ],
      applications: ["Soggiorni verso terrazze", "Collegamento con giardini", "Ampie vetrate", "Residenziale premium"],
    },
    en: {
      name: "INOVA Sliding",
      tagline: "Large glazed surfaces, pressure-point closure.",
      description: "The PVC sliding system designed for large glazed areas: on closing, pressure points distributed around the entire perimeter push the sash against the gaskets, ensuring air and water tightness superior to traditional sliding systems. Tests carried out at the IFT Rosenheim certified laboratory (Germany) assign it the best insulation value among existing sliding systems, with a Uw thermal transmittance down to 1.40 W/m²K. The hardware supports up to 400 kg per sash and permits openings up to 3000×3600 mm: ideal for connecting living rooms, terraces and gardens.",
      features: [
        "Air permeability class 4 — wind class B3",
        "System depth 147 mm",
        "Perimeter pressure-point closing",
        "Glazing 24–50 mm",
        "For sliding windows and doors",
        "Dedicated hardware — smooth operation",
        "Dedicated reinforcements for large surfaces",
      ],
      applications: ["Living rooms to terraces", "Garden connections", "Wide glazing", "Premium residential"],
    },
    image: "/catalog2026/inova-sliding.webp",
    gallery: ["/catalog2026/inova-sliding.webp", "/catalog2026/pvc-inova-sliding-amb.webp", "/catalog2026/pvc-inova-sliding-sez.webp"],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Uw fino a 1,40 W/m²K", "note": "Valore di sistema: varia con vetro e dimensioni. Testato IFT Rosenheim"}, "en": {"label": "Thermal insulation", "value": "Uw up to 1.40 W/m²K", "note": "System value: varies with glazing and size. IFT Rosenheim tested"}}, {"icon": "size", "it": {"label": "Grandi superfici vetrate", "value": "Aperture fino a 3000×3600 mm", "note": "Portata fino a 400 kg per anta"}, "en": {"label": "Large glazed surfaces", "value": "Openings up to 3000×3600 mm", "note": "Load capacity up to 400 kg per sash"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "24–50 mm", "note": "Fino a 80 kg/m²"}, "en": {"label": "Glazing", "value": "24–50 mm", "note": "Up to 80 kg/m²"}}, {"icon": "security", "it": {"label": "Tenuta superiore", "value": "Chiusura a punti di pressione perimetrali", "note": "Permeabilità all'aria classe 4 — vento classe B3"}, "en": {"label": "Superior sealing", "value": "Perimeter pressure-point closing", "note": "Air permeability class 4"}}, {"icon": "depth", "it": {"label": "Profondità del sistema", "value": "147 mm"}, "en": {"label": "System depth", "value": "147 mm"}}],
  },
  "asas-hebe-schiebe": {
    slug: "asas-hebe-schiebe",
    category: "pvc-scorrevole",
    quickSpecs: { frame: 170, glass: 40 },
    it: {
      name: "Hebe-Schiebe",
      tagline: "Aperture generose verso l'esterno. L'alzante scorrevole in PVC.",
      description: "L'alzante scorrevole in PVC per le aperture più generose: una leggera rotazione della maniglia solleva l'anta di qualche millimetro e la fa scorrere senza sforzo, anche quando è molto grande. Il telaio da 170 mm e i rinforzi dedicati permettono vetrate ampie verso balconi, terrazze e giardini d'inverno; la soglia in alluminio con finitura interna in PVC unisce robustezza e continuità estetica. Il telaio è inoltre predisposto per l'assemblaggio direttamente in cantiere.",
      features: [
        "Profondità telaio 170 mm — anta 70 mm",
        "Profili con pareti in Classe A",
        "Vetro 4–40 mm",
        "Permeabilità all'aria classe 3 — vento C4/B5",
        "Soglia in alluminio con chiusura interna in uPVC",
        "Telaio predisposto per assemblaggio in cantiere",
      ],
      applications: ["Balconi e terrazze", "Verande", "Giardini d'inverno", "Grandi aperture residenziali"],
    },
    en: {
      name: "Hebe-Schiebe",
      tagline: "Generous openings to the outside. The PVC lift-and-slide.",
      description: "The PVC lift-and-slide for the most generous openings: a gentle turn of the handle lifts the sash by a few millimetres and allows it to glide effortlessly, even when very large. The 170 mm frame and dedicated reinforcements permit expansive glazing towards balconies, terraces and winter gardens; the aluminium threshold with PVC interior finish combines robustness and visual continuity. The frame is also designed for on-site assembly.",
      features: [
        "Air permeability class 3 — wind C4/B5",
        "Frame depth 170 mm — sash 70 mm",
        "Class A profiles, per ASAŞ",
        "Glazing up to 40 mm",
        "Reinforcements for wide openings",
        "Aluminium threshold with PVC interior finish",
        "Frame designed for on-site assembly",
      ],
      applications: ["Balconies and terraces", "Verandas", "Winter gardens", "Large residential openings"],
    },
    image: "/catalog2026/hebe-schiebe.webp",
    gallery: ["/catalog2026/hebe-schiebe.webp", "/catalog2026/pvc-hebe-schiebe-amb.webp", "/catalog2026/pvc-hebe-schiebe-sez.webp"],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "fino a 40 mm"}, "en": {"label": "Glazing", "value": "up to 40 mm"}}, {"icon": "opening", "it": {"label": "Tipologia di apertura", "value": "Alzante scorrevole", "note": "Sollevamento con maniglia per scorrimento senza sforzo"}, "en": {"label": "Opening type", "value": "Lift-and-slide", "note": "Handle-operated lift for effortless sliding"}}, {"icon": "depth", "it": {"label": "Profondità del telaio", "value": "170 mm"}, "en": {"label": "Frame depth", "value": "170 mm"}}, {"icon": "size", "it": {"label": "Aperture ampie", "value": "Rinforzi dedicati per grandi vetrate", "note": "Ideale per balconi, terrazze e giardini d'inverno"}, "en": {"label": "Wide openings", "value": "Dedicated reinforcements for large glazing", "note": "Ideal for balconies, terraces and winter gardens"}}, {"icon": "structure", "it": {"label": "Tenuta all'aria e al vento", "value": "Classe 3 (aria) — C4/B5 (vento)"}, "en": {"label": "Air and wind tightness", "value": "Class 3 (air) — C4/B5 (wind)"}}],
  },

  "asas-sliding-70": {
    slug: "asas-sliding-70",
    category: "pvc-scorrevole",
    quickSpecs: { frame: 70, glass: 20 },
    it: {
      name: "Sliding System 70",
      tagline: "Lo scorrevole pratico per ogni giorno.",
      description: "La versione da 70 mm dello scorrevole in linea: le ante si muovono lungo il proprio asse senza ingombrare gli spazi interni. Telaio e profilo centrale hanno una configurazione a labirinto che facilita il deflusso dell'acqua e garantisce una buona tenuta agli agenti atmosferici. Accetta vetri da 4 a 20 mm e si completa con zanzariere su tutte le configurazioni: la scelta semplice per balconi, verande e aperture di servizio.",
      features: [
        "Profondità profilo 70 mm",
        "Vetro 4–20 mm",
        "Scorrimento con configurazione a labirinto",
        "Design ottimizzato per il deflusso dell'acqua",
        "Zanzariere su tutte le configurazioni",
        "Profili sostenibili e senza piombo",
      ],
      applications: ["Balconi", "Verande", "Aperture di servizio", "Spazi ridotti"],
    },
    en: {
      name: "Sliding System 70",
      tagline: "The practical everyday slider.",
      description: "The 70 mm version of the in-line slider: sashes move along their own axis without encroaching on interior space. Frame and centre mullion feature a labyrinth configuration that facilitates water drainage and ensures good weather resistance. Accepts 4–20 mm glazing and can be fitted with insect screens on all configurations: the straightforward choice for balconies, conservatories and utility openings.",
      features: [
        "Profile depth 70 mm",
        "Glazing 4–20 mm",
        "Labyrinth sliding configuration",
        "Water-discharge optimised design",
        "Insect screens on all configurations",
        "Sustainable, lead-free profiles",
      ],
      applications: ["Balconies", "Verandas", "Service openings", "Compact spaces"],
    },
    image: "/catalog2026/pvc-sliding-70-corner.webp",
    gallery: ["/catalog2026/pvc-sliding-70-corner.webp", "/catalog2026/pvc-sliding-70-amb.webp"],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "da 4 a 20 mm"}, "en": {"label": "Glazing", "value": "4–20 mm"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "70 mm"}, "en": {"label": "Profile depth", "value": "70 mm"}}, {"icon": "opening", "it": {"label": "Tipologia di apertura", "value": "Scorrevole in linea", "note": "Le ante si muovono lungo il proprio asse"}, "en": {"label": "Opening type", "value": "In-line sliding", "note": "Sashes move along their own axis"}}, {"icon": "structure", "it": {"label": "Configurazione", "value": "Sistema a labirinto", "note": "Facilita il deflusso dell'acqua e migliora la tenuta"}, "en": {"label": "Configuration", "value": "Labyrinth system", "note": "Optimises water discharge and improves sealing"}}],
  },
  "asas-compact-60": {
    slug: "asas-compact-60",
    category: "pvc-scorrevole",
    quickSpecs: { frame: 60, glass: 20 },
    it: {
      name: "Compact Sliding 60",
      tagline: "Lo scorrevole più compatto della gamma.",
      description: "Compact Sliding 60 riduce tutto all'essenziale: 60 mm di profondità e un profilo intelligente che può fare sia da telaio perimetrale sia da giunzione centrale tra le ante — meno componenti, posa più semplice. Il sistema di drenaggio a labirinto assicura il libero deflusso dell'acqua, le zanzariere si installano su tutte le configurazioni. Perfetto per verande, box e chiusure leggere dove contano praticità e prezzo.",
      features: [
        "Profondità profilo 60 mm",
        "Vetro 4–20 mm",
        "Profilo unico per telaio e giunzione centrale",
        "Drenaggio a labirinto — libero deflusso dell'acqua",
        "Permeabilità all'aria classe 4 — vento C2/B3",
        "Zanzariere su tutte le configurazioni",
      ],
      applications: ["Verande leggere", "Box e depositi", "Chiusure balcone", "Partizioni scorrevoli"],
    },
    en: {
      name: "Compact Sliding 60",
      tagline: "The most compact sliding system in the range.",
      description: "Compact Sliding 60 reduces everything to the essential: 60 mm depth and an intelligent profile that serves both as perimeter frame and central sash junction — fewer components, simpler installation. The labyrinth drainage system ensures free water discharge, and insect screens can be fitted to all configurations. Perfect for verandas, enclosures and lightweight installations where practicality and price matter.",
      features: [
        "Profile depth 60 mm",
        "Glazing 4–20 mm",
        "Single profile for frame and central junction",
        "Labyrinth drainage — free water discharge",
        "Air permeability class 4 — wind C2/B3",
        "Insect screens on all configurations",
      ],
      applications: ["Light verandas", "Storage rooms", "Balcony enclosures", "Sliding partitions"],
    },
    image: "/catalog2026/pvc-compact-60-corner.webp",
    gallery: ["/catalog2026/pvc-compact-60-corner.webp", "/catalog2026/pvc-compact-60-amb.webp"],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "da 4 a 20 mm"}, "en": {"label": "Glazing", "value": "4 to 20 mm"}}, {"icon": "depth", "it": {"label": "Profondità del profilo", "value": "60 mm"}, "en": {"label": "Profile depth", "value": "60 mm"}}, {"icon": "rain", "it": {"label": "Drenaggio", "value": "Sistema a labirinto", "note": "Libero deflusso dell'acqua"}, "en": {"label": "Drainage", "value": "Labyrinth system", "note": "Free water discharge"}}, {"icon": "structure", "it": {"label": "Semplicità costruttiva", "value": "Profilo unico per telaio e giunzione", "note": "Meno componenti, installazione semplificata"}, "en": {"label": "Construction simplicity", "value": "Single profile for frame and junction", "note": "Fewer components, simplified installation"}}],
  },
  "asas-davanzali": {
    slug: "asas-davanzali",
    category: "pvc-oscuranti",
    quickSpecs: {},
    it: {
      name: "Profili Davanzale",
      tagline: "L'alternativa al marmo, in 8 misure e 17 finiture.",
      description: "I profili davanzale in PVC completano il serramento dall'interno: un'alternativa moderna al marmo, con elevato isolamento termico e grande resistenza alla condensa — niente più zone fredde sotto la finestra. Disponibili in versione a pezzo unico o componibile, in larghezze da 150 a 600 mm, si installano facilmente anche su superfici ampie e si adattano alle diverse configurazioni costruttive. La gamma colori spazia dalle essenze legno (Golden Oak, Noce, Mogano, Winchester) alle tinte moderne come Antracite, Quartz Grey e Black Ulti-Matt.",
      features: [
        "Larghezze 150–600 mm, a pezzo unico o componibile",
        "Elevato isolamento termico",
        "Alta resistenza alla condensa",
        "Alternativa moderna al davanzale in marmo",
        "17 finiture: essenze legno e tinte moderne",
        "Terminali, angoli di giunzione e coperture dedicate",
      ],
      applications: ["Completamento serramenti", "Nuove costruzioni", "Ristrutturazioni", "Sostituzione davanzali interni"],
    },
    en: {
      name: "Sill Profiles",
      tagline: "The marble alternative, in 8 sizes and 17 finishes.",
      description: "PVC sill profiles complete the window from the inside: a modern alternative to marble, offering high thermal insulation and excellent condensation resistance—eliminating cold zones beneath the window. Available in one-piece or modular versions, in widths from 150 to 600 mm, they install easily even on large surfaces and adapt to different construction configurations. The colour range spans wood-effect finishes (Golden Oak, Walnut, Mahogany, Winchester) and contemporary shades such as Anthracite, Quartz Grey and Black Ulti-Matt.",
      features: [
        "Widths 150–600 mm, one-piece or modular",
        "High thermal insulation",
        "High condensation resistance",
        "Modern alternative to marble sills",
        "17 finishes: wood grains and modern shades",
        "Dedicated end caps, corner joints and covers",
      ],
      applications: ["Window completion", "New builds", "Renovations", "Interior sill replacement"],
    },
    image: "/catalog2026/pvc-davanzali.webp",
    gallery: ["/catalog2026/pvc-davanzali.webp", "/catalog2026/pvc-davanzali-colori.webp"],
    highlights: [{"icon": "thermal", "it": {"label": "Isolamento termico", "value": "Elevato", "note": "Elimina i ponti termici sotto la finestra"}, "en": {"label": "Thermal insulation", "value": "High", "note": "Eliminates cold bridges under the window"}}, {"icon": "size", "it": {"label": "Larghezze disponibili", "value": "Da 150 a 600 mm", "note": "A pezzo unico o componibile"}, "en": {"label": "Available widths", "value": "From 150 to 600 mm", "note": "One-piece or modular"}}],
  },

  // PVC — Complementi Oscuranti (Catalogo ASAŞ 2026)
  "asas-inovabox": {
    slug: "asas-inovabox",
    category: "pvc-oscuranti",
    quickSpecs: {},
    it: {
      name: "InovaBox",
      tagline: "Avvolgibile e zanzariera integrata.",
      description: "InovaBox è il cassonetto monoblocco che integra avvolgibile e zanzariera direttamente sopra la finestra: un unico elemento, installato insieme al serramento, senza opere murarie aggiuntive. La versione più recente include la zanzariera a rullo e soluzioni per migliorare isolamento termico e acustico del vano. I coperchi posteriore e inferiore si rimuovono facilmente, così manutenzione e regolazioni si fanno in pochi minuti.",
      features: [
        "Cassonetto monoblocco in PVC",
        "Zanzariera a rullo integrata",
        "Soluzioni per isolamento termico e acustico",
        "Ispezione posteriore e inferiore",
        "Accesso facilitato per manutenzione e regolazione",
      ],
      applications: ["Monoblocco con serramento", "Nuove costruzioni", "Sostituzione con cassonetto", "Residenziale"],
    },
    en: {
      name: "InovaBox",
      tagline: "Integrated roller shutter and insect screen in one housing.",
      description: "InovaBox is a monoblock housing that integrates roller shutter and insect screen directly above the window: a single element installed together with the window, requiring no additional building work. The latest version includes a roller insect screen and solutions to improve thermal and acoustic insulation of the box. Rear and bottom covers remove easily, allowing maintenance and adjustments to be carried out in minutes.",
      features: [
        "PVC monobloc shutter box",
        "Integrated roller insect screen",
        "Thermal and acoustic insulation solutions",
        "Rear and bottom inspection",
        "Easy access for maintenance and adjustment",
      ],
      applications: ["Monobloc with window", "New builds", "Replacement with shutter box", "Residential"],
    },
    image: "/catalog2026/inovabox.webp",
    gallery: ["/catalog2026/inovabox.webp"],
    highlights: [{"icon": "structure", "it": {"label": "Sistema integrato", "value": "Cassonetto monoblocco con avvolgibile e zanzariera", "note": "Installazione senza opere murarie aggiuntive"}, "en": {"label": "Integrated system", "value": "Monobloc box with roller shutter and insect screen", "note": "Installation without additional masonry work"}}, {"icon": "thermal", "it": {"label": "Isolamento termo-acustico", "value": "Soluzioni per migliorare l'isolamento", "note": "Riduce le dispersioni termiche del vano cassonetto"}, "en": {"label": "Thermal and acoustic insulation", "value": "Solutions to improve insulation", "note": "Reduces thermal losses from the shutter box compartment"}}, {"icon": "structure", "it": {"label": "Manutenzione semplificata", "value": "Accesso posteriore e inferiore facilitato", "note": "Coperchi rimovibili per interventi rapidi"}, "en": {"label": "Easy maintenance", "value": "Rear and bottom easy access", "note": "Removable covers for quick servicing"}}],
  },
  "asas-u-shape": {
    slug: "asas-u-shape",
    category: "pvc-oscuranti",
    quickSpecs: {},
    it: {
      name: "U-Shape",
      tagline: "Il cassonetto si integra nella facciata.",
      description: "U-Shape è l'oscurante che non si vede: il cassonetto a U si incassa nella muratura, sopra la finestra, e scompare sotto l'intonaco. Dall'esterno resta solo la facciata pulita, senza volumi sporgenti. La struttura in alluminio ospita il meccanismo dell'avvolgibile, azionabile a manovella o con motore. La soluzione ideale per le nuove costruzioni e per i progetti in cui il design della facciata viene prima di tutto.",
      features: [
        "Cassonetto a U da incasso",
        "Struttura in alluminio",
        "Azionamento manuale o motorizzato",
        "Integrazione nella muratura / sotto intonaco",
        "Facciata dal disegno pulito",
      ],
      applications: ["Facciate minimali", "Nuove costruzioni", "Oscurante invisibile", "Progetti architettonici"],
    },
    en: {
      name: "U-Shape",
      tagline: "The shutter box integrates into the facade.",
      description: "U-Shape is the invisible shading system: the U-shaped box is recessed into the masonry above the window and concealed beneath the render. From outside, only a clean facade remains, with no protruding volumes. The aluminium structure houses the roller shutter mechanism, operable by crank handle or motor. The ideal solution for new builds and projects where facade design comes first.",
      features: [
        "Recessed U-shaped shutter box",
        "Aluminium structure",
        "Manual or motorised operation",
        "Integrated in masonry / under plaster",
        "Clean facade design",
      ],
      applications: ["Minimal facades", "New builds", "Invisible shading", "Architectural projects"],
    },
    image: "/catalog2026/u-shape.webp",
    gallery: ["/catalog2026/u-shape.webp"],
    highlights: [{"icon": "structure", "it": {"label": "Installazione", "value": "Cassonetto a incasso totale", "note": "Integrato nella muratura, invisibile dall'esterno"}, "en": {"label": "Installation", "value": "Fully recessed shutter box", "note": "Integrated in masonry, invisible from outside"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Alluminio"}, "en": {"label": "Structure", "value": "Aluminium"}}, {"icon": "automation", "it": {"label": "Azionamento", "value": "Manuale o motorizzato"}, "en": {"label": "Operation", "value": "Manual or motorised"}}],
  },

  // PERGOLE — Bioclimatiche
  "wp-aspendos-plus": {
    slug: "wp-aspendos-plus",
    category: "pergole-bioclimatiche",
    youtubeId: "pTcAr65pKMU",
    it: {
      "name": "Aspendos Plus",
      "tagline": "Sistema bioclimatico in alluminio con apertura assiale e retrattile.",
      "description": "Aspendos Plus porta il controllo della luce e della ventilazione all'interno dello spazio outdoor attraverso lamelle in alluminio movimentate in modo assiale e retrattile. La copertura può essere regolata in funzione delle condizioni e dell'atmosfera desiderata, mantenendo la vocazione architettonica di una pergola aperta. Il comando motorizzato e la gestione anche da smartphone rendono il sistema intuitivo e versatile, ideale per terrazze, ristorazione, hospitality e spazi residenziali.",
      "features": [
        "Copertura a lamelle in alluminio",
        "Alluminio 6063-T6 F25",
        "Movimento assiale + retrattile",
        "Apertura minima 100°",
        "Controllo con telecomando e app Android / iOS",
        "LED nascosto su 4 lati",
        "Portanti principali 128 × 170 × 3 mm",
        "Carico distribuito 50 kg + 25 kg/m²",
        "Carico del vento 50 kg/m²"
      ],
      "applications": [
        "Terrazze",
        "Ristorazione",
        "Hospitality",
        "Spazi residenziali"
      ]
    },
    en: {
      "name": "Aspendos Plus",
      "tagline": "Aluminium bioclimatic system with axial and retractable opening.",
      "description": "Aspendos Plus brings light and ventilation control to outdoor spaces through aluminium louvres moving axially and retracting. The roof can be adjusted to conditions and the desired atmosphere while keeping the architectural character of an open pergola. Motorised control and smartphone management make it intuitive and versatile — ideal for terraces, restaurants, hospitality and homes.",
      "features": [
        "Aluminium louvre roof",
        "6063-T6 F25 aluminium",
        "Axial + retractable movement",
        "Minimum opening 100°",
        "Remote control and Android / iOS app",
        "Concealed LED on 4 sides",
        "Main beams 128 × 170 × 3 mm",
        "Distributed load 50 kg + 25 kg/m²",
        "Wind load 50 kg/m²"
      ],
      "applications": [
        "Terraces",
        "Restaurants",
        "Hospitality",
        "Homes"
      ]
    },
    image: "https://winperax.com/images/urunler/aspendos-plus/1.jpg",
    gallery: [
      "https://winperax.com/images/urunler/aspendos-plus/1.jpg",
      "https://winperax.com/images/urunler/aspendos-plus/2.jpg",
      "https://winperax.com/images/urunler/aspendos-plus/3.jpg",
      "https://winperax.com/images/urunler/aspendos-plus/4.jpg",
      "https://winperax.com/images/urunler/aspendos-plus/5.jpg",
    ],
    highlights: [{"icon": "louvres", "it": {"label": "Copertura", "value": "Lamelle in alluminio", "note": "Movimento assiale + retrattile, apertura minima 100°"}, "en": {"label": "Roof", "value": "Aluminium louvres", "note": "Axial + retractable movement, minimum opening 100°"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Alluminio 6063-T6 F25", "note": "Portanti principali 128 × 170 × 3 mm"}, "en": {"label": "Structure", "value": "6063-T6 F25 aluminium", "note": "Main beams 128 × 170 × 3 mm"}}, {"icon": "size", "it": {"label": "Prestazioni", "value": "Carico distribuito 50 kg + 25 kg/m²", "note": "Carico del vento 50 kg/m²"}, "en": {"label": "Performance", "value": "Distributed load 50 kg + 25 kg/m²", "note": "Wind load 50 kg/m²"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Telecomando e app Android / iOS"}, "en": {"label": "Control", "value": "Remote control and Android / iOS app"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED nascosto su 4 lati", "status": "optional"}, "en": {"label": "Lighting", "value": "Concealed LED on 4 sides", "status": "optional"}}],
  },
  "wp-aspendos-glass": {
    slug: "wp-aspendos-glass",
    category: "pergole-bioclimatiche",
    video: "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/eic0n4qk_aspendos_glass.mp4",
    it: {
      "name": "Aspendos Glass",
      "tagline": "Sistema bioclimatico con lamelle in vetro isolante.",
      "description": "Aspendos Glass unisce la flessibilità di una copertura bioclimatica alla trasparenza del vetro isolante. Le lamelle si muovono assialmente e possono essere retratte, consentendo di modulare luce, apertura e ventilazione senza rinunciare alla continuità visiva. Il sistema può essere installato su strutture piane o inclinate e integra un drenaggio a quattro lati, mentre il controllo motorizzato e l'illuminazione LED completano una soluzione pensata per ambienti outdoor eleganti e luminosi.",
      "features": [
        "Lamelle in vetro temperato isolante Comfort 4+12+4",
        "Larghezza massima del sistema 300 cm",
        "Profili in alluminio 6063-T6 F25",
        "Movimento assiale + retrattile",
        "Apertura assiale minima 100°",
        "Controllo con telecomando e app Android / iOS",
        "Sensori pioggia, sole e vento opzionali",
        "Portanti verticali e orizzontali 128 × 170 × 3 mm",
        "Carico distribuito 50 kg + 25 kg/m² · carico del vento 50 kg/m²",
        "LED nascosto su 4 lati con dimmer",
        "Guarnizioni EPDM",
        "Installabile su strutture piane o inclinate, drenaggio a quattro lati"
      ],
      "applications": [
        "Terrazze",
        "Ristorazione",
        "Hotel",
        "Ville"
      ]
    },
    en: {
      "name": "Aspendos Glass",
      "tagline": "Bioclimatic system with insulated glass louvres.",
      "description": "Aspendos Glass combines the flexibility of a bioclimatic roof with the transparency of insulated glass. The louvres move axially and can be retracted to modulate light, opening and ventilation without losing visual continuity. It can be installed on flat or sloped structures with four-sided drainage, while motorised control and LED lighting complete a solution for elegant, bright outdoor spaces.",
      "features": [
        "Tempered insulated glass louvres Comfort 4+12+4",
        "Maximum system width 300 cm",
        "6063-T6 F25 aluminium profiles",
        "Axial + retractable movement",
        "Minimum axial opening 100°",
        "Remote control and Android / iOS app",
        "Optional rain, sun and wind sensors",
        "Vertical and horizontal beams 128 × 170 × 3 mm",
        "Distributed load 50 kg + 25 kg/m² · wind load 50 kg/m²",
        "Concealed dimmable LED on 4 sides",
        "EPDM gaskets",
        "Flat or sloped installation, four-sided drainage"
      ],
      "applications": [
        "Terraces",
        "Restaurants",
        "Hotels",
        "Villas"
      ]
    },
    image: "https://winperax.com/images/urunler/rolling/n1.jpg",
    gallery: [
      "https://winperax.com/images/urunler/rolling/n1.jpg",
      "https://winperax.com/images/urunler/rolling/n2.jpg",
      "https://winperax.com/images/urunler/rolling/n3.jpg",
      "https://winperax.com/images/urunler/rolling/n4.jpg",
      "https://winperax.com/images/urunler/rolling/n5.jpg",
      "https://winperax.com/images/urunler/rolling/n6.jpg",
    ],
    highlights: [{"icon": "glass", "it": {"label": "Copertura", "value": "Vetro temperato isolante 4+12+4", "note": "Lamelle mobili, apertura minima 100°"}, "en": {"label": "Roof", "value": "Tempered insulated glass 4+12+4", "note": "Moving louvres, minimum opening 100°"}}, {"icon": "size", "it": {"label": "Larghezza massima", "value": "300 cm", "note": "Carico distribuito 50 kg + 25 kg/m², vento 50 kg/m²"}, "en": {"label": "Maximum width", "value": "300 cm", "note": "Distributed load 50 kg + 25 kg/m², wind 50 kg/m²"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Alluminio 6063-T6 F25", "note": "Portanti 128 × 170 × 3 mm, guarnizioni EPDM"}, "en": {"label": "Structure", "value": "6063-T6 F25 aluminium", "note": "Beams 128 × 170 × 3 mm, EPDM gaskets"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Telecomando e app Android / iOS", "note": "Sensori pioggia, sole e vento", "noteStatus": "optional"}, "en": {"label": "Control", "value": "Remote control and Android / iOS app", "note": "Rain, sun and wind sensors", "noteStatus": "optional"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED nascosto su 4 lati, con dimmer"}, "en": {"label": "Lighting", "value": "Concealed dimmable LED on 4 sides"}}],
  },
  "wp-skyline-axial": {
    slug: "wp-skyline-axial",
    category: "pergole-bioclimatiche",
    it: {
      "name": "Skyline",
      "tagline": "Pergola bioclimatica ad apertura assiale fino a 105°.",
      "description": "Skyline interpreta la copertura bioclimatica attraverso un movimento assiale preciso, capace di orientare i pannelli fino a 105°. La regolazione permette di combinare ombreggiamento e ventilazione, mentre il profilo a tendina nascosto limita l'ingresso indesiderato di luce e vento. Il sistema integra un drenaggio perimetrale a quattro lati e può essere azionato con riduttore manuale o motore tubolare. Una soluzione essenziale e contemporanea per terrazze, ristorazione, hotel, aree piscina e ville.",
      "features": [
        "Rotazione dei pannelli fino a 105°",
        "Profilo principale verticale 160 × 160 × 2,5 mm",
        "Profilo principale orizzontale 60 × 246 × 2,5 mm",
        "Profilo pannello 233 × 456 × 2 mm",
        "Alluminio 6063-T6 F25 · durezza 75–80 Brinell",
        "Riduttore manuale oppure motore tubolare",
        "Drenaggio nascosto a quattro lati",
        "Sensori vento, pioggia e sole opzionali sulle versioni motorizzate",
        "LED opzionale su tutti i lati, con dimmer",
        "Guarnizioni EPDM"
      ],
      "applications": [
        "Terrazze",
        "Ristorazione",
        "Hotel",
        "Aree piscina",
        "Ville"
      ]
    },
    en: {
      "name": "Skyline",
      "tagline": "Bioclimatic pergola with axial opening up to 105°.",
      "description": "Skyline interprets the bioclimatic roof through precise axial movement, rotating the panels up to 105°. Adjustment combines shading and ventilation, while the concealed curtain profile limits unwanted light and wind. Four-sided perimeter drainage is integrated and the system can be operated by manual gearbox or tubular motor. An essential, contemporary solution for terraces, restaurants, hotels, pool areas and villas.",
      "features": [
        "Panel rotation up to 105°",
        "Main vertical profile 160 × 160 × 2.5 mm",
        "Main horizontal profile 60 × 246 × 2.5 mm",
        "Panel profile 233 × 456 × 2 mm",
        "6063-T6 F25 aluminium · 75–80 Brinell hardness",
        "Manual gearbox or tubular motor",
        "Concealed four-sided drainage",
        "Optional wind, rain and sun sensors on motorised versions",
        "Optional dimmable LED on all sides",
        "EPDM gaskets"
      ],
      "applications": [
        "Terraces",
        "Restaurants",
        "Hotels",
        "Pool areas",
        "Villas"
      ]
    },
    image: "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/3213jsxc_4.jpg",
    gallery: [
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/3213jsxc_4.jpg",
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/c9ry8pv1_5.jpg",
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/ewi1olo5_6.jpg",
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/jhehv73l_7.jpg",
      "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/rxsywpud_8.jpg",
    ],
    highlights: [{"icon": "louvres", "it": {"label": "Movimento", "value": "Rotazione assiale dei pannelli fino a 105°", "note": "Profilo a tendina nascosto"}, "en": {"label": "Movement", "value": "Axial panel rotation up to 105°", "note": "Concealed curtain profile"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Alluminio 6063-T6 F25", "note": "Montanti 160 × 160 × 2,5 mm · durezza 75–80 Brinell"}, "en": {"label": "Structure", "value": "6063-T6 F25 aluminium", "note": "Posts 160 × 160 × 2.5 mm · 75–80 Brinell"}}, {"icon": "rain", "it": {"label": "Drenaggio", "value": "Sistema nascosto a quattro lati"}, "en": {"label": "Drainage", "value": "Concealed four-sided system"}}, {"icon": "automation", "it": {"label": "Comando", "value": "Riduttore manuale o motore tubolare", "note": "Sensori vento, pioggia e sole sulle versioni motorizzate", "noteStatus": "optional"}, "en": {"label": "Operation", "value": "Manual gearbox or tubular motor", "note": "Wind, rain and sun sensors on motorised versions", "noteStatus": "optional"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED su tutti i lati, con dimmer", "status": "optional"}, "en": {"label": "Lighting", "value": "Dimmable LED on all sides", "status": "optional"}}],
  },

  // PERGOLE — Tende & Schermature (Winperax)
  "wp-olympos-170": {
    slug: "wp-olympos-170",
    category: "pergole-tende-schermature",
    youtubeId: "plWF_burgM8",
    it: {
      "name": "Olympos 170",
      "tagline": "Pergola retrattile progettata per coprire superfici di maggiore ampiezza.",
      "description": "Olympos 170 combina una struttura in alluminio con una copertura retrattile in tessuto Black-Out, offrendo una soluzione ordinata e versatile per grandi superfici. Il profilo portante da 90 × 170 mm e la configurazione dedicata alle applicazioni estese ne fanno un sistema particolarmente adatto a winter garden, hotel, ristoranti, caffè e pasticcerie. Il tessuto Black-Out ignifugo, l'illuminazione LED integrata e il comando RTS completano una copertura pensata per l'uso quotidiano.",
      "features": [
        "Sistema a tetto retrattile in tessuto",
        "Profilo 90 × 170 × 3 mm",
        "Alluminio termico 12 · 6060",
        "3 assi portanti per modulo",
        "Tessuto PVC Black-Out a 3 strati, ignifugo",
        "Carico neve 15 cm",
        "Resistenza al vento Beaufort 6",
        "LED nascosto nei profili",
        "Telecomando RTS"
      ],
      "applications": [
        "Winter garden",
        "Hotel",
        "Ristoranti",
        "Caffè e pasticcerie"
      ]
    },
    en: {
      "name": "Olympos 170",
      "tagline": "Retractable pergola designed to cover larger surfaces.",
      "description": "Olympos 170 combines an aluminium structure with a retractable Black-Out fabric roof, offering a tidy and versatile solution for large surfaces. The 90 × 170 mm load-bearing profile and a configuration dedicated to wide applications make it ideal for winter gardens, hotels, restaurants, cafés and pastry shops. Flame-retardant Black-Out fabric, integrated LED lighting and RTS control complete a roof designed for everyday use.",
      "features": [
        "Retractable fabric roof system",
        "Profile 90 × 170 × 3 mm",
        "Thermal aluminium 12 · 6060",
        "3 load-bearing axes per module",
        "3-layer PVC Black-Out fabric, flame-retardant",
        "Snow load 15 cm",
        "Wind resistance Beaufort 6",
        "LED concealed in the profiles",
        "RTS remote control"
      ],
      "applications": [
        "Winter gardens",
        "Hotels",
        "Restaurants",
        "Cafés & pastry shops"
      ]
    },
    image: "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/1.jpg",
    gallery: [
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/1.jpg",
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/3.jpg",
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/4.jpg",
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/5.jpg",
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/6.jpg",
    ],
    highlights: [{"icon": "structure", "it": {"label": "Profilo", "value": "90 × 170 × 3 mm", "note": "Alluminio termico 12 · 6060, 3 assi portanti per modulo"}, "en": {"label": "Profile", "value": "90 × 170 × 3 mm", "note": "Thermal aluminium 12 · 6060, 3 axes per module"}}, {"icon": "rain", "it": {"label": "Copertura", "value": "Tessuto PVC Black-Out a 3 strati", "note": "Ignifugo"}, "en": {"label": "Roof", "value": "3-layer PVC Black-Out fabric", "note": "Flame-retardant"}}, {"icon": "size", "it": {"label": "Resistenza", "value": "Carico neve 15 cm · vento Beaufort 6"}, "en": {"label": "Resistance", "value": "Snow load 15 cm · wind Beaufort 6"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED nascosto nei profili"}, "en": {"label": "Lighting", "value": "LED concealed in the profiles"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Telecomando RTS"}, "en": {"label": "Control", "value": "RTS remote control"}}],
  },
  "wp-side-150": {
    slug: "wp-side-150",
    category: "pergole-tende-schermature",
    it: {
      "name": "Side 150",
      "tagline": "Pergola retrattile per grandi superfici, con profilo standard da 150 mm.",
      "description": "Side 150 è una copertura retrattile pensata per ampliare e proteggere gli spazi esterni con una struttura essenziale e una copertura in tessuto Black-Out. Il profilo da 81 × 150 × 2,5 mm, il comando RTS e l'illuminazione LED integrata rendono il sistema adatto a terrazze e superfici di ampia estensione. Impermeabile e progettata per l'impiego outdoor, con un linguaggio architettonico pulito e facilmente integrabile.",
      "features": [
        "Sistema a tetto retrattile in tessuto",
        "Profilo 81 × 150 × 2,5 mm",
        "Tessuto PVC Black-Out a 3 strati",
        "Resistenza al vento Beaufort 6",
        "LED nascosto",
        "Telecomando RTS",
        "Sistema impermeabile"
      ],
      "applications": [
        "Terrazze",
        "Grandi superfici outdoor"
      ]
    },
    en: {
      "name": "Side 150",
      "tagline": "Retractable pergola for large surfaces, with a standard 150 mm profile.",
      "description": "Side 150 is a retractable roof designed to extend and protect outdoor spaces with an essential structure and Black-Out fabric cover. The 81 × 150 × 2.5 mm profile, RTS control and integrated LED lighting make it suitable for terraces and wide surfaces. Waterproof and designed for outdoor use, with a clean architectural language that integrates easily.",
      "features": [
        "Retractable fabric roof system",
        "Profile 81 × 150 × 2.5 mm",
        "3-layer PVC Black-Out fabric",
        "Wind resistance Beaufort 6",
        "Concealed LED",
        "RTS remote control",
        "Waterproof system"
      ],
      "applications": [
        "Terraces",
        "Large outdoor surfaces"
      ]
    },
    image: "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/2.jpg",
    gallery: [
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/2.jpg",
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/7.jpg",
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/otomatik-rayli/8.jpg",
    ],
    highlights: [{"icon": "structure", "it": {"label": "Profilo", "value": "81 × 150 × 2,5 mm"}, "en": {"label": "Profile", "value": "81 × 150 × 2.5 mm"}}, {"icon": "rain", "it": {"label": "Copertura", "value": "Tessuto PVC Black-Out a 3 strati", "note": "Sistema impermeabile · vento Beaufort 6"}, "en": {"label": "Roof", "value": "3-layer PVC Black-Out fabric", "note": "Waterproof system · wind Beaufort 6"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED nascosto"}, "en": {"label": "Lighting", "value": "Concealed LED"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Telecomando RTS"}, "en": {"label": "Control", "value": "RTS remote control"}}],
  },
  "wp-efes-120": {
    slug: "wp-efes-120",
    category: "pergole-tende-schermature",
    it: {
      "name": "Efes 120",
      "tagline": "Sistema retrattile compatto per winter garden e spazi hospitality.",
      "description": "Efes 120 propone una copertura retrattile in tessuto Black-Out, costruita attorno a profili in alluminio 6060 e pensata per integrarsi con naturalezza in winter garden, hotel, ristoranti, caffè e pasticcerie. Il profilo portante da 120 mm, l'illuminazione LED nascosta e il sistema di gronda inferiore concentrano funzionalità e pulizia formale in una soluzione adatta a superfici outdoor che richiedono comfort e continuità architettonica.",
      "features": [
        "Pergola retrattile",
        "Profilo portante 7,5 × 120 × 2,2 mm",
        "Alluminio 6060",
        "3 assi portanti per modulo",
        "Movimento pieghevole / retrattile",
        "Tessuto Black-Out",
        "LED nascosto nei profili",
        "Sistema di gronda inferiore",
        "Telecomando"
      ],
      "applications": [
        "Winter garden",
        "Hotel",
        "Ristoranti",
        "Caffè e pasticcerie"
      ]
    },
    en: {
      "name": "Efes 120",
      "tagline": "Compact retractable system for winter gardens and hospitality.",
      "description": "Efes 120 offers a retractable Black-Out fabric roof built around 6060 aluminium profiles, designed to blend naturally into winter gardens, hotels, restaurants, cafés and pastry shops. The 120 mm load-bearing profile, concealed LED lighting and lower gutter system bring together function and clean design for outdoor surfaces that need comfort and architectural continuity.",
      "features": [
        "Retractable pergola",
        "Load-bearing profile 7.5 × 120 × 2.2 mm",
        "6060 aluminium",
        "3 load-bearing axes per module",
        "Folding / retractable movement",
        "Black-Out fabric",
        "LED concealed in the profiles",
        "Lower gutter system",
        "Remote control"
      ],
      "applications": [
        "Winter gardens",
        "Hotels",
        "Restaurants",
        "Cafés & pastry shops"
      ]
    },
    image: "/winperax/wp-efes-120.webp",
    gallery: [],
    highlights: [{"icon": "structure", "it": {"label": "Profilo portante", "value": "7,5 × 120 × 2,2 mm", "note": "Alluminio 6060, 3 assi portanti per modulo"}, "en": {"label": "Load-bearing profile", "value": "7.5 × 120 × 2.2 mm", "note": "6060 aluminium, 3 axes per module"}}, {"icon": "rain", "it": {"label": "Copertura", "value": "Tessuto Black-Out", "note": "Movimento pieghevole / retrattile, gronda inferiore"}, "en": {"label": "Roof", "value": "Black-Out fabric", "note": "Folding / retractable, lower gutter"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED nascosto nei profili"}, "en": {"label": "Lighting", "value": "LED concealed in the profiles"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Telecomando"}, "en": {"label": "Control", "value": "Remote control"}}],
  },
  "wp-zip-curtain": {
    slug: "wp-zip-curtain",
    category: "pergole-tende-schermature",
    it: {
      "name": "Zip Curtain",
      "tagline": "Tenda zip motorizzata per proteggere lateralmente gli spazi esterni.",
      "description": "Zip Curtain è una schermatura verticale motorizzata pensata per chiudere lateralmente pergole, terrazze e altri spazi outdoor senza rinunciare alla leggerezza visiva del tessuto tecnico. Il telo scorre verticalmente all'interno di guide in alluminio, mantenendosi teso e offrendo protezione da vento, pioggia, neve e sole. La configurazione compatta e la possibilità di automazione lo rendono particolarmente adatto a ville, caffè, ristoranti e ambienti esterni dove comfort e continuità visiva devono convivere.",
      "features": [
        "Tenda zip motorizzata per esterni",
        "Schermo tecnico per esterni",
        "Movimento verticale motorizzato",
        "Larghezza da 100 a 450 cm",
        "Guide verticali 49 × 49 mm",
        "Box motore 110 × 110 mm",
        "Profilo inferiore 50 × 40 mm",
        "Alluminio 6060",
        "Motore CE + telecomando",
        "Integrazione smart-home / automazione",
        "Protezione da vento, pioggia, neve e sole"
      ],
      "applications": [
        "Ville",
        "Caffè",
        "Ristoranti",
        "Terrazze"
      ]
    },
    en: {
      "name": "Zip Curtain",
      "tagline": "Motorised zip screen to close outdoor spaces at the sides.",
      "description": "Zip Curtain is a motorised vertical screen designed to close the sides of pergolas, terraces and other outdoor spaces while keeping the visual lightness of technical fabric. The fabric runs vertically inside aluminium guides, staying taut and protecting from wind, rain, snow and sun. Its compact configuration and automation options make it ideal for villas, cafés, restaurants and outdoor areas where comfort and visual continuity go together.",
      "features": [
        "Motorised outdoor zip screen",
        "Technical outdoor screen fabric",
        "Motorised vertical movement",
        "Width from 100 to 450 cm",
        "Vertical guides 49 × 49 mm",
        "Motor box 110 × 110 mm",
        "Bottom profile 50 × 40 mm",
        "6060 aluminium",
        "CE motor + remote control",
        "Smart-home / automation integration",
        "Protection from wind, rain, snow and sun"
      ],
      "applications": [
        "Villas",
        "Cafés",
        "Restaurants",
        "Terraces"
      ]
    },
    image: "/winperax/wp-zip-curtain.webp",
    gallery: [],
    highlights: [{"icon": "size", "it": {"label": "Larghezza realizzabile", "value": "da 100 a 450 cm"}, "en": {"label": "Available width", "value": "from 100 to 450 cm"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Alluminio 6060", "note": "Guide 49 × 49 mm · box motore 110 × 110 mm · profilo inferiore 50 × 40 mm"}, "en": {"label": "Structure", "value": "6060 aluminium", "note": "Guides 49 × 49 mm · motor box 110 × 110 mm · bottom profile 50 × 40 mm"}}, {"icon": "rain", "it": {"label": "Protezione", "value": "Vento, pioggia, neve e sole", "note": "Schermo tecnico per esterni, sempre teso nelle guide"}, "en": {"label": "Protection", "value": "Wind, rain, snow and sun", "note": "Technical screen, kept taut in the guides"}}, {"icon": "automation", "it": {"label": "Motorizzazione", "value": "Motore CE con telecomando", "note": "Integrazione smart-home / automazione"}, "en": {"label": "Motorisation", "value": "CE motor with remote control", "note": "Smart-home / automation integration"}}],
  },
  "wp-wintent": {
    slug: "wp-wintent",
    category: "pergole-tende-schermature",
    youtubeId: "t_ZSbpGWbB0",
    it: {
      "name": "Wintent",
      "tagline": "Sistema di schermatura esterna per finestre, terrazze e spazi aperti.",
      "description": "Wintent è una soluzione di schermatura esterna pensata per proteggere finestre e ambienti outdoor da pioggia e sporco, unendo funzionalità e presenza architettonica discreta. La gamma comprende differenti configurazioni e modelli, con tessuto acrilico europeo di prima qualità, bracci articolati con apertura fino a 180° e cassonetto in alluminio che nasconde il telo quando il sistema è chiuso. Il comando RTS può essere affiancato da una soluzione manuale.",
      "features": [
        "Schermatura esterna / Pen-Ten",
        "Tessuto acrilico europeo di prima qualità",
        "Motore con tecnologia RTS, certificazione CE",
        "Alternativa con riduttore manuale",
        "2 bracci per modulo con meccanismo a molla",
        "Profilo bracci in alluminio termico 12 · 6060",
        "Apertura bracci fino a 180°",
        "Cassonetto in alluminio: telo completamente nascosto a chiusura",
        "Verniciatura a polvere elettrostatica"
      ],
      "applications": [
        "Finestre",
        "Terrazze",
        "Spazi aperti"
      ]
    },
    en: {
      "name": "Wintent",
      "tagline": "External shading system for windows, terraces and open spaces.",
      "description": "Wintent is an external shading solution that protects windows and outdoor areas from rain and dirt, combining function with a discreet architectural presence. The range includes different configurations and models, with premium European acrylic fabric, articulated arms opening up to 180° and an aluminium cassette that hides the fabric when closed. RTS control can be paired with a manual option.",
      "features": [
        "External shading / Pen-Ten",
        "Premium European acrylic fabric",
        "RTS technology motor, CE certified",
        "Manual gearbox alternative",
        "2 spring-loaded arms per module",
        "Arm profile in thermal aluminium 12 · 6060",
        "Arm opening up to 180°",
        "Aluminium cassette: fabric fully hidden when closed",
        "Electrostatic powder coating"
      ],
      "applications": [
        "Windows",
        "Terraces",
        "Open spaces"
      ]
    },
    image: "https://winperax.com/images/urunler/tente-ve-golgelendirme/penten/1.jpg",
    gallery: [
      "https://winperax.com/images/urunler/tente-ve-golgelendirme/penten/1.jpg",
    ],
    highlights: [{"icon": "rain", "it": {"label": "Tessuto", "value": "Acrilico europeo di prima qualità", "note": "Cassonetto in alluminio, telo nascosto a chiusura"}, "en": {"label": "Fabric", "value": "Premium European acrylic", "note": "Aluminium cassette, fabric hidden when closed"}}, {"icon": "opening", "it": {"label": "Bracci", "value": "Articolati, apertura fino a 180°", "note": "2 bracci con meccanismo a molla per modulo"}, "en": {"label": "Arms", "value": "Articulated, opening up to 180°", "note": "2 spring-loaded arms per module"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Alluminio termico 12 · 6060", "note": "Verniciatura a polvere elettrostatica"}, "en": {"label": "Structure", "value": "Thermal aluminium 12 · 6060", "note": "Electrostatic powder coating"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Motore RTS certificato CE", "note": "Alternativa con riduttore manuale"}, "en": {"label": "Control", "value": "CE certified RTS motor", "note": "Manual gearbox alternative"}}],
  },
  "wp-apollon": {
    slug: "wp-apollon",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Apollon",
      "tagline": "Sistema a ghigliottina motorizzato per aprire verticalmente gli spazi vetrati.",
      "description": "Apollon è un sistema verticale motorizzato che consente di trasformare una superficie vetrata chiusa in uno spazio più aperto con un comando. Le ante possono essere movimentate verso l'alto e verso il basso e fermate al livello desiderato, permettendo di gestire l'apertura in modo parziale o completo. La configurazione può prevedere ante fisse e mobili e un traverso superiore, estendendo l'impiego anche a balconi e aperture in quota.",
      "features": [
        "Sistema a ghigliottina motorizzato",
        "2 o 3 pannelli; configurazioni a 3 ante con opzioni 4 / 2",
        "Movimento automatico in salita e discesa",
        "Arresto al livello desiderato",
        "Trasmissione a catena, cinghia opzionale",
        "Profilo in alluminio spessore 2 mm",
        "Dimensioni massime 5500 × 2200 mm",
        "Vetratura singola o isolante secondo configurazione",
        "Ante fisse e mobili, traverso superiore"
      ],
      "applications": [
        "Balconi",
        "Terrazze",
        "Aperture in quota"
      ]
    },
    en: {
      "name": "Apollon",
      "tagline": "Motorised guillotine system to open glazed spaces vertically.",
      "description": "Apollon is a motorised vertical system that turns a closed glazed surface into a more open space with one command. The sashes move up and down and stop at the desired level, allowing partial or full openings. Configurations can include fixed and moving sashes and an upper transom, extending use to balconies and high openings.",
      "features": [
        "Motorised guillotine system",
        "2 or 3 panels; 3-sash configurations with 4 / 2 options",
        "Automatic up and down movement",
        "Stops at the desired level",
        "Chain drive, optional belt",
        "2 mm thick aluminium profile",
        "Maximum size 5500 × 2200 mm",
        "Single or insulated glazing depending on configuration",
        "Fixed and moving sashes, upper transom"
      ],
      "applications": [
        "Balconies",
        "Terraces",
        "High openings"
      ]
    },
    image: "/winperax/wp-apollon.webp",
    gallery: [],
    highlights: [{"icon": "opening", "it": {"label": "Movimento", "value": "Salita e discesa motorizzata", "note": "Arresto al livello desiderato"}, "en": {"label": "Movement", "value": "Motorised up and down", "note": "Stops at the desired level"}}, {"icon": "size", "it": {"label": "Dimensioni massime", "value": "5500 × 2200 mm", "note": "2 o 3 pannelli, opzioni 4 / 2"}, "en": {"label": "Maximum size", "value": "5500 × 2200 mm", "note": "2 or 3 panels, 4 / 2 options"}}, {"icon": "glass", "it": {"label": "Vetratura", "value": "Singola o isolante", "note": "Secondo configurazione"}, "en": {"label": "Glazing", "value": "Single or insulated", "note": "Depending on configuration"}}, {"icon": "structure", "it": {"label": "Profilo", "value": "Alluminio spessore 2 mm"}, "en": {"label": "Profile", "value": "2 mm aluminium"}}, {"icon": "automation", "it": {"label": "Trasmissione", "value": "A catena", "note": "Cinghia", "noteStatus": "optional"}, "en": {"label": "Drive", "value": "Chain", "note": "Belt", "noteStatus": "optional"}}],
  },
  "wp-apollon-plus": {
    slug: "wp-apollon-plus",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Apollon Plus",
      "tagline": "Sistema a ghigliottina evoluto con movimentazione verticale motorizzata e vetro isolante.",
      "description": "Apollon Plus porta la chiusura verticale a un livello superiore di flessibilità, combinando vetro isolante e movimentazione motorizzata verso l'alto e verso il basso. Le ante mobili possono fermarsi a qualsiasi quota, consentendo di modulare la relazione tra interno ed esterno in base alle esigenze dello spazio. La trasmissione a cinghia e ingranaggi e il box motore superiore completano una soluzione adatta a hotel, residenze, negozi, ristorazione, verande e terrazze.",
      "features": [
        "Sistema a ghigliottina",
        "Vetratura 4+16+4 mm (documentazione di famiglia: anche 6+12+6 mm)",
        "Salita e discesa automatica",
        "Controllo con pulsante e telecomando",
        "3 ante, opzioni 4 / 2",
        "Arresto a qualsiasi livello",
        "Trasmissione a cinghia e ingranaggi",
        "Dimensioni massime 5500 × 2200 mm",
        "Box motore superiore dedicato"
      ],
      "applications": [
        "Hotel",
        "Residenze",
        "Negozi",
        "Ristorazione",
        "Verande e terrazze"
      ]
    },
    en: {
      "name": "Apollon Plus",
      "tagline": "Advanced guillotine system with motorised vertical movement and insulated glass.",
      "description": "Apollon Plus takes vertical enclosures to a higher level of flexibility, combining insulated glass with motorised up and down movement. The moving sashes can stop at any height, modulating the relationship between inside and outside as needed. Belt-and-gear drive and an upper motor box complete a solution for hotels, homes, shops, restaurants, verandas and terraces.",
      "features": [
        "Guillotine system",
        "Glazing 4+16+4 mm (family documentation: also 6+12+6 mm)",
        "Automatic up and down",
        "Push-button and remote control",
        "3 sashes, 4 / 2 options",
        "Stops at any level",
        "Belt-and-gear drive",
        "Maximum size 5500 × 2200 mm",
        "Dedicated upper motor box"
      ],
      "applications": [
        "Hotels",
        "Homes",
        "Shops",
        "Restaurants",
        "Verandas & terraces"
      ]
    },
    image: "/winperax/wp-apollon-plus.webp",
    gallery: [],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "Vetro isolante 4+16+4 mm", "note": "Documentazione di famiglia: anche 6+12+6 mm"}, "en": {"label": "Glazing", "value": "Insulated glass 4+16+4 mm", "note": "Family documentation: also 6+12+6 mm"}}, {"icon": "opening", "it": {"label": "Movimento", "value": "Salita e discesa automatica", "note": "Arresto a qualsiasi livello"}, "en": {"label": "Movement", "value": "Automatic up and down", "note": "Stops at any level"}}, {"icon": "size", "it": {"label": "Dimensioni massime", "value": "5500 × 2200 mm", "note": "3 ante, opzioni 4 / 2"}, "en": {"label": "Maximum size", "value": "5500 × 2200 mm", "note": "3 sashes, 4 / 2 options"}}, {"icon": "automation", "it": {"label": "Controllo", "value": "Pulsante e telecomando", "note": "Trasmissione a cinghia e ingranaggi, box motore superiore"}, "en": {"label": "Control", "value": "Push-button and remote", "note": "Belt-and-gear drive, upper motor box"}}],
  },
  "wp-cotil": {
    slug: "wp-cotil",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Cotil",
      "tagline": "Sistema a ghigliottina standard per chiusure vetrate verticali.",
      "description": "Cotil è una soluzione a ghigliottina pensata per chiudere e aprire verticalmente gli spazi con una presenza architettonica essenziale. La configurazione standard a tre ante utilizza vetro isolante e permette la movimentazione in salita e discesa, fino a creare una chiusura completamente aperta secondo la configurazione del progetto. Le dimensioni massime dichiarate lo rendono adatto a terrazze, verande e contesti residenziali o commerciali.",
      "features": [
        "Sistema a ghigliottina standard",
        "Vetro isolante 4+16+4 mm oppure 6+12+6 mm",
        "Movimento in salita e discesa",
        "3 ante di serie",
        "Larghezza massima 3500 mm",
        "Altezza massima 3000 mm",
        "Sistema completamente chiuso"
      ],
      "applications": [
        "Terrazze",
        "Verande",
        "Residenziale",
        "Commerciale"
      ]
    },
    en: {
      "name": "Cotil",
      "tagline": "Standard guillotine system for vertical glass enclosures.",
      "description": "Cotil is a guillotine solution designed to close and open spaces vertically with an essential architectural presence. The standard three-sash configuration uses insulated glass and moves up and down, up to a fully open enclosure depending on the project. Its declared maximum sizes make it suitable for terraces, verandas and residential or commercial settings.",
      "features": [
        "Standard guillotine system",
        "Insulated glass 4+16+4 mm or 6+12+6 mm",
        "Up and down movement",
        "3 sashes as standard",
        "Maximum width 3500 mm",
        "Maximum height 3000 mm",
        "Fully closed system"
      ],
      "applications": [
        "Terraces",
        "Verandas",
        "Residential",
        "Commercial"
      ]
    },
    image: "/winperax/wp-cotil.webp",
    gallery: [],
    highlights: [{"icon": "glass", "it": {"label": "Vetro", "value": "Isolante 4+16+4 mm oppure 6+12+6 mm"}, "en": {"label": "Glass", "value": "Insulated 4+16+4 mm or 6+12+6 mm"}}, {"icon": "opening", "it": {"label": "Movimento", "value": "Salita e discesa", "note": "3 ante", "noteStatus": "serie"}, "en": {"label": "Movement", "value": "Up and down", "note": "3 sashes", "noteStatus": "serie"}}, {"icon": "size", "it": {"label": "Dimensioni massime", "value": "3500 × 3000 mm", "note": "Larghezza 3500 mm · altezza 3000 mm"}, "en": {"label": "Maximum size", "value": "3500 × 3000 mm", "note": "Width 3500 mm · height 3000 mm"}}, {"icon": "structure", "it": {"label": "Chiusura", "value": "Sistema completamente chiuso"}, "en": {"label": "Enclosure", "value": "Fully closed system"}}],
  },
  "wp-termessos": {
    slug: "wp-termessos",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Termessos",
      "tagline": "Sistema scorrevole orizzontale per chiusure vetrate flessibili e leggere.",
      "description": "Termessos è un sistema scorrevole orizzontale progettato per creare chiusure vetrate mobili senza interrompere la continuità dello spazio. Le ante, con larghezza compresa tra 40 e 100 cm, scorrono lungo il sistema permettendo di modulare l'apertura secondo l'utilizzo dell'ambiente. La disponibilità di vetro monolitico o vetro camera consente di configurare la soluzione in funzione del livello di isolamento richiesto.",
      "features": [
        "Sistema scorrevole",
        "Movimento orizzontale",
        "Vetro 8 / 10 mm oppure vetro camera",
        "Larghezza anta 40–100 cm",
        "Altezza massima 260 cm"
      ],
      "applications": [
        "Balconi",
        "Terrazze",
        "Verande"
      ]
    },
    en: {
      "name": "Termessos",
      "tagline": "Horizontal sliding system for light, flexible glass enclosures.",
      "description": "Termessos is a horizontal sliding system designed to create movable glass enclosures without interrupting the continuity of the space. Sashes from 40 to 100 cm wide slide along the system, modulating the opening to suit how the space is used. Monolithic or double glazing lets you configure the solution for the insulation level required.",
      "features": [
        "Sliding system",
        "Horizontal movement",
        "8 / 10 mm glass or double glazing",
        "Sash width 40–100 cm",
        "Maximum height 260 cm"
      ],
      "applications": [
        "Balconies",
        "Terraces",
        "Verandas"
      ]
    },
    image: "/winperax/wp-termessos.webp",
    gallery: [],
    highlights: [{"icon": "opening", "it": {"label": "Movimento", "value": "Scorrevole orizzontale"}, "en": {"label": "Movement", "value": "Horizontal sliding"}}, {"icon": "glass", "it": {"label": "Vetro", "value": "8 / 10 mm oppure vetro camera"}, "en": {"label": "Glass", "value": "8 / 10 mm or double glazing"}}, {"icon": "size", "it": {"label": "Altezza massima", "value": "260 cm"}, "en": {"label": "Maximum height", "value": "260 cm"}}, {"icon": "depth", "it": {"label": "Larghezza anta", "value": "40–100 cm"}, "en": {"label": "Sash width", "value": "40–100 cm"}}],
  },
  "wp-termessos-plus": {
    slug: "wp-termessos-plus",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Termessos Plus",
      "tagline": "Sistema scorrevole assistito per chiusure vetrate di maggiore altezza.",
      "description": "Termessos Plus sviluppa il concetto del sistema scorrevole attraverso una movimentazione assistita, pensata per chiusure vetrate di maggiore altezza. Le ante scorrono orizzontalmente e possono essere configurate con vetro monolitico o vetro camera, combinando flessibilità d'uso e maggiore comfort. Con un'altezza massima dichiarata di 350 cm, rappresenta una soluzione adatta a progetti residenziali e commerciali che richiedono superfici vetrate più importanti.",
      "features": [
        "Sistema scorrevole assistito",
        "Movimento orizzontale assistito",
        "Vetro monolitico 8 / 10 mm oppure 4+12+4 mm",
        "Larghezza anta 40–100 cm",
        "Altezza massima 350 cm"
      ],
      "applications": [
        "Residenziale",
        "Commerciale",
        "Grandi vetrate"
      ]
    },
    en: {
      "name": "Termessos Plus",
      "tagline": "Assisted sliding system for taller glass enclosures.",
      "description": "Termessos Plus develops the sliding concept with assisted movement, designed for taller glass enclosures. Sashes slide horizontally and can be configured with monolithic or double glazing, combining flexibility and comfort. With a declared maximum height of 350 cm, it suits residential and commercial projects that need larger glazed surfaces.",
      "features": [
        "Assisted sliding system",
        "Assisted horizontal movement",
        "8 / 10 mm monolithic glass or 4+12+4 mm",
        "Sash width 40–100 cm",
        "Maximum height 350 cm"
      ],
      "applications": [
        "Residential",
        "Commercial",
        "Large glazing"
      ]
    },
    image: "/winperax/wp-termessos-plus.webp",
    gallery: [],
    highlights: [{"icon": "opening", "it": {"label": "Movimento", "value": "Scorrevole orizzontale assistito"}, "en": {"label": "Movement", "value": "Assisted horizontal sliding"}}, {"icon": "glass", "it": {"label": "Vetro", "value": "Monolitico 8 / 10 mm oppure 4+12+4 mm"}, "en": {"label": "Glass", "value": "Monolithic 8 / 10 mm or 4+12+4 mm"}}, {"icon": "size", "it": {"label": "Altezza massima", "value": "350 cm"}, "en": {"label": "Maximum height", "value": "350 cm"}}, {"icon": "depth", "it": {"label": "Larghezza anta", "value": "40–100 cm"}, "en": {"label": "Sash width", "value": "40–100 cm"}}],
  },
  "wp-adorado": {
    slug: "wp-adorado",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Adorado",
      "tagline": "Sistema scorrevole a libro per aprire le ante verso l'esterno.",
      "description": "Adorado combina scorrimento e apertura a libro per concentrare i pannelli lateralmente e liberare rapidamente il passaggio. Ogni anta è composta da due pannelli e può muoversi indipendentemente dalle altre, offrendo una configurazione flessibile per terrazze e chiusure vetrate. L'apertura verso l'esterno mantiene il gesto di apertura semplice e leggibile, mentre l'altezza massima dichiarata di 250 cm permette di adattare il sistema a numerosi progetti outdoor.",
      "features": [
        "Sistema scorrevole a libro",
        "Scorrimento + apertura a libro verso l'esterno",
        "2 pannelli per anta",
        "Ante a movimento indipendente",
        "Larghezza pannello massimo 80 cm",
        "Altezza massima 250 cm"
      ],
      "applications": [
        "Terrazze",
        "Chiusure vetrate",
        "Progetti outdoor"
      ]
    },
    en: {
      "name": "Adorado",
      "tagline": "Folding-sliding system with sashes opening outwards.",
      "description": "Adorado combines sliding and folding to stack the panels at the side and quickly free the passage. Each sash is made of two panels and moves independently, offering a flexible configuration for terraces and glass enclosures. Opening outwards keeps the gesture simple and intuitive, while the declared maximum height of 250 cm adapts the system to many outdoor projects.",
      "features": [
        "Folding-sliding system",
        "Sliding + outward folding",
        "2 panels per sash",
        "Independently moving sashes",
        "Maximum panel width 80 cm",
        "Maximum height 250 cm"
      ],
      "applications": [
        "Terraces",
        "Glass enclosures",
        "Outdoor projects"
      ]
    },
    image: "/winperax/wp-adorado.webp",
    gallery: [],
    highlights: [{"icon": "opening", "it": {"label": "Movimento", "value": "Scorrimento con apertura a libro verso l'esterno", "note": "Ante a movimento indipendente"}, "en": {"label": "Movement", "value": "Sliding with outward folding", "note": "Independently moving sashes"}}, {"icon": "structure", "it": {"label": "Configurazione", "value": "2 pannelli per anta"}, "en": {"label": "Configuration", "value": "2 panels per sash"}}, {"icon": "size", "it": {"label": "Altezza massima", "value": "250 cm"}, "en": {"label": "Maximum height", "value": "250 cm"}}, {"icon": "depth", "it": {"label": "Larghezza pannello", "value": "massimo 80 cm"}, "en": {"label": "Panel width", "value": "maximum 80 cm"}}],
  },
  "wp-wind-breaker": {
    slug: "wp-wind-breaker",
    category: "pergole-chiusure-vetrate",
    it: {
      "name": "Wind Breaker",
      "tagline": "Paravento motorizzato verticale per proteggere terrazze e dehors.",
      "description": "Wind Breaker è un sistema verticale motorizzato che combina vetro e alluminio per proteggere gli spazi esterni dal vento mantenendo una presenza visiva pulita. Il pannello mobile in vetro temperato sale e scende con comando motorizzato, mentre il profilo guida integra la struttura in modo compatto. Con una resistenza dichiarata fino a Beaufort 6 e dimensioni massime di 3000 × 1800 mm, è pensato per terrazze, dehors e aperture esterne.",
      "features": [
        "Sistema paravento motorizzato",
        "Vetro fisso 8 mm",
        "Vetro mobile temperato 10 mm",
        "Salita / discesa motorizzata",
        "Resistenza al vento Beaufort 6 · fino a 50 km/h",
        "Dimensioni massime 3000 × 1800 mm",
        "Profilo guida 82 × 150 mm",
        "Alluminio 6060"
      ],
      "applications": [
        "Terrazze",
        "Dehors",
        "Aperture esterne"
      ]
    },
    en: {
      "name": "Wind Breaker",
      "tagline": "Motorised vertical windbreak to protect terraces and outdoor seating.",
      "description": "Wind Breaker is a motorised vertical system combining glass and aluminium to protect outdoor spaces from wind while keeping a clean visual presence. The tempered glass moving panel rises and lowers by motor, while the guide profile integrates the structure compactly. With declared resistance up to Beaufort 6 and maximum size of 3000 × 1800 mm, it is designed for terraces, outdoor seating and external openings.",
      "features": [
        "Motorised windbreak system",
        "Fixed glass 8 mm",
        "Tempered moving glass 10 mm",
        "Motorised up / down",
        "Wind resistance Beaufort 6 · up to 50 km/h",
        "Maximum size 3000 × 1800 mm",
        "Guide profile 82 × 150 mm",
        "6060 aluminium"
      ],
      "applications": [
        "Terraces",
        "Outdoor seating",
        "External openings"
      ]
    },
    image: "/winperax/wp-wind-breaker.webp",
    gallery: [],
    highlights: [{"icon": "rain", "it": {"label": "Resistenza al vento", "value": "Beaufort 6 · fino a 50 km/h"}, "en": {"label": "Wind resistance", "value": "Beaufort 6 · up to 50 km/h"}}, {"icon": "glass", "it": {"label": "Vetro", "value": "Mobile temperato 10 mm · fisso 8 mm"}, "en": {"label": "Glass", "value": "Moving tempered 10 mm · fixed 8 mm"}}, {"icon": "size", "it": {"label": "Dimensioni massime", "value": "3000 × 1800 mm"}, "en": {"label": "Maximum size", "value": "3000 × 1800 mm"}}, {"icon": "structure", "it": {"label": "Profilo guida", "value": "82 × 150 mm in alluminio 6060"}, "en": {"label": "Guide profile", "value": "82 × 150 mm, 6060 aluminium"}}, {"icon": "automation", "it": {"label": "Movimento", "value": "Salita / discesa motorizzata"}, "en": {"label": "Movement", "value": "Motorised up / down"}}],
  },

  // PERGOLE — Coperture Vetrate (Winperax Glass Balcony)

  // PERGOLE — Coperture in Vetro (Glass Roof Systems Winperax)
  "wp-sky-phaselis": {
    slug: "wp-sky-phaselis",
    category: "pergole-glass-roof",
    youtubeId: "vj8S96yhooM",
    it: {
      "name": "Sky Phaselis",
      "tagline": "Sistema retrattile con vetro isolante per trasformare la copertura in uno spazio aperto.",
      "description": "Sky Phaselis trasforma una copertura vetrata in una superficie dinamica, capace di aprirsi e richiudersi con un semplice comando. Le ante in vetro isolante possono essere arrestate alla quota desiderata, consentendo aperture parziali o complete e mantenendo la continuità visiva verso il cielo. Il box motore superiore è integrato nei profili in alluminio e accessibile per la manutenzione. Una soluzione adatta a hotel, residenze, ristoranti, winter garden e terrazze.",
      "features": [
        "Copertura vetrata retrattile",
        "4 ante, opzionale fino a 5",
        "Vetro isolante",
        "Movimento retrattile con arresto a qualsiasi livello",
        "Guide laterali 180 × 117 mm · parete 3 mm",
        "Modulo massimo 2500 × 4000 mm",
        "Modulo facciata / apertura 1500 × 8000 mm",
        "Box motore superiore in alluminio",
        "Manutenzione: accesso dal coperchio del box motore",
        "Sensori pioggia, sole e vento opzionali",
        "Illuminazione LED opzionale"
      ],
      "applications": [
        "Hotel",
        "Residenze",
        "Ristoranti",
        "Winter garden",
        "Terrazze"
      ]
    },
    en: {
      "name": "Sky Phaselis",
      "tagline": "Retractable insulated glass system that turns the roof into an open space.",
      "description": "Sky Phaselis turns a glass roof into a dynamic surface that opens and closes with a simple command. The insulated glass sashes can be stopped at any height, allowing partial or full openings while keeping visual continuity with the sky. The upper motor box is integrated into the aluminium profiles and accessible for maintenance. Suited to hotels, homes, restaurants, winter gardens and terraces.",
      "features": [
        "Retractable glass roof",
        "4 sashes, optionally up to 5",
        "Insulated glass",
        "Retractable movement, stops at any level",
        "Side guides 180 × 117 mm · 3 mm wall",
        "Maximum module 2500 × 4000 mm",
        "Façade / opening module 1500 × 8000 mm",
        "Upper aluminium motor box",
        "Maintenance access from the motor box cover",
        "Optional rain, sun and wind sensors",
        "Optional LED lighting"
      ],
      "applications": [
        "Hotels",
        "Homes",
        "Restaurants",
        "Winter gardens",
        "Terraces"
      ]
    },
    image: "https://winperax.com/images/urunler/otomatik/4.jpg",
    gallery: [
      "https://winperax.com/images/urunler/otomatik/4.jpg",
      "https://winperax.com/images/urunler/otomatik/5.jpg",
    ],
    highlights: [{"icon": "glass", "it": {"label": "Copertura", "value": "Vetro isolante retrattile", "note": "4 ante, fino a 5", "noteStatus": "optional"}, "en": {"label": "Roof", "value": "Retractable insulated glass", "note": "4 sashes, up to 5", "noteStatus": "optional"}}, {"icon": "opening", "it": {"label": "Apertura", "value": "Arresto a qualsiasi livello", "note": "Aperture parziali o complete"}, "en": {"label": "Opening", "value": "Stops at any level", "note": "Partial or full openings"}}, {"icon": "size", "it": {"label": "Dimensioni", "value": "Modulo massimo 2500 × 4000 mm", "note": "Modulo facciata / apertura 1500 × 8000 mm"}, "en": {"label": "Dimensions", "value": "Maximum module 2500 × 4000 mm", "note": "Façade / opening module 1500 × 8000 mm"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Guide laterali 180 × 117 mm", "note": "Box motore superiore in alluminio, ispezionabile"}, "en": {"label": "Structure", "value": "Side guides 180 × 117 mm", "note": "Upper aluminium motor box, inspectable"}}, {"icon": "automation", "it": {"label": "Automazione", "value": "Motorizzata", "note": "Sensori pioggia, sole e vento", "noteStatus": "optional"}, "en": {"label": "Automation", "value": "Motorised", "note": "Rain, sun and wind sensors", "noteStatus": "optional"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED integrati", "status": "optional"}, "en": {"label": "Lighting", "value": "Integrated LEDs", "status": "optional"}}],
  },
  "wp-likya": {
    slug: "wp-likya",
    category: "pergole-glass-roof",
    it: {
      "name": "Likya",
      "tagline": "Copertura vetrata fissa per terrazze, balconi e ambienti outdoor.",
      "description": "Likya offre una copertura vetrata fissa dal disegno essenziale, pensata per portare luce naturale e continuità visiva negli spazi outdoor senza introdurre elementi mobili. La struttura in alluminio accoglie pannelli vetrati fino a 400 × 100 cm e integra un sistema di drenaggio con grondaia auto-pendente e parete posteriore. È possibile completare la copertura con una tenda a soffitto integrabile, ampliando le possibilità di comfort e controllo della luce.",
      "features": [
        "Copertura vetrata fissa",
        "Vetro temperato isolante / stratificato",
        "Formato vetro massimo 400 × 100 cm",
        "Guide portanti 60 × 120 × 1,6 mm",
        "Interasse guide 100 cm",
        "Profili in alluminio",
        "Grondaia auto-pendente + parete posteriore",
        "Tenda a soffitto integrabile",
        "Illuminazione LED opzionale"
      ],
      "applications": [
        "Terrazze",
        "Balconi",
        "Ambienti outdoor"
      ]
    },
    en: {
      "name": "Likya",
      "tagline": "Fixed glass roof for terraces, balconies and outdoor spaces.",
      "description": "Likya offers a fixed glass roof with an essential design, bringing natural light and visual continuity to outdoor spaces without moving parts. The aluminium structure holds glass panels up to 400 × 100 cm and integrates drainage with a self-sloping gutter and rear wall. The roof can be completed with an integrable ceiling awning for more comfort and light control.",
      "features": [
        "Fixed glass roof",
        "Tempered insulated / laminated glass",
        "Maximum glass size 400 × 100 cm",
        "Bearing rails 60 × 120 × 1.6 mm",
        "Rail spacing 100 cm",
        "Aluminium profiles",
        "Self-sloping gutter + rear wall",
        "Integrable ceiling awning",
        "Optional LED lighting"
      ],
      "applications": [
        "Terraces",
        "Balconies",
        "Outdoor spaces"
      ]
    },
    image: "https://winperax.com/images/urunler/otomatik/1.jpg",
    gallery: [
      "https://winperax.com/images/urunler/otomatik/1.jpg",
      "https://winperax.com/images/urunler/otomatik/2.jpg",
      "https://winperax.com/images/urunler/otomatik/3.jpg",
    ],
    highlights: [{"icon": "glass", "it": {"label": "Vetratura", "value": "Vetro temperato isolante / stratificato", "note": "Lastra fino a 400 × 100 cm"}, "en": {"label": "Glazing", "value": "Tempered insulated / laminated glass", "note": "Panel up to 400 × 100 cm"}}, {"icon": "structure", "it": {"label": "Struttura", "value": "Guide portanti 60 × 120 × 1,6 mm", "note": "Interasse 100 cm, profili in alluminio"}, "en": {"label": "Structure", "value": "Bearing rails 60 × 120 × 1.6 mm", "note": "100 cm spacing, aluminium profiles"}}, {"icon": "rain", "it": {"label": "Drenaggio", "value": "Grondaia auto-pendente + parete posteriore"}, "en": {"label": "Drainage", "value": "Self-sloping gutter + rear wall"}}, {"icon": "led", "it": {"label": "Illuminazione", "value": "LED integrati", "status": "optional"}, "en": {"label": "Lighting", "value": "Integrated LEDs", "status": "optional"}}, {"icon": "opening", "it": {"label": "Comfort", "value": "Tenda a soffitto integrabile", "status": "optional"}, "en": {"label": "Comfort", "value": "Integrable ceiling awning", "status": "optional"}}],
  },
};

/** Helpers */
export function getCategory(slug) {
  return CATEGORIES[slug] || null;
}
export function getMacro(slug) {
  return MACROS[slug] || null;
}
export function getProduct(slug) {
  return PRODUCTS[slug] || null;
}
export function productsInCategory(slug) {
  return Object.values(PRODUCTS).filter((p) => p.category === slug);
}
export function subCategoriesOf(parentSlug) {
  return Object.values(CATEGORIES).filter((c) => c.parent === parentSlug);
}

/**
 * Build a compact array of "pill" specs for a product, localized IT/EN.
 * Returns array of { label: string, highlight?: boolean }.
 */
/** Proposta C — in-page grouping of leaf-category products into product lines. */
export const CATEGORY_GROUPS = {
  "pergole-tende-schermature": [
    {
      id: "pergole-retrattili",
      it: { title: "Pergole retrattili", sub: "Coperture in tessuto Black-Out per terrazze, winter garden e hospitality." },
      en: { title: "Retractable pergolas", sub: "Black-Out fabric roofs for terraces, winter gardens and hospitality." },
      products: ["wp-olympos-170", "wp-side-150", "wp-efes-120"],
    },
    {
      id: "schermature",
      it: { title: "Schermature", sub: "Tende zip laterali e schermature a bracci per finestre e spazi aperti." },
      en: { title: "Shading", sub: "Side zip screens and arm awnings for windows and open spaces." },
      products: ["wp-zip-curtain", "wp-wintent"],
    },
  ],
  "pergole-chiusure-vetrate": [
    {
      id: "ghigliottine",
      it: { title: "Sistemi a ghigliottina", sub: "Vetrate che salgono e scendono, fino a fermarsi alla quota desiderata." },
      en: { title: "Guillotine systems", sub: "Glazing that rises and lowers, stopping at the desired height." },
      products: ["wp-apollon", "wp-apollon-plus", "wp-cotil"],
    },
    {
      id: "scorrevoli-paraventi",
      it: { title: "Scorrevoli, a libro e paraventi", sub: "Chiusure orizzontali e protezioni dal vento per terrazze e dehors." },
      en: { title: "Sliding, folding and windbreaks", sub: "Horizontal enclosures and wind protection for terraces and outdoor seating." },
      products: ["wp-termessos", "wp-termessos-plus", "wp-adorado", "wp-wind-breaker"],
    },
  ],
  "alluminio-porte-finestre": [
    {
      id: "essenziali",
      it: { title: "Essenziali a taglio termico (55–56 mm)", sub: "Sistemi versatili e convenienti con tutte le aperture: la base affidabile per casa e piccoli edifici." },
      en: { title: "Thermal-break essentials (55–56 mm)", sub: "Versatile, affordable systems with every opening type." },
      products: ["asas-rwt55", "asas-rwt55-plus", "asas-rwt56"],
    },
    {
      id: "isolamento-64",
      it: { title: "Isolamento avanzato (64 mm)", sub: "Barretta da 24 mm e vetri fino a 44 mm: più comfort e silenzio senza passare a profili più profondi." },
      en: { title: "Advanced insulation (64 mm)", sub: "24 mm barrier and glazing up to 44 mm for more comfort." },
      products: ["asas-rwt64", "asas-rwtp64"],
    },
    {
      id: "alto-isolamento",
      it: { title: "Alto isolamento e Passive House (75–95 mm)", sub: "Per ville, edifici efficienti e case passive: le prestazioni termiche più alte in alluminio." },
      en: { title: "High insulation & Passive House (75–95 mm)", sub: "For villas, efficient buildings and passive houses." },
      products: ["asas-rwt75", "asas-rwt75f", "asas-rwt95"],
    },
    {
      id: "design",
      it: { title: "Design", sub: "Estetiche speciali: profili sottili effetto acciaio o anta nascosta per facciate pulite." },
      en: { title: "Design", sub: "Special aesthetics: steel-look slim profiles or hidden vents." },
      products: ["asas-asw34", "asas-rwt67"],
    },
  ],
  "alluminio-scorrevole": [
    {
      id: "alzanti",
      it: { title: "Alzanti scorrevoli", sub: "L'anta si solleva e scorre senza sforzo: grandi vetrate isolate per soggiorni e terrazze." },
      en: { title: "Lift-and-slide", sub: "The sash lifts and glides effortlessly: large insulated glazing." },
      products: ["asas-rst116", "asas-rst162"],
    },
    {
      id: "minimal-performance",
      it: { title: "Minimal e alte prestazioni", sub: "Profili quasi invisibili o chiusura intelligente a tenuta per edifici di prestigio." },
      en: { title: "Minimal & high performance", sub: "Near-invisible frames or smart sealed closing for prestigious buildings." },
      products: ["asas-resf32", "asas-repf160"],
    },
    {
      id: "libro",
      it: { title: "Porte a libro", sub: "Le ante si impacchettano di lato e la parete si apre completamente." },
      en: { title: "Folding doors", sub: "Panels stack to the side and the wall opens completely." },
      products: ["asas-refd77"],
    },
  ],
  "alluminio-facciate": [
    {
      id: "continue",
      it: { title: "Facciate continue", sub: "Montanti e traversi per involucri vetrati: a coprigiunto, strutturali e semi-strutturali." },
      en: { title: "Curtain walls", sub: "Stick systems for glazed envelopes: capped, structural and semi-structural." },
      products: ["asas-e50", "asas-r50", "asas-rt50", "asas-ref60"],
    },
    {
      id: "cellule",
      it: { title: "Facciate a cellule e window wall", sub: "Elementi preassemblati o da solaio a solaio per posare più in fretta, anche senza ponteggi." },
      en: { title: "Unitised & window wall", sub: "Pre-assembled or floor-to-floor systems for faster installation." },
      products: ["asas-rpe82", "asas-reww141"],
    },
    {
      id: "lucernari-frangisole",
      it: { title: "Lucernari e frangisole", sub: "Luce dall'alto e controllo del sole per completare la facciata." },
      en: { title: "Skylights & sunshades", sub: "Daylight from above and sun control to complete the facade." },
      products: ["asas-rsk50", "asas-rss", "asas-sn42"],
    },
  ],
  "alluminio-rivestimenti": [
    {
      id: "lastre",
      it: { title: "Lastre e pannelli", sub: "Pannelli compositi e lastre in alluminio incombustibili, anche forate e in 3D." },
      en: { title: "Sheets & panels", sub: "Composite panels and non-combustible aluminium sheets, also perforated and 3D." },
      products: ["asas-comp50", "asas-skypanel"],
    },
    {
      id: "terracotta",
      it: { title: "Terracotta", sub: "Il calore della terracotta su una sottostruttura in alluminio." },
      en: { title: "Terracotta", sub: "The warmth of terracotta on an aluminium substructure." },
      products: ["asas-rtc22", "asas-rtc22-plus"],
    },
    {
      id: "decorativi",
      it: { title: "Doghe, lamelle e profili decorativi", sub: "Profili a incastro per dare ritmo e carattere alla facciata." },
      en: { title: "Planks, fins & decorative profiles", sub: "Interlocking profiles that give rhythm and character to the facade." },
      products: ["asas-rdp", "asas-rdm50", "asas-rsp22", "asas-rpc40"],
    },
  ],
  "alluminio-parapetti": [
    {
      id: "parapetti",
      it: { title: "Parapetti in vetro", sub: "Protezioni trasparenti per balconi, scale e portefinestre." },
      en: { title: "Glass balustrades", sub: "Transparent guards for balconies, stairs and French windows." },
      products: ["asas-rb90", "asas-rb120", "asas-rbsl65", "asas-rejb50"],
    },
    {
      id: "vetrate-balconi",
      it: { title: "Vetrate per balconi", sub: "A pacchetto o scorrevoli: chiudono balconi e verande e si aprono quando serve." },
      en: { title: "Balcony glazing", sub: "Folding or sliding: they enclose balconies and open when needed." },
      products: ["asas-rfg46", "asas-rfg46-plus", "asas-rsg104"],
    },
  ],
  "alluminio-pareti-ufficio": [
    {
      id: "pareti-vetro",
      it: { title: "Pareti in vetro", sub: "Vetro singolo o doppio per uffici luminosi, con veneziane e passacavi integrati." },
      en: { title: "Glass partitions", sub: "Single or double glazing for bright offices, with integrated blinds and cable channels." },
      products: ["asas-ro26", "asas-ro77", "asas-ro108"],
    },
    {
      id: "porte-interni",
      it: { title: "Porte per interni", sub: "Porte in alluminio con ante in legno o vetro, adattabili allo spessore del muro." },
      en: { title: "Interior doors", sub: "Aluminium doors with wooden or glass leaves, adaptable to wall thickness." },
      products: ["asas-rd55"],
    },
  ],
  "pvc-porte-finestre": [
    {
      id: "inova",
      it: { title: "Linea INOVA — Alte prestazioni", sub: "La piattaforma premium da 76 mm: dal comfort elevato fino alla certificazione Passive House." },
      en: { title: "INOVA Line — High performance", sub: "The premium 76 mm platform: from high comfort up to Passive House certification." },
      products: ["asas-inova-76-md", "asas-inova-76", "asas-inova-plus", "asas-inova-76-ph", "asas-inova-76-door"],
    },
    {
      id: "elegans",
      it: { title: "Linea Elegans & Diamond — L'essenziale di qualità", sub: "Sistemi pratici e convenienti per il residenziale e la sostituzione dei serramenti." },
      en: { title: "Elegans & Diamond Line — Quality essentials", sub: "Practical, affordable systems for residential projects and window replacement." },
      products: ["asas-elegans-70", "asas-elegans-60", "asas-diamond-60"],
    },
    {
      id: "maxi",
      it: { title: "Linea Maxi — Soluzioni speciali", sub: "Apertura verso l'esterno e profili dedicati agli edifici alti più esposti al vento." },
      en: { title: "Maxi Line — Special solutions", sub: "Outward opening and profiles dedicated to wind-exposed high-rise buildings." },
      products: ["asas-maxi-majestic", "asas-maxi-empire"],
    },
  ],
  "pvc-scorrevole": [
    {
      id: "alzanti",
      it: { title: "Alzanti e grandi vetrate", sub: "L'anta si solleva o si chiude a pressione: tenuta superiore e vetrate fino a 3 metri, per soggiorni aperti su terrazze e giardini." },
      en: { title: "Lift-and-slide & large glazing", sub: "The sash lifts or closes under pressure: superior sealing and glazing up to 3 metres, for living rooms opening onto terraces and gardens." },
      products: ["asas-inova-sliding", "asas-hebe-schiebe"],
    },
    {
      id: "in-linea",
      it: { title: "Scorrevoli in linea", sub: "Le ante scorrono parallele al telaio senza ingombri: la soluzione pratica ed economica per balconi, verande e chiusure leggere." },
      en: { title: "Inline sliding", sub: "Sashes slide parallel to the frame without taking up space: the practical, affordable choice for balconies, verandas and light enclosures." },
      products: ["asas-sliding-74", "asas-sliding-70", "asas-compact-60"],
    },
  ],
};

export function groupedProductsInCategory(catSlug) {
  const groups = CATEGORY_GROUPS[catSlug];
  if (!groups) return null;
  return groups
    .map((g) => ({ ...g, items: g.products.map((s) => PRODUCTS[s]).filter(Boolean) }))
    .filter((g) => g.items.length > 0);
}

export const isRender = (src) =>
  typeof src === "string" && src.includes("/catalog2026/") && !/-amb\d*\./.test(src) && !src.includes("pvc-tile") && !src.includes("/schede/");

export function categoryTrail(slug) {
  const trail = [];
  let c = CATEGORIES[slug];
  while (c) { trail.unshift(c); c = CATEGORIES[c.parent]; }
  return trail;
}

export function getProductPills(product, lang = "it") {
  if (!product?.quickSpecs) return [];
  const q = product.quickSpecs;
  const L = lang === "en" ? {
    frame: "Frame", profile: "Profile", glass: "Glass", thermal: "Thermal break",
    passive: "Passive House", folding: "leaves", load: "kg/leaf",
    chambers: "chambers", gaskets: "gaskets",
    unitized: "Unitised", windowWall: "Window Wall", sunshade: "Sunshade",
    highInsulation: "High insulation",
  } : {
    frame: "Telaio", profile: "Profilo", glass: "Vetro", thermal: "Taglio termico",
    passive: "Passive House", folding: "ante", load: "kg/anta",
    chambers: "camere", gaskets: "guarnizioni",
    unitized: "Unitizzata", windowWall: "Window Wall", sunshade: "Frangisole",
    highInsulation: "Alto isolamento",
  };
  const pills = [];
  if (q.frame) pills.push({ label: `${L.frame} ${q.frame} mm` });
  if (q.profile) pills.push({ label: `${L.profile} ${q.profile} mm` });
  if (q.glass) pills.push({ label: `${L.glass} ${q.glass} mm` });
  if (q.thermal) pills.push({ label: `${L.thermal} ${lang === "en" ? q.thermal : String(q.thermal).replace(".", ",")} mm` });
  if (q.chambers) pills.push({ label: `${q.chambers} ${L.chambers}` });
  if (q.gaskets) pills.push({ label: `${q.gaskets} ${L.gaskets}` });
  if (q.mullion) pills.push({ label: `${L.frame} ${q.mullion} mm` });
  if (q.folding) pills.push({ label: `${q.folding} ${L.folding}` });
  if (q.load) pills.push({ label: `${q.load} ${L.load}` });
  if (q.profileMin && q.profileMax) pills.push({ label: `${L.profile} ${q.profileMin}–${q.profileMax} mm` });
  if (q.passive) pills.push({ label: L.passive, highlight: true });
  if (q.highInsulation) pills.push({ label: L.highInsulation, highlight: true });
  if (q.unitized) pills.push({ label: L.unitized, highlight: true });
  if (q.windowWall) pills.push({ label: L.windowWall, highlight: true });
  if (q.sunshade) pills.push({ label: L.sunshade, highlight: true });
  return pills;
}
